// prettier-ignore
/* eslint-disable @typescript-eslint/no-empty-interface */
const topLevelFieldsInputTypes = {
  queries: {
    v13pTaxProviderGlobalSettings: {
      input: 'OpenapiGetV13pTaxProviderGlobalSettingsInput',
    },
    v1Account: {
      input: 'OpenapiGetV1AccountInput',
    },
    v1AccountCapabilitiesCapability: {
      input: 'OpenapiGetV1AccountCapabilitiesCapabilityInput',
    },
    v1AccountEmailSettingsFetchAccountEmailSetting: {
      input: 'OpenapiGetV1AccountEmailSettingsFetchAccountEmailSettingInput',
    },
    v1AccountEmailSettingsListAccountEmailSettings: {
      input: 'OpenapiGetV1AccountEmailSettingsListAccountEmailSettingsInput',
    },
    v1AccountingAuditDetailSourceObjectId: {
      input: 'OpenapiGetV1AccountingAuditDetailSourceObjectIdInput',
    },
    v1AccountingJournalSummarizerConfig: {
      input: 'OpenapiGetV1AccountingJournalSummarizerConfigInput',
    },
    v1AccountingJournalSummarizerDownload: {
      input: 'OpenapiGetV1AccountingJournalSummarizerDownloadInput',
    },
    v1AccountingJournalSummarizerGet: {
      input: 'OpenapiGetV1AccountingJournalSummarizerGetInput',
    },
    v1AccountingJournalSummarizerList: {
      input: 'OpenapiGetV1AccountingJournalSummarizerListInput',
    },
    v1AccountingMonthlyWaterfallV2SourceObjectId: {
      input: 'OpenapiGetV1AccountingMonthlyWaterfallV2SourceObjectIdInput',
    },
    v1AccountPersons: {
      input: 'OpenapiGetV1AccountPersonsInput',
    },
    v1AccountRequirements: {
      input: 'OpenapiGetV1AccountRequirementsInput',
    },
    v1AccountsAccount: {
      input: 'OpenapiGetV1AccountsAccountInput',
    },
    v1AccountsAccountCapabilities: {
      input: 'OpenapiGetV1AccountsAccountCapabilitiesInput',
    },
    v1AccountsAccountCapabilitiesCapability: {
      input: 'OpenapiGetV1AccountsAccountCapabilitiesCapabilityInput',
    },
    v1AccountsAccountExternalAccounts: {
      input: 'OpenapiGetV1AccountsAccountExternalAccountsInput',
    },
    v1AccountsAccountExternalAccountsId: {
      input: 'OpenapiGetV1AccountsAccountExternalAccountsIdInput',
    },
    v1AccountsAccountInvoiceTaxInfoSettings: {
      input: 'OpenapiGetV1AccountsAccountInvoiceTaxInfoSettingsInput',
    },
    v1AccountsAccountPersons: {
      input: 'OpenapiGetV1AccountsAccountPersonsInput',
    },
    v1AccountsAccountPersonsPerson: {
      input: 'OpenapiGetV1AccountsAccountPersonsPersonInput',
    },
    v1AccountStatusTaskId: {
      input: 'OpenapiGetV1AccountStatusTaskIdInput',
    },
    v1AccountSuggestions: {
      input: 'OpenapiGetV1AccountSuggestionsInput',
    },
    v1AdaptivePricingDirectConfig: {
      input: 'OpenapiGetV1AdaptivePricingDirectConfigInput',
    },
    v1AdaptivePricingSubaccountConfigs: {
      input: 'OpenapiGetV1AdaptivePricingSubaccountConfigsInput',
    },
    v1AdaptivePricingTemplateConfig: {
      input: 'OpenapiGetV1AdaptivePricingTemplateConfigInput',
    },
    v1AddressReferenceCountryZipCode: {
      input: 'OpenapiGetV1AddressReferenceCountryZipCodeInput',
    },
    v1AgenticCommerceChannels: {
      input: 'OpenapiGetV1AgenticCommerceChannelsInput',
    },
    v1AgenticCommerceSellerConfig: {
      input: 'OpenapiGetV1AgenticCommerceSellerConfigInput',
    },
    v1AgenticCommerceSellers: {
      input: 'OpenapiGetV1AgenticCommerceSellersInput',
    },
    v1AgenticCommerceTurnkeySellerOnboardingSteps: {
      input: 'OpenapiGetV1AgenticCommerceTurnkeySellerOnboardingStepsInput',
    },
    v1AjaxPaymentMethodConfigurations: {
      input: 'OpenapiGetV1AjaxPaymentMethodConfigurationsInput',
    },
    v1AllCurrenciesFilter: {
      input: 'OpenapiGetV1AllCurrenciesFilterInput',
    },
    v1ApplePayDomains: {
      input: 'OpenapiGetV1ApplePayDomainsInput',
    },
    v1ApplicationFees: {
      input: 'OpenapiGetV1ApplicationFeesInput',
    },
    v1ApplicationFeesId: {
      input: 'OpenapiGetV1ApplicationFeesIdInput',
    },
    v1Applications: {
      input: 'OpenapiGetV1ApplicationsInput',
    },
    v1ApplicationsApplicationToken: {
      input: 'OpenapiGetV1ApplicationsApplicationTokenInput',
    },
    v1ApplicationsLatest: {
      input: 'OpenapiGetV1ApplicationsLatestInput',
    },
    v1AppLinksLinkId: {
      input: 'OpenapiGetV1AppLinksLinkIdInput',
    },
    v1AppMarketplaceDevDashboardRecommendedApps: {
      input: 'OpenapiGetV1AppMarketplaceDevDashboardRecommendedAppsInput',
    },
    v1ApprovalsApprovalRequestsDetailsId: {
      input: 'OpenapiGetV1ApprovalsApprovalRequestsDetailsIdInput',
    },
    v1ApprovalsApprovalRequestsId: {
      input: 'OpenapiGetV1ApprovalsApprovalRequestsIdInput',
    },
    v1ApprovalsApprovalRulesId: {
      input: 'OpenapiGetV1ApprovalsApprovalRulesIdInput',
    },
    v1ApprovalsApprovers: {
      input: 'OpenapiGetV1ApprovalsApproversInput',
    },
    v1ApprovalsListApprovalRequests: {
      input: 'OpenapiGetV1ApprovalsListApprovalRequestsInput',
    },
    v1ApprovalsListApprovalRules: {
      input: 'OpenapiGetV1ApprovalsListApprovalRulesInput',
    },
    v1ApprovalsListApprovalRulesAction: {
      input: 'OpenapiGetV1ApprovalsListApprovalRulesActionInput',
    },
    v1Apps: {
      input: 'OpenapiGetV1AppsInput',
    },
    v1AppsAppConnection: {
      input: 'OpenapiGetV1AppsAppConnectionInput',
    },
    v1AppsAppIdChannels: {
      input: 'OpenapiGetV1AppsAppIdChannelsInput',
    },
    v1AppsAppIdDynamicClientApplications: {
      input: 'OpenapiGetV1AppsAppIdDynamicClientApplicationsInput',
    },
    v1AppsAppIdEligibilityForDistributionType: {
      input: 'OpenapiGetV1AppsAppIdEligibilityForDistributionTypeInput',
    },
    v1AppsAppIdInstalls: {
      input: 'OpenapiGetV1AppsAppIdInstallsInput',
    },
    v1AppsInquiries: {
      input: 'OpenapiGetV1AppsInquiriesInput',
    },
    v1AppsInstallEligibility: {
      input: 'OpenapiGetV1AppsInstallEligibilityInput',
    },
    v1AppsInstallsId: {
      input: 'OpenapiGetV1AppsInstallsIdInput',
    },
    v1AppsSecrets: {
      input: 'OpenapiGetV1AppsSecretsInput',
    },
    v1AtlasAlternativeNames: {
      input: 'OpenapiGetV1AtlasAlternativeNamesInput',
    },
    v1AtlasFundraisingBoardConsents: {
      input: 'OpenapiGetV1AtlasFundraisingBoardConsentsInput',
    },
    v1AtlasPartners: {
      input: 'OpenapiGetV1AtlasPartnersInput',
    },
    v1AtlasSafes: {
      input: 'OpenapiGetV1AtlasSafesInput',
    },
    v1AtlasTimelineEstimatesAndCompletionDates: {
      input: 'OpenapiGetV1AtlasTimelineEstimatesAndCompletionDatesInput',
    },
    v1AutomationsRunsId: {
      input: 'OpenapiGetV1AutomationsRunsIdInput',
    },
    v1AutomationsVersionId: {
      input: 'OpenapiGetV1AutomationsVersionIdInput',
    },
    v1AvailableBalancesForCurrencyConversion: {
      input: 'OpenapiGetV1AvailableBalancesForCurrencyConversionInput',
    },
    v1AvailablePaymentMethodsAndSources: {
      input: 'OpenapiGetV1AvailablePaymentMethodsAndSourcesInput',
    },
    v1Balance: {
      input: 'OpenapiGetV1BalanceInput',
    },
    v1BalanceEod: {
      input: 'OpenapiGetV1BalanceEodInput',
    },
    v1BalancePendingCurrency: {
      input: 'OpenapiGetV1BalancePendingCurrencyInput',
    },
    v1BalanceSettings: {
      input: 'OpenapiGetV1BalanceSettingsInput',
    },
    v1BalanceSummary: {
      input: 'OpenapiGetV1BalanceSummaryInput',
    },
    v1BalanceTransactions: {
      input: 'OpenapiGetV1BalanceTransactionsInput',
    },
    v1BalanceTransactionsId: {
      input: 'OpenapiGetV1BalanceTransactionsIdInput',
    },
    v1BalanceTransfers: {
      input: 'OpenapiGetV1BalanceTransfersInput',
    },
    v1BalanceTransfersBalances: {
      input: 'OpenapiGetV1BalanceTransfersBalancesInput',
    },
    v1BalanceTransfersBalanceTransfer: {
      input: 'OpenapiGetV1BalanceTransfersBalanceTransferInput',
    },
    v1BankingOverrideableFeatureRestrictions: {
      input: 'OpenapiGetV1BankingOverrideableFeatureRestrictionsInput',
    },
    v1BankingPrivateAccountsFinancialAccountInstructionsPdf: {
      input: 'OpenapiGetV1BankingPrivateAccountsFinancialAccountInstructionsPdfInput',
    },
    v1BankingPrivateAccountsFinancialAccountStatements: {
      input: 'OpenapiGetV1BankingPrivateAccountsFinancialAccountStatementsInput',
    },
    v1BankingPrivatePlatformTransactionVolume: {
      input: 'OpenapiGetV1BankingPrivatePlatformTransactionVolumeInput',
    },
    v1BankSuggest: {
      input: 'OpenapiGetV1BankSuggestInput',
    },
    v1BillingAlerts: {
      input: 'OpenapiGetV1BillingAlertsInput',
    },
    v1BillingAlertsId: {
      input: 'OpenapiGetV1BillingAlertsIdInput',
    },
    v1BillingCreditBalanceSummary: {
      input: 'OpenapiGetV1BillingCreditBalanceSummaryInput',
    },
    v1BillingCreditBalanceTransactions: {
      input: 'OpenapiGetV1BillingCreditBalanceTransactionsInput',
    },
    v1BillingCreditGrants: {
      input: 'OpenapiGetV1BillingCreditGrantsInput',
    },
    v1BillingCreditGrantsId: {
      input: 'OpenapiGetV1BillingCreditGrantsIdInput',
    },
    v1BillingFeedbackOptions: {
      input: 'OpenapiGetV1BillingFeedbackOptionsInput',
    },
    v1BillingMerchantTags: {
      input: 'OpenapiGetV1BillingMerchantTagsInput',
    },
    v1BillingMeterEvents: {
      input: 'OpenapiGetV1BillingMeterEventsInput',
    },
    v1BillingMeterMerchantSettings: {
      input: 'OpenapiGetV1BillingMeterMerchantSettingsInput',
    },
    v1BillingMeterRatedUsageMetadata: {
      input: 'OpenapiGetV1BillingMeterRatedUsageMetadataInput',
    },
    v1BillingMeters: {
      input: 'OpenapiGetV1BillingMetersInput',
    },
    v1BillingMetersId: {
      input: 'OpenapiGetV1BillingMetersIdInput',
    },
    v1BillingOverviewMerchantSettingsVersion: {
      input: 'OpenapiGetV1BillingOverviewMerchantSettingsVersionInput',
    },
    v1BillingOverviewUbbMerchantSettings: {
      input: 'OpenapiGetV1BillingOverviewUbbMerchantSettingsInput',
    },
    v1BillingPaymentMethodConfiguration: {
      input: 'OpenapiGetV1BillingPaymentMethodConfigurationInput',
    },
    v1BillingPolicyType: {
      input: 'OpenapiGetV1BillingPolicyTypeInput',
    },
    v1BillingPortalConfigurations: {
      input: 'OpenapiGetV1BillingPortalConfigurationsInput',
    },
    v1BillingPortalRefundPolicies: {
      input: 'OpenapiGetV1BillingPortalRefundPoliciesInput',
    },
    v1BillingPortalRefundPoliciesPrice: {
      input: 'OpenapiGetV1BillingPortalRefundPoliciesPriceInput',
    },
    v1BillingPortalRetentionFlows: {
      input: 'OpenapiGetV1BillingPortalRetentionFlowsInput',
    },
    v1BillingPortalSessionsSession: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionInput',
    },
    v1BillingPortalSessionsSessionCustomer: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionCustomerInput',
    },
    v1BillingPortalSessionsSessionCustomerRecovery: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionCustomerRecoveryInput',
    },
    v1BillingPortalSessionsSessionExpCreditGrantBalance: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionExpCreditGrantBalanceInput',
    },
    v1BillingPortalSessionsSessionExpCreditHistory: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionExpCreditHistoryInput',
    },
    v1BillingPortalSessionsSessionExpCreditNotesCreditNoteLines: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionExpCreditNotesCreditNoteLinesInput',
    },
    v1BillingPortalSessionsSessionExpInvoicesInvoiceCreditNotes: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionExpInvoicesInvoiceCreditNotesInput',
    },
    v1BillingPortalSessionsSessionExpInvoicesInvoiceLines: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionExpInvoicesInvoiceLinesInput',
    },
    v1BillingPortalSessionsSessionExpMeterUsage: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionExpMeterUsageInput',
    },
    v1BillingPortalSessionsSessionExpSubscriptions: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionExpSubscriptionsInput',
    },
    v1BillingPortalSessionsSessionExpSubscriptionsSubscription: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionExpSubscriptionsSubscriptionInput',
    },
    v1BillingPortalSessionsSessionExpSubscriptionSubscriptionPreviewCancel: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionExpSubscriptionSubscriptionPreviewCancelInput',
    },
    v1BillingPortalSessionsSessionExpSubscriptionSubscriptionPreviewUpdate: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionExpSubscriptionSubscriptionPreviewUpdateInput',
    },
    v1BillingPortalSessionsSessionExpSubscriptionSubscriptionUpdate: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionExpSubscriptionSubscriptionUpdateInput',
    },
    v1BillingPortalSessionsSessionExpSubscriptionSubscriptionUpdatePaymentMethod: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionExpSubscriptionSubscriptionUpdatePaymentMethodInput',
    },
    v1BillingPortalSessionsSessionExpSubscriptionSubscriptionUpdatePreview: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionExpSubscriptionSubscriptionUpdatePreviewInput',
    },
    v1BillingPortalSessionsSessionExpSubscriptionSubscriptionUpdateTiers: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionExpSubscriptionSubscriptionUpdateTiersInput',
    },
    v1BillingPortalSessionsSessionExpUsageAnalytics: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionExpUsageAnalyticsInput',
    },
    v1BillingPortalSessionsSessionInvoiceRecovery: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionInvoiceRecoveryInput',
    },
    v1BillingPortalSessionsSessionInvoices: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionInvoicesInput',
    },
    v1BillingPortalSessionsSessionInvoicesSearch: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionInvoicesSearchInput',
    },
    v1BillingPortalSessionsSessionLinkPaymentMethodPaymentMethod: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionLinkPaymentMethodPaymentMethodInput',
    },
    v1BillingPortalSessionsSessionPaymentMethods: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionPaymentMethodsInput',
    },
    v1BillingPortalSessionsSessionPaymentMethodsPaymentMethod: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionPaymentMethodsPaymentMethodInput',
    },
    v1BillingPortalSessionsSessionPricingPlanSubscriptions: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionPricingPlanSubscriptionsInput',
    },
    v1BillingPortalSessionsSessionPricingPlanSubscriptionsPricingPlanSubscriptionId: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionPricingPlanSubscriptionsPricingPlanSubscriptionIdInput',
    },
    v1BillingPortalSessionsSessionSubscriptions: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionSubscriptionsInput',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscription: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionSubscriptionsSubscriptionInput',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionCheckRefundEligibility: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionSubscriptionsSubscriptionCheckRefundEligibilityInput',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionRetentionCoupon: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionSubscriptionsSubscriptionRetentionCouponInput',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionRetentionFlowCoupon: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionSubscriptionsSubscriptionRetentionFlowCouponInput',
    },
    v1BillingPortalSessionsSessionSubscriptionUpdatePaymentMethodLink: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionSubscriptionUpdatePaymentMethodLinkInput',
    },
    v1BillingPortalSessionsSessionUpdatePreview: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionUpdatePreviewInput',
    },
    v1BillingPortalSessionsSessionValidatePromotionCode: {
      input: 'OpenapiGetV1BillingPortalSessionsSessionValidatePromotionCodeInput',
    },
    v1BulkOnboardingExternalAccountsForLeAndMerchants: {
      input: 'OpenapiGetV1BulkOnboardingExternalAccountsForLeAndMerchantsInput',
    },
    v1BulkOnboardingGetAccountsForBulkOnboardingMerchants: {
      input: 'OpenapiGetV1BulkOnboardingGetAccountsForBulkOnboardingMerchantsInput',
    },
    v1BulkOnboardingLegalEntitiesAccessibleForUserAndMerchants: {
      input: 'OpenapiGetV1BulkOnboardingLegalEntitiesAccessibleForUserAndMerchantsInput',
    },
    v1BuyButtonsForPlink: {
      input: 'OpenapiGetV1BuyButtonsForPlinkInput',
    },
    v1CapitalActionRequired: {
      input: 'OpenapiGetV1CapitalActionRequiredInput',
    },
    v1CapitalActiveOnlineThirdPartyIntegrations: {
      input: 'OpenapiGetV1CapitalActiveOnlineThirdPartyIntegrationsInput',
    },
    v1CapitalAdditionalUnderwritingRequest: {
      input: 'OpenapiGetV1CapitalAdditionalUnderwritingRequestInput',
    },
    v1CapitalAdditionalUnderwritingRequests: {
      input: 'OpenapiGetV1CapitalAdditionalUnderwritingRequestsInput',
    },
    v1CapitalBankAccounts: {
      input: 'OpenapiGetV1CapitalBankAccountsInput',
    },
    v1CapitalConnectContract: {
      input: 'OpenapiGetV1CapitalConnectContractInput',
    },
    v1CapitalConnectPartnerPrograms: {
      input: 'OpenapiGetV1CapitalConnectPartnerProgramsInput',
    },
    v1CapitalDualMerchantFinancings: {
      input: 'OpenapiGetV1CapitalDualMerchantFinancingsInput',
    },
    v1CapitalDualMerchantFinancingsDualMerchantFinancing: {
      input: 'OpenapiGetV1CapitalDualMerchantFinancingsDualMerchantFinancingInput',
    },
    v1CapitalFinancingAccepted: {
      input: 'OpenapiGetV1CapitalFinancingAcceptedInput',
    },
    v1CapitalFinancingBalanceFinancingOffer: {
      input: 'OpenapiGetV1CapitalFinancingBalanceFinancingOfferInput',
    },
    v1CapitalFinancingMultiDrawFinancingLine: {
      input: 'OpenapiGetV1CapitalFinancingMultiDrawFinancingLineInput',
    },
    v1CapitalFinancingMultiDrawFinancingLines: {
      input: 'OpenapiGetV1CapitalFinancingMultiDrawFinancingLinesInput',
    },
    v1CapitalFinancingOfferCounts: {
      input: 'OpenapiGetV1CapitalFinancingOfferCountsInput',
    },
    v1CapitalFinancingOfferSneakPeek: {
      input: 'OpenapiGetV1CapitalFinancingOfferSneakPeekInput',
    },
    v1CapitalFinancingOffersOnDemand: {
      input: 'OpenapiGetV1CapitalFinancingOffersOnDemandInput',
    },
    v1CapitalFinancingOfferUpsell: {
      input: 'OpenapiGetV1CapitalFinancingOfferUpsellInput',
    },
    v1CapitalImports: {
      input: 'OpenapiGetV1CapitalImportsInput',
    },
    v1CapitalImportsImportBundle: {
      input: 'OpenapiGetV1CapitalImportsImportBundleInput',
    },
    v1CapitalLendingNetworkCreatePartnerApplicationWorkflowStatus: {
      input: 'OpenapiGetV1CapitalLendingNetworkCreatePartnerApplicationWorkflowStatusInput',
    },
    v1CapitalMerchantRevenue: {
      input: 'OpenapiGetV1CapitalMerchantRevenueInput',
    },
    v1CapitalMerchantSettings: {
      input: 'OpenapiGetV1CapitalMerchantSettingsInput',
    },
    v1CapitalNoOfferPotentialOfferSize: {
      input: 'OpenapiGetV1CapitalNoOfferPotentialOfferSizeInput',
    },
    v1CapitalOfferApplicationsOfferApplication: {
      input: 'OpenapiGetV1CapitalOfferApplicationsOfferApplicationInput',
    },
    v1CapitalOffers: {
      input: 'OpenapiGetV1CapitalOffersInput',
    },
    v1CapitalOffersOffer: {
      input: 'OpenapiGetV1CapitalOffersOfferInput',
    },
    v1CapitalOffersOfferCalculations: {
      input: 'OpenapiGetV1CapitalOffersOfferCalculationsInput',
    },
    v1CapitalPlatformPortfolioUnderwritingTimeSeries: {
      input: 'OpenapiGetV1CapitalPlatformPortfolioUnderwritingTimeSeriesInput',
    },
    v1CapitalPlatformsMerchantSettings: {
      input: 'OpenapiGetV1CapitalPlatformsMerchantSettingsInput',
    },
    v1CapitalPlatformsMerchantSettingsMerchant: {
      input: 'OpenapiGetV1CapitalPlatformsMerchantSettingsMerchantInput',
    },
    v1CapitalPlatformsPlaygroundSettings: {
      input: 'OpenapiGetV1CapitalPlatformsPlaygroundSettingsInput',
    },
    v1CapitalSbfeConsent: {
      input: 'OpenapiGetV1CapitalSbfeConsentInput',
    },
    v1CapitalYouLendAcceptanceWorkflow: {
      input: 'OpenapiGetV1CapitalYouLendAcceptanceWorkflowInput',
    },
    v1CapitalYouLendEligibleSigners: {
      input: 'OpenapiGetV1CapitalYouLendEligibleSignersInput',
    },
    v1CapitalYouLendRepayment: {
      input: 'OpenapiGetV1CapitalYouLendRepaymentInput',
    },
    v1CashAdvances: {
      input: 'OpenapiGetV1CashAdvancesInput',
    },
    v1CashAdvancesCashAdvance: {
      input: 'OpenapiGetV1CashAdvancesCashAdvanceInput',
    },
    v1Charges: {
      input: 'OpenapiGetV1ChargesInput',
    },
    v1ChargesCharge: {
      input: 'OpenapiGetV1ChargesChargeInput',
    },
    v1CheckoutInspectDetails: {
      input: 'OpenapiGetV1CheckoutInspectDetailsInput',
    },
    v1CheckoutSessions: {
      input: 'OpenapiGetV1CheckoutSessionsInput',
    },
    v1CheckoutSessionsSession: {
      input: 'OpenapiGetV1CheckoutSessionsSessionInput',
    },
    v1CheckoutSessionsSessionLineItems: {
      input: 'OpenapiGetV1CheckoutSessionsSessionLineItemsInput',
    },
    v1ClimateAutogenDraftSettings: {
      input: 'OpenapiGetV1ClimateAutogenDraftSettingsInput',
    },
    v1ClimateAutogenLiveSettings: {
      input: 'OpenapiGetV1ClimateAutogenLiveSettingsInput',
    },
    v1ClimateBrandSettings: {
      input: 'OpenapiGetV1ClimateBrandSettingsInput',
    },
    v1ClimateCacheValues: {
      input: 'OpenapiGetV1ClimateCacheValuesInput',
    },
    v1ClimateConnectPlatformConfig: {
      input: 'OpenapiGetV1ClimateConnectPlatformConfigInput',
    },
    v1ClimateOrders: {
      input: 'OpenapiGetV1ClimateOrdersInput',
    },
    v1ClimateOrdersOrder: {
      input: 'OpenapiGetV1ClimateOrdersOrderInput',
    },
    v1ClimateOrderSummary: {
      input: 'OpenapiGetV1ClimateOrderSummaryInput',
    },
    v1ClimateProducts: {
      input: 'OpenapiGetV1ClimateProductsInput',
    },
    v1ClimateProductsProduct: {
      input: 'OpenapiGetV1ClimateProductsProductInput',
    },
    v1ClimateProgram: {
      input: 'OpenapiGetV1ClimateProgramInput',
    },
    v1ClimateSignupPricePoints: {
      input: 'OpenapiGetV1ClimateSignupPricePointsInput',
    },
    v1ClimateSignupState: {
      input: 'OpenapiGetV1ClimateSignupStateInput',
    },
    v1ClimateSuppliers: {
      input: 'OpenapiGetV1ClimateSuppliersInput',
    },
    v1ClimateSuppliersSupplier: {
      input: 'OpenapiGetV1ClimateSuppliersSupplierInput',
    },
    v1CommunicationChannels: {
      input: 'OpenapiGetV1CommunicationChannelsInput',
    },
    v1CommunicationManagementListEmailDestinations: {
      input: 'OpenapiGetV1CommunicationManagementListEmailDestinationsInput',
    },
    v1CommunicationManagementListSubscriptionRecipients: {
      input: 'OpenapiGetV1CommunicationManagementListSubscriptionRecipientsInput',
    },
    v1CommunicationPreferences: {
      input: 'OpenapiGetV1CommunicationPreferencesInput',
    },
    v1ConnectAccountGroups: {
      input: 'OpenapiGetV1ConnectAccountGroupsInput',
    },
    v1ConnectAccountGroupsCsvValidate: {
      input: 'OpenapiGetV1ConnectAccountGroupsCsvValidateInput',
    },
    v1ConnectAccountReadyToOnboard: {
      input: 'OpenapiGetV1ConnectAccountReadyToOnboardInput',
    },
    v1ConnectAccountsConnectedAccountDetails: {
      input: 'OpenapiGetV1ConnectAccountsConnectedAccountDetailsInput',
    },
    v1ConnectAccountsV2GetPlatformPublicPreviewState: {
      input: 'OpenapiGetV1ConnectAccountsV2GetPlatformPublicPreviewStateInput',
    },
    v1ConnectAccountsV2GetV2AccountsFasttrackState: {
      input: 'OpenapiGetV1ConnectAccountsV2GetV2AccountsFasttrackStateInput',
    },
    v1ConnectAgenticCommerceConfigSubaccountConfig: {
      input: 'OpenapiGetV1ConnectAgenticCommerceConfigSubaccountConfigInput',
    },
    v1ConnectAgenticCommerceConfigTemplateConfig: {
      input: 'OpenapiGetV1ConnectAgenticCommerceConfigTemplateConfigInput',
    },
    v1ConnectCommsCenterCsvSummaryStatus: {
      input: 'OpenapiGetV1ConnectCommsCenterCsvSummaryStatusInput',
    },
    v1ConnectCommsCenterEmailPreview: {
      input: 'OpenapiGetV1ConnectCommsCenterEmailPreviewInput',
    },
    v1ConnectCommsCenterPlatformCommunicationsTemplate: {
      input: 'OpenapiGetV1ConnectCommsCenterPlatformCommunicationsTemplateInput',
    },
    v1ConnectCommsCenterProductCommunicationSettings: {
      input: 'OpenapiGetV1ConnectCommsCenterProductCommunicationSettingsInput',
    },
    v1ConnectCommsCenterProductCommunicationSettingsAll: {
      input: 'OpenapiGetV1ConnectCommsCenterProductCommunicationSettingsAllInput',
    },
    v1ConnectCommsCenterProductCommunicationSettingsEmails: {
      input: 'OpenapiGetV1ConnectCommsCenterProductCommunicationSettingsEmailsInput',
    },
    v1ConnectCommsCenterSentEmail: {
      input: 'OpenapiGetV1ConnectCommsCenterSentEmailInput',
    },
    v1ConnectCommsCenterSentMessagesToConnectedAccount: {
      input: 'OpenapiGetV1ConnectCommsCenterSentMessagesToConnectedAccountInput',
    },
    v1ConnectCommsCenterUrls: {
      input: 'OpenapiGetV1ConnectCommsCenterUrlsInput',
    },
    v1ConnectConnectedAccountEligibleAdditionalVerifications: {
      input: 'OpenapiGetV1ConnectConnectedAccountEligibleAdditionalVerificationsInput',
    },
    v1ConnectConnectedAccountsListAggregations: {
      input: 'OpenapiGetV1ConnectConnectedAccountsListAggregationsInput',
    },
    v1ConnectDebitCardCountrySupported: {
      input: 'OpenapiGetV1ConnectDebitCardCountrySupportedInput',
    },
    v1ConnectEligibleForIdentityAuth: {
      input: 'OpenapiGetV1ConnectEligibleForIdentityAuthInput',
    },
    v1ConnectExternalAccountCollectionConfig: {
      input: 'OpenapiGetV1ConnectExternalAccountCollectionConfigInput',
    },
    v1ConnectFinancialAccounts: {
      input: 'OpenapiGetV1ConnectFinancialAccountsInput',
    },
    v1ConnectFinancingFinancingTransactions: {
      input: 'OpenapiGetV1ConnectFinancingFinancingTransactionsInput',
    },
    v1ConnectGrossSettlementConfig: {
      input: 'OpenapiGetV1ConnectGrossSettlementConfigInput',
    },
    v1ConnectIdentityChallengesAuthAttemptIdExternalAccountKey: {
      input: 'OpenapiGetV1ConnectIdentityChallengesAuthAttemptIdExternalAccountKeyInput',
    },
    v1ConnectInsightsDashboardConfiguration: {
      input: 'OpenapiGetV1ConnectInsightsDashboardConfigurationInput',
    },
    v1ConnectInsightsDashboardConfigurationForMerchant: {
      input: 'OpenapiGetV1ConnectInsightsDashboardConfigurationForMerchantInput',
    },
    v1ConnectInsightsQueryAggregatedCurrentUserTasks: {
      input: 'OpenapiGetV1ConnectInsightsQueryAggregatedCurrentUserTasksInput',
    },
    v1ConnectInsightsUpcomingUserTasksByMonthAggregation: {
      input: 'OpenapiGetV1ConnectInsightsUpcomingUserTasksByMonthAggregationInput',
    },
    v1ConnectInstantPayoutsConfig: {
      input: 'OpenapiGetV1ConnectInstantPayoutsConfigInput',
    },
    v1ConnectIntegrationPlatformAttestation: {
      input: 'OpenapiGetV1ConnectIntegrationPlatformAttestationInput',
    },
    v1ConnectInvitations: {
      input: 'OpenapiGetV1ConnectInvitationsInput',
    },
    v1ConnectionsAccounts: {
      input: 'OpenapiGetV1ConnectionsAccountsInput',
    },
    v1ConnectionsFeaturedInstitutions: {
      input: 'OpenapiGetV1ConnectionsFeaturedInstitutionsInput',
    },
    v1ConnectionsInstitutions: {
      input: 'OpenapiGetV1ConnectionsInstitutionsInput',
    },
    v1ConnectionsOffers: {
      input: 'OpenapiGetV1ConnectionsOffersInput',
    },
    v1ConnectLegalEntitiesAccessibleForUserAndMerchant: {
      input: 'OpenapiGetV1ConnectLegalEntitiesAccessibleForUserAndMerchantInput',
    },
    v1ConnectLegalEntitySharingAllowed: {
      input: 'OpenapiGetV1ConnectLegalEntitySharingAllowedInput',
    },
    v1ConnectNoCodeInstantPayoutsSubaccountConfigConnectedAccountId: {
      input: 'OpenapiGetV1ConnectNoCodeInstantPayoutsSubaccountConfigConnectedAccountIdInput',
    },
    v1ConnectNoCodeInstantPayoutsTemplateConfig: {
      input: 'OpenapiGetV1ConnectNoCodeInstantPayoutsTemplateConfigInput',
    },
    v1ConnectNoCodeMeetsInstantPayoutsEligibilityPnblConnectedAccountId: {
      input: 'OpenapiGetV1ConnectNoCodeMeetsInstantPayoutsEligibilityPnblConnectedAccountIdInput',
    },
    v1ConnectOnboardingConfig: {
      input: 'OpenapiGetV1ConnectOnboardingConfigInput',
    },
    v1ConnectPayoutMethodCollectionConfig: {
      input: 'OpenapiGetV1ConnectPayoutMethodCollectionConfigInput',
    },
    v1ConnectPayoutsInstantPayoutsPricing: {
      input: 'OpenapiGetV1ConnectPayoutsInstantPayoutsPricingInput',
    },
    v1ConnectPayoutsNoCodeInstantPayoutsInstantPayoutSupportedCountriesPnbl: {
      input: 'OpenapiGetV1ConnectPayoutsNoCodeInstantPayoutsInstantPayoutSupportedCountriesPnblInput',
    },
    v1ConnectPlatformCadDetails: {
      input: 'OpenapiGetV1ConnectPlatformCadDetailsInput',
    },
    v1ConnectPricingGroupsCustomizedPricingGroup: {
      input: 'OpenapiGetV1ConnectPricingGroupsCustomizedPricingGroupInput',
    },
    v1ConnectPricingGroupsSubaccountPricingGroup: {
      input: 'OpenapiGetV1ConnectPricingGroupsSubaccountPricingGroupInput',
    },
    v1ConnectPricingGroupsTemplates: {
      input: 'OpenapiGetV1ConnectPricingGroupsTemplatesInput',
    },
    v1ConnectRisk: {
      input: 'OpenapiGetV1ConnectRiskInput',
    },
    v1ConnectRiskAndComplianceSettings: {
      input: 'OpenapiGetV1ConnectRiskAndComplianceSettingsInput',
    },
    v1ConnectSession: {
      input: 'OpenapiGetV1ConnectSessionInput',
    },
    v1ConnectTaxReportingUsTaxFormRequestLatest: {
      input: 'OpenapiGetV1ConnectTaxReportingUsTaxFormRequestLatestInput',
    },
    v1ConnectUnderwritingRequests: {
      input: 'OpenapiGetV1ConnectUnderwritingRequestsInput',
    },
    v1ConnectUser: {
      input: 'OpenapiGetV1ConnectUserInput',
    },
    v1ConnectW8W9CollectionFullyKeyedInTaxId: {
      input: 'OpenapiGetV1ConnectW8W9CollectionFullyKeyedInTaxIdInput',
    },
    v1ConnectW8W9CollectionPdfConnectedAccountId: {
      input: 'OpenapiGetV1ConnectW8W9CollectionPdfConnectedAccountIdInput',
    },
    v1ConnectW8W9CollectionRomajiInfo: {
      input: 'OpenapiGetV1ConnectW8W9CollectionRomajiInfoInput',
    },
    v1ConnectW8W9CollectionW8Settings: {
      input: 'OpenapiGetV1ConnectW8W9CollectionW8SettingsInput',
    },
    v1ConnectW8W9CollectionW8W9PlatformConfig: {
      input: 'OpenapiGetV1ConnectW8W9CollectionW8W9PlatformConfigInput',
    },
    v1ConsoleConversations: {
      input: 'OpenapiGetV1ConsoleConversationsInput',
    },
    v1ConsoleConversationsConversationId: {
      input: 'OpenapiGetV1ConsoleConversationsConversationIdInput',
    },
    v1ConsoleMerchantContext: {
      input: 'OpenapiGetV1ConsoleMerchantContextInput',
    },
    v1ConsoleSkills: {
      input: 'OpenapiGetV1ConsoleSkillsInput',
    },
    v1ConsoleSkillsName: {
      input: 'OpenapiGetV1ConsoleSkillsNameInput',
    },
    v1ConsoleTaskId: {
      input: 'OpenapiGetV1ConsoleTaskIdInput',
    },
    v1ControlledContentBatchDisplayStatus: {
      input: 'OpenapiGetV1ControlledContentBatchDisplayStatusInput',
    },
    v1ControlledContentDisplayStatus: {
      input: 'OpenapiGetV1ControlledContentDisplayStatusInput',
    },
    v1ControlledContentSurfaceDisplayStatus: {
      input: 'OpenapiGetV1ControlledContentSurfaceDisplayStatusInput',
    },
    v1CountrySpecsCountry: {
      input: 'OpenapiGetV1CountrySpecsCountryInput',
    },
    v1Coupons: {
      input: 'OpenapiGetV1CouponsInput',
    },
    v1CouponsCoupon: {
      input: 'OpenapiGetV1CouponsCouponInput',
    },
    v1CreditNotes: {
      input: 'OpenapiGetV1CreditNotesInput',
    },
    v1CreditNotesCreditNoteLines: {
      input: 'OpenapiGetV1CreditNotesCreditNoteLinesInput',
    },
    v1CreditNotesPreview: {
      input: 'OpenapiGetV1CreditNotesPreviewInput',
    },
    v1CreditNotesPreviewLines: {
      input: 'OpenapiGetV1CreditNotesPreviewLinesInput',
    },
    v1CryptoInternalPayinSession: {
      input: 'OpenapiGetV1CryptoInternalPayinSessionInput',
    },
    v1CryptoInternalSetupSession: {
      input: 'OpenapiGetV1CryptoInternalSetupSessionInput',
    },
    v1CryptoInternalWalletBalances: {
      input: 'OpenapiGetV1CryptoInternalWalletBalancesInput',
    },
    v1CryptoPayoutsSupportedCryptoNetworks: {
      input: 'OpenapiGetV1CryptoPayoutsSupportedCryptoNetworksInput',
    },
    v1CurrencyConversionsConversion: {
      input: 'OpenapiGetV1CurrencyConversionsConversionInput',
    },
    v1CurrentMerchant: {
      input: 'OpenapiGetV1CurrentMerchantInput',
    },
    v1CustomDomainsTypeType: {
      input: 'OpenapiGetV1CustomDomainsTypeTypeInput',
    },
    v1CustomerCashBalanceCurrencyEnablementDetails: {
      input: 'OpenapiGetV1CustomerCashBalanceCurrencyEnablementDetailsInput',
    },
    v1CustomerCashBalanceEnabledCurrencies: {
      input: 'OpenapiGetV1CustomerCashBalanceEnabledCurrenciesInput',
    },
    v1Customers: {
      input: 'OpenapiGetV1CustomersInput',
    },
    v1CustomersBlockedBillingAddressCountries: {
      input: 'OpenapiGetV1CustomersBlockedBillingAddressCountriesInput',
    },
    v1CustomersCustomer: {
      input: 'OpenapiGetV1CustomersCustomerInput',
    },
    v1CustomersCustomerBalanceTransactions: {
      input: 'OpenapiGetV1CustomersCustomerBalanceTransactionsInput',
    },
    v1CustomersCustomerCashBalanceTransactions: {
      input: 'OpenapiGetV1CustomersCustomerCashBalanceTransactionsInput',
    },
    v1CustomersCustomerCashBalanceTransactionsTransaction: {
      input: 'OpenapiGetV1CustomersCustomerCashBalanceTransactionsTransactionInput',
    },
    v1CustomersCustomerFundingInstructions: {
      input: 'OpenapiGetV1CustomersCustomerFundingInstructionsInput',
    },
    v1CustomersCustomerPaymentMethodsPaymentMethod: {
      input: 'OpenapiGetV1CustomersCustomerPaymentMethodsPaymentMethodInput',
    },
    v1CustomersCustomerSources: {
      input: 'OpenapiGetV1CustomersCustomerSourcesInput',
    },
    v1CustomersCustomerVbanOwnershipLetter: {
      input: 'OpenapiGetV1CustomersCustomerVbanOwnershipLetterInput',
    },
    v1CustomerSegmentationSavedSegments: {
      input: 'OpenapiGetV1CustomerSegmentationSavedSegmentsInput',
    },
    v1CustomerSegmentationSavedSegmentsSavedSegment: {
      input: 'OpenapiGetV1CustomerSegmentationSavedSegmentsSavedSegmentInput',
    },
    v1CustomersSearch: {
      input: 'OpenapiGetV1CustomersSearchInput',
    },
    v1DashboardSearch: {
      input: 'OpenapiGetV1DashboardSearchInput',
    },
    v1DashboardSettingsBillingMode: {
      input: 'OpenapiGetV1DashboardSettingsBillingModeInput',
    },
    v1DashboardSettingsBillingNotifications: {
      input: 'OpenapiGetV1DashboardSettingsBillingNotificationsInput',
    },
    v1DashboardVolumeLimits: {
      input: 'OpenapiGetV1DashboardVolumeLimitsInput',
    },
    v1DashboardWidgetsId: {
      input: 'OpenapiGetV1DashboardWidgetsIdInput',
    },
    v1DataExplorerEditableGroups: {
      input: 'OpenapiGetV1DataExplorerEditableGroupsInput',
    },
    v1DataExplorerGroups: {
      input: 'OpenapiGetV1DataExplorerGroupsInput',
    },
    v1DataExplorerMetricsMetric: {
      input: 'OpenapiGetV1DataExplorerMetricsMetricInput',
    },
    v1DataManagementImportSetsId: {
      input: 'OpenapiGetV1DataManagementImportSetsIdInput',
    },
    v1DataStudioBillingCount: {
      input: 'OpenapiGetV1DataStudioBillingCountInput',
    },
    v1DataStudioTrialEligibility: {
      input: 'OpenapiGetV1DataStudioTrialEligibilityInput',
    },
    v1DisputeEvidenceSubmissionsSettings: {
      input: 'OpenapiGetV1DisputeEvidenceSubmissionsSettingsInput',
    },
    v1Disputes: {
      input: 'OpenapiGetV1DisputesInput',
    },
    v1DisputesDispute: {
      input: 'OpenapiGetV1DisputesDisputeInput',
    },
    v1DisputesInternalArbitrationSettings: {
      input: 'OpenapiGetV1DisputesInternalArbitrationSettingsInput',
    },
    v1DisputesInternalAutoRepresentmentDisputeFeePassthroughUsageFeeSummary: {
      input: 'OpenapiGetV1DisputesInternalAutoRepresentmentDisputeFeePassthroughUsageFeeSummaryInput',
    },
    v1DisputesInternalAutoRepresentmentGetMerchantConfiguration: {
      input: 'OpenapiGetV1DisputesInternalAutoRepresentmentGetMerchantConfigurationInput',
    },
    v1DisputesInternalAutoRepresentmentSettingDirectConfig: {
      input: 'OpenapiGetV1DisputesInternalAutoRepresentmentSettingDirectConfigInput',
    },
    v1DisputesInternalAutoRepresentmentSettingSubaccountConfigs: {
      input: 'OpenapiGetV1DisputesInternalAutoRepresentmentSettingSubaccountConfigsInput',
    },
    v1DisputesInternalAutoRepresentmentSettingTemplateConfig: {
      input: 'OpenapiGetV1DisputesInternalAutoRepresentmentSettingTemplateConfigInput',
    },
    v1DisputesInternalEnrichedDisputes: {
      input: 'OpenapiGetV1DisputesInternalEnrichedDisputesInput',
    },
    v1DisputesInternalEvidenceLibrary: {
      input: 'OpenapiGetV1DisputesInternalEvidenceLibraryInput',
    },
    v1DisputesInternalIssuerEvidence: {
      input: 'OpenapiGetV1DisputesInternalIssuerEvidenceInput',
    },
    v1DisputesInternalPreventionListMerchantSettings: {
      input: 'OpenapiGetV1DisputesInternalPreventionListMerchantSettingsInput',
    },
    v1DisputesInternalPreventionListPreventionEnrollments: {
      input: 'OpenapiGetV1DisputesInternalPreventionListPreventionEnrollmentsInput',
    },
    v1EarningsChart: {
      input: 'OpenapiGetV1EarningsChartInput',
    },
    v1EmbeddedPaymentDetailSummary: {
      input: 'OpenapiGetV1EmbeddedPaymentDetailSummaryInput',
    },
    v1EmbeddedTransactionsSummary: {
      input: 'OpenapiGetV1EmbeddedTransactionsSummaryInput',
    },
    v1EmeraldTransactions: {
      input: 'OpenapiGetV1EmeraldTransactionsInput',
    },
    v1EntitlementsActiveEntitlements: {
      input: 'OpenapiGetV1EntitlementsActiveEntitlementsInput',
    },
    v1EntitlementsFeatures: {
      input: 'OpenapiGetV1EntitlementsFeaturesInput',
    },
    v1EntitlementsFeaturesId: {
      input: 'OpenapiGetV1EntitlementsFeaturesIdInput',
    },
    v1Events: {
      input: 'OpenapiGetV1EventsInput',
    },
    v1EventsId: {
      input: 'OpenapiGetV1EventsIdInput',
    },
    v1ExperienceEngineNocodeModules: {
      input: 'OpenapiGetV1ExperienceEngineNocodeModulesInput',
    },
    v1ExportDetailsObject: {
      input: 'OpenapiGetV1ExportDetailsObjectInput',
    },
    v1ExportDownloadExportId: {
      input: 'OpenapiGetV1ExportDownloadExportIdInput',
    },
    v1ExportExportId: {
      input: 'OpenapiGetV1ExportExportIdInput',
    },
    v1FacilitatedCommercePermissionGrants: {
      input: 'OpenapiGetV1FacilitatedCommercePermissionGrantsInput',
    },
    v1FacilitatedCommerceProducts: {
      input: 'OpenapiGetV1FacilitatedCommerceProductsInput',
    },
    v1FacilitatedCommerceProductsSearch: {
      input: 'OpenapiGetV1FacilitatedCommerceProductsSearchInput',
    },
    v1FaEligibilityCheckResult: {
      input: 'OpenapiGetV1FaEligibilityCheckResultInput',
    },
    v1FeeCreditsGetCredit: {
      input: 'OpenapiGetV1FeeCreditsGetCreditInput',
    },
    v1FeeCreditsListCredits: {
      input: 'OpenapiGetV1FeeCreditsListCreditsInput',
    },
    v1FileLinksLink: {
      input: 'OpenapiGetV1FileLinksLinkInput',
    },
    v1Files: {
      input: 'OpenapiGetV1FilesInput',
    },
    v1FilesFile: {
      input: 'OpenapiGetV1FilesFileInput',
    },
    v1FinancialConnectionsAccounts: {
      input: 'OpenapiGetV1FinancialConnectionsAccountsInput',
    },
    v1FinancialConnectionsAccountsAccount: {
      input: 'OpenapiGetV1FinancialConnectionsAccountsAccountInput',
    },
    v1FinancialConnectionsAccountsAccountBalanceActivity: {
      input: 'OpenapiGetV1FinancialConnectionsAccountsAccountBalanceActivityInput',
    },
    v1FinancialConnectionsRefreshes: {
      input: 'OpenapiGetV1FinancialConnectionsRefreshesInput',
    },
    v1FinancialConnectionsSessions: {
      input: 'OpenapiGetV1FinancialConnectionsSessionsInput',
    },
    v1FinancialConnectionsSessionsSession: {
      input: 'OpenapiGetV1FinancialConnectionsSessionsSessionInput',
    },
    v1FinancialConnectionsSessionsSessionEvents: {
      input: 'OpenapiGetV1FinancialConnectionsSessionsSessionEventsInput',
    },
    v1FinancialPartnerPaymentAuthorizationsPaymentAuthorization: {
      input: 'OpenapiGetV1FinancialPartnerPaymentAuthorizationsPaymentAuthorizationInput',
    },
    v1FinancialReportingOrganizationAccountsCurrencies: {
      input: 'OpenapiGetV1FinancialReportingOrganizationAccountsCurrenciesInput',
    },
    v1FinancialReportingOrganizationAccountsMetadata: {
      input: 'OpenapiGetV1FinancialReportingOrganizationAccountsMetadataInput',
    },
    v1FinancialReportingOrgPlatformAggregations: {
      input: 'OpenapiGetV1FinancialReportingOrgPlatformAggregationsInput',
    },
    v1FinancingFinancingTransactions: {
      input: 'OpenapiGetV1FinancingFinancingTransactionsInput',
    },
    v1FinancingReviewsFinancingObject: {
      input: 'OpenapiGetV1FinancingReviewsFinancingObjectInput',
    },
    v1FinancingTransactionsFind: {
      input: 'OpenapiGetV1FinancingTransactionsFindInput',
    },
    v1FinancingTransactionTransaction: {
      input: 'OpenapiGetV1FinancingTransactionTransactionInput',
    },
    v1FlexLoans: {
      input: 'OpenapiGetV1FlexLoansInput',
    },
    v1FlexLoansFlexLoan: {
      input: 'OpenapiGetV1FlexLoansFlexLoanInput',
    },
    v1FlexLoansFlexLoanMinRepaymentWindows: {
      input: 'OpenapiGetV1FlexLoansFlexLoanMinRepaymentWindowsInput',
    },
    v1FlexLoansFlexLoanRetrieveAgreement: {
      input: 'OpenapiGetV1FlexLoansFlexLoanRetrieveAgreementInput',
    },
    v1FrMealVouchersSiretInfo: {
      input: 'OpenapiGetV1FrMealVouchersSiretInfoInput',
    },
    v1GetCompliancePdfPollToken: {
      input: 'OpenapiGetV1GetCompliancePdfPollTokenInput',
    },
    v1GiftCardsCards: {
      input: 'OpenapiGetV1GiftCardsCardsInput',
    },
    v1GiftCardsCardsId: {
      input: 'OpenapiGetV1GiftCardsCardsIdInput',
    },
    v1GiftCardsTransactions: {
      input: 'OpenapiGetV1GiftCardsTransactionsInput',
    },
    v1GuestCustomerForPayment: {
      input: 'OpenapiGetV1GuestCustomerForPaymentInput',
    },
    v1GuestCustomers: {
      input: 'OpenapiGetV1GuestCustomersInput',
    },
    v1GuestCustomersGuestCustomer: {
      input: 'OpenapiGetV1GuestCustomersGuestCustomerInput',
    },
    v1IamRoleAssignmentsPrincipal: {
      input: 'OpenapiGetV1IamRoleAssignmentsPrincipalInput',
    },
    v1IdentityVerificationReports: {
      input: 'OpenapiGetV1IdentityVerificationReportsInput',
    },
    v1IdentityVerificationSessions: {
      input: 'OpenapiGetV1IdentityVerificationSessionsInput',
    },
    v1IdentityVerificationSessionsSession: {
      input: 'OpenapiGetV1IdentityVerificationSessionsSessionInput',
    },
    v1IdentityVerificationTemplates: {
      input: 'OpenapiGetV1IdentityVerificationTemplatesInput',
    },
    v1IdentityVerificationTemplatesTemplate: {
      input: 'OpenapiGetV1IdentityVerificationTemplatesTemplateInput',
    },
    v1InternalRubyReadFirst: {
      input: 'OpenapiGetV1InternalRubyReadFirstInput',
    },
    v1Inventories: {
      input: 'OpenapiGetV1InventoriesInput',
    },
    v1InventoriesId: {
      input: 'OpenapiGetV1InventoriesIdInput',
    },
    v1InviteATeammateInvites: {
      input: 'OpenapiGetV1InviteATeammateInvitesInput',
    },
    v1InvoiceChallengesSiteKey: {
      input: 'OpenapiGetV1InvoiceChallengesSiteKeyInput',
    },
    v1Invoiceitems: {
      input: 'OpenapiGetV1InvoiceitemsInput',
    },
    v1InvoiceitemsInvoiceitem: {
      input: 'OpenapiGetV1InvoiceitemsInvoiceitemInput',
    },
    v1InvoicePayments: {
      input: 'OpenapiGetV1InvoicePaymentsInput',
    },
    v1InvoiceRenderingTemplates: {
      input: 'OpenapiGetV1InvoiceRenderingTemplatesInput',
    },
    v1InvoiceRenderingTemplatesTemplate: {
      input: 'OpenapiGetV1InvoiceRenderingTemplatesTemplateInput',
    },
    v1Invoices: {
      input: 'OpenapiGetV1InvoicesInput',
    },
    v1InvoicesInvoice: {
      input: 'OpenapiGetV1InvoicesInvoiceInput',
    },
    v1InvoicesInvoiceEmailSubjectData: {
      input: 'OpenapiGetV1InvoicesInvoiceEmailSubjectDataInput',
    },
    v1InvoicesInvoiceLines: {
      input: 'OpenapiGetV1InvoicesInvoiceLinesInput',
    },
    v1InvoicesInvoicePayments: {
      input: 'OpenapiGetV1InvoicesInvoicePaymentsInput',
    },
    v1InvoicesInvoiceRevisions: {
      input: 'OpenapiGetV1InvoicesInvoiceRevisionsInput',
    },
    v1InvoicesInvoiceSummaryItems: {
      input: 'OpenapiGetV1InvoicesInvoiceSummaryItemsInput',
    },
    v1InvoicesPreview: {
      input: 'OpenapiGetV1InvoicesPreviewInput',
    },
    v1InvoicesUpcoming: {
      input: 'OpenapiGetV1InvoicesUpcomingInput',
    },
    v1InvoicesUpcomingLines: {
      input: 'OpenapiGetV1InvoicesUpcomingLinesInput',
    },
    v1IpGeocode: {
      input: 'OpenapiGetV1IpGeocodeInput',
    },
    v1IssuingAccountSettingFlags: {
      input: 'OpenapiGetV1IssuingAccountSettingFlagsInput',
    },
    v1IssuingAftenrollmentPricingstatus: {
      input: 'OpenapiGetV1IssuingAftenrollmentPricingstatusInput',
    },
    v1IssuingAftenrollmentUserconfig: {
      input: 'OpenapiGetV1IssuingAftenrollmentUserconfigInput',
    },
    v1IssuingAuthorizations: {
      input: 'OpenapiGetV1IssuingAuthorizationsInput',
    },
    v1IssuingAuthorizationsAuthorization: {
      input: 'OpenapiGetV1IssuingAuthorizationsAuthorizationInput',
    },
    v1IssuingCardholders: {
      input: 'OpenapiGetV1IssuingCardholdersInput',
    },
    v1IssuingCardholdersCardholder: {
      input: 'OpenapiGetV1IssuingCardholdersCardholderInput',
    },
    v1IssuingCards: {
      input: 'OpenapiGetV1IssuingCardsInput',
    },
    v1IssuingCardsCard: {
      input: 'OpenapiGetV1IssuingCardsCardInput',
    },
    v1IssuingDisputes: {
      input: 'OpenapiGetV1IssuingDisputesInput',
    },
    v1IssuingDisputesDispute: {
      input: 'OpenapiGetV1IssuingDisputesDisputeInput',
    },
    v1IssuingEmbeddedFlags: {
      input: 'OpenapiGetV1IssuingEmbeddedFlagsInput',
    },
    v1IssuingLiveModeTrialControls: {
      input: 'OpenapiGetV1IssuingLiveModeTrialControlsInput',
    },
    v1IssuingPersonalizationDesigns: {
      input: 'OpenapiGetV1IssuingPersonalizationDesignsInput',
    },
    v1IssuingPersonalizationDesignsPersonalizationDesign: {
      input: 'OpenapiGetV1IssuingPersonalizationDesignsPersonalizationDesignInput',
    },
    v1IssuingPhysicalBundles: {
      input: 'OpenapiGetV1IssuingPhysicalBundlesInput',
    },
    v1IssuingPhysicalBundlesPhysicalBundle: {
      input: 'OpenapiGetV1IssuingPhysicalBundlesPhysicalBundleInput',
    },
    v1IssuingPrograms: {
      input: 'OpenapiGetV1IssuingProgramsInput',
    },
    v1IssuingProgramsList: {
      input: 'OpenapiGetV1IssuingProgramsListInput',
    },
    v1IssuingProgramsProgram: {
      input: 'OpenapiGetV1IssuingProgramsProgramInput',
    },
    v1IssuingProgramsRetrieveProgram: {
      input: 'OpenapiGetV1IssuingProgramsRetrieveProgramInput',
    },
    v1IssuingReceipts: {
      input: 'OpenapiGetV1IssuingReceiptsInput',
    },
    v1IssuingReceiptsReceipt: {
      input: 'OpenapiGetV1IssuingReceiptsReceiptInput',
    },
    v1IssuingRulebacktest: {
      input: 'OpenapiGetV1IssuingRulebacktestInput',
    },
    v1IssuingTransactions: {
      input: 'OpenapiGetV1IssuingTransactionsInput',
    },
    v1IssuingTransactionsTransaction: {
      input: 'OpenapiGetV1IssuingTransactionsTransactionInput',
    },
    v1IsUrlOptOutMerchant: {
      input: 'OpenapiGetV1IsUrlOptOutMerchantInput',
    },
    v1JapanAddressSuggest: {
      input: 'OpenapiGetV1JapanAddressSuggestInput',
    },
    v1ListLegacyChargesSearch: {
      input: 'OpenapiGetV1ListLegacyChargesSearchInput',
    },
    v1LiveModeTrial: {
      input: 'OpenapiGetV1LiveModeTrialInput',
    },
    v1LpmAdoptionPaymentMethodRecommendedBuyerCountries: {
      input: 'OpenapiGetV1LpmAdoptionPaymentMethodRecommendedBuyerCountriesInput',
    },
    v1LpmDashboardSettingsFinancingPackageDetailsAffirm: {
      input: 'OpenapiGetV1LpmDashboardSettingsFinancingPackageDetailsAffirmInput',
    },
    v1LpmPartnerSettlementAndConversationsSettlement: {
      input: 'OpenapiGetV1LpmPartnerSettlementAndConversationsSettlementInput',
    },
    v1LtmAlwaysOnEligibility: {
      input: 'OpenapiGetV1LtmAlwaysOnEligibilityInput',
    },
    v1ManagedOperationsCancellationReasons: {
      input: 'OpenapiGetV1ManagedOperationsCancellationReasonsInput',
    },
    v1ManagedOperationsMerchantSettings: {
      input: 'OpenapiGetV1ManagedOperationsMerchantSettingsInput',
    },
    v1ManagedPaymentsAccountEligibility: {
      input: 'OpenapiGetV1ManagedPaymentsAccountEligibilityInput',
    },
    v1ManagedPaymentsEligibleTaxCodes: {
      input: 'OpenapiGetV1ManagedPaymentsEligibleTaxCodesInput',
    },
    v1ManagedPaymentsMerchantSettings: {
      input: 'OpenapiGetV1ManagedPaymentsMerchantSettingsInput',
    },
    v1Mandates: {
      input: 'OpenapiGetV1MandatesInput',
    },
    v1MerchantEligibilityForPiiExemptOnboardingMerchantId: {
      input: 'OpenapiGetV1MerchantEligibilityForPiiExemptOnboardingMerchantIdInput',
    },
    v1MetadataKeys: {
      input: 'OpenapiGetV1MetadataKeysInput',
    },
    v1Metrics: {
      input: 'OpenapiGetV1MetricsInput',
    },
    v1MexicoAddressSuggest: {
      input: 'OpenapiGetV1MexicoAddressSuggestInput',
    },
    v1MexicoAddressSuggestNested: {
      input: 'OpenapiGetV1MexicoAddressSuggestNestedInput',
    },
    v1MonetizationCurrentPricing: {
      input: 'OpenapiGetV1MonetizationCurrentPricingInput',
    },
    v1MoneyManagementBalanceSummary: {
      input: 'OpenapiGetV1MoneyManagementBalanceSummaryInput',
    },
    v1MoneyManagementFuturePayouts: {
      input: 'OpenapiGetV1MoneyManagementFuturePayoutsInput',
    },
    v1MoneyManagementMerchantAttributes: {
      input: 'OpenapiGetV1MoneyManagementMerchantAttributesInput',
    },
    v1MoneyManagementOutboundPaymentFees: {
      input: 'OpenapiGetV1MoneyManagementOutboundPaymentFeesInput',
    },
    v1Notes: {
      input: 'OpenapiGetV1NotesInput',
    },
    v1NtaCorporateNumberTypeahead: {
      input: 'OpenapiGetV1NtaCorporateNumberTypeaheadInput',
    },
    v1OnboardingBusinessIntentRecommendations: {
      input: 'OpenapiGetV1OnboardingBusinessIntentRecommendationsInput',
    },
    v1OrdersIdLineItems: {
      input: 'OpenapiGetV1OrdersIdLineItemsInput',
    },
    v1OrrChanges: {
      input: 'OpenapiGetV1OrrChangesInput',
    },
    v1OrrGroups: {
      input: 'OpenapiGetV1OrrGroupsInput',
    },
    v1OrrMetrics: {
      input: 'OpenapiGetV1OrrMetricsInput',
    },
    v1OtpSmsDeliveryHealthy: {
      input: 'OpenapiGetV1OtpSmsDeliveryHealthyInput',
    },
    v1PaperChecks: {
      input: 'OpenapiGetV1PaperChecksInput',
    },
    v1PaperChecksId: {
      input: 'OpenapiGetV1PaperChecksIdInput',
    },
    v1PaymentAttemptRecordEntriesId: {
      input: 'OpenapiGetV1PaymentAttemptRecordEntriesIdInput',
    },
    v1PaymentAttemptRecordsId: {
      input: 'OpenapiGetV1PaymentAttemptRecordsIdInput',
    },
    v1PaymentAttemptRecordsIdEntries: {
      input: 'OpenapiGetV1PaymentAttemptRecordsIdEntriesInput',
    },
    v1PaymentIntents: {
      input: 'OpenapiGetV1PaymentIntentsInput',
    },
    v1PaymentIntentsIntent: {
      input: 'OpenapiGetV1PaymentIntentsIntentInput',
    },
    v1PaymentIntentsWithLegacyCharges: {
      input: 'OpenapiGetV1PaymentIntentsWithLegacyChargesInput',
    },
    v1PaymentLinks: {
      input: 'OpenapiGetV1PaymentLinksInput',
    },
    v1PaymentLinksPaymentLink: {
      input: 'OpenapiGetV1PaymentLinksPaymentLinkInput',
    },
    v1PaymentLinksPaymentLinkLineItems: {
      input: 'OpenapiGetV1PaymentLinksPaymentLinkLineItemsInput',
    },
    v1PaymentMethodConfigurations: {
      input: 'OpenapiGetV1PaymentMethodConfigurationsInput',
    },
    v1PaymentMethodConfigurationsConfiguration: {
      input: 'OpenapiGetV1PaymentMethodConfigurationsConfigurationInput',
    },
    v1PaymentMethodDomains: {
      input: 'OpenapiGetV1PaymentMethodDomainsInput',
    },
    v1PaymentMethods: {
      input: 'OpenapiGetV1PaymentMethodsInput',
    },
    v1PaymentMethodsPaymentMethod: {
      input: 'OpenapiGetV1PaymentMethodsPaymentMethodInput',
    },
    v1PaymentMethodSupportedCurrencies: {
      input: 'OpenapiGetV1PaymentMethodSupportedCurrenciesInput',
    },
    v1PaymentOptimizerSelfServeEligibility: {
      input: 'OpenapiGetV1PaymentOptimizerSelfServeEligibilityInput',
    },
    v1PaymentOrchestrationRoutingOnboardedProcessors: {
      input: 'OpenapiGetV1PaymentOrchestrationRoutingOnboardedProcessorsInput',
    },
    v1PaymentOrchestrationRoutingRoutingConfigs: {
      input: 'OpenapiGetV1PaymentOrchestrationRoutingRoutingConfigsInput',
    },
    v1PaymentProviderBalanceTransactions: {
      input: 'OpenapiGetV1PaymentProviderBalanceTransactionsInput',
    },
    v1PaymentRecordsId: {
      input: 'OpenapiGetV1PaymentRecordsIdInput',
    },
    v1PaymentsConfigPaymentMethodsUsBankAccount: {
      input: 'OpenapiGetV1PaymentsConfigPaymentMethodsUsBankAccountInput',
    },
    v1PaymentsConfigPaymentsVolumes: {
      input: 'OpenapiGetV1PaymentsConfigPaymentsVolumesInput',
    },
    v1Payouts: {
      input: 'OpenapiGetV1PayoutsInput',
    },
    v1PayoutsCurrencyCurrency: {
      input: 'OpenapiGetV1PayoutsCurrencyCurrencyInput',
    },
    v1PayoutsPayout: {
      input: 'OpenapiGetV1PayoutsPayoutInput',
    },
    v1PayoutsPayoutSummary: {
      input: 'OpenapiGetV1PayoutsPayoutSummaryInput',
    },
    v1PayoutsSettingsBankToPayoutReconciliation: {
      input: 'OpenapiGetV1PayoutsSettingsBankToPayoutReconciliationInput',
    },
    v1PersonVerificationRequest: {
      input: 'OpenapiGetV1PersonVerificationRequestInput',
    },
    v1PlatformExtensionAccountStatusPreview: {
      input: 'OpenapiGetV1PlatformExtensionAccountStatusPreviewInput',
    },
    v1PlatformExtensionDisruptedExtensions: {
      input: 'OpenapiGetV1PlatformExtensionDisruptedExtensionsInput',
    },
    v1PlatformExtensionPreviewConnectedAccount: {
      input: 'OpenapiGetV1PlatformExtensionPreviewConnectedAccountInput',
    },
    v1PlatformOnboardingVerificationStatus: {
      input: 'OpenapiGetV1PlatformOnboardingVerificationStatusInput',
    },
    v1PmonboardingPmonboardingForm: {
      input: 'OpenapiGetV1PmonboardingPmonboardingFormInput',
    },
    v1Prices: {
      input: 'OpenapiGetV1PricesInput',
    },
    v1PricesPrice: {
      input: 'OpenapiGetV1PricesPriceInput',
    },
    v1PricesPriceSubscriptionCount: {
      input: 'OpenapiGetV1PricesPriceSubscriptionCountInput',
    },
    v1PricingConfigsPricingType: {
      input: 'OpenapiGetV1PricingConfigsPricingTypeInput',
    },
    v1PricingConfigsPricingTypeSchemesCurrentAt: {
      input: 'OpenapiGetV1PricingConfigsPricingTypeSchemesCurrentAtInput',
    },
    v1PricingTables: {
      input: 'OpenapiGetV1PricingTablesInput',
    },
    v1PricingTablesPricingTable: {
      input: 'OpenapiGetV1PricingTablesPricingTableInput',
    },
    v1ProductCatalogFeedIngestedAndSyndicatedCounts: {
      input: 'OpenapiGetV1ProductCatalogFeedIngestedAndSyndicatedCountsInput',
    },
    v1ProductCatalogFeedProducts: {
      input: 'OpenapiGetV1ProductCatalogFeedProductsInput',
    },
    v1ProductCatalogFeedProductsSku: {
      input: 'OpenapiGetV1ProductCatalogFeedProductsSkuInput',
    },
    v1ProductCatalogMetadata: {
      input: 'OpenapiGetV1ProductCatalogMetadataInput',
    },
    v1ProductCatalogTrialOffers: {
      input: 'OpenapiGetV1ProductCatalogTrialOffersInput',
    },
    v1ProductCatalogTrialOffersId: {
      input: 'OpenapiGetV1ProductCatalogTrialOffersIdInput',
    },
    v1ProductClasses: {
      input: 'OpenapiGetV1ProductClassesInput',
    },
    v1ProductClassesId: {
      input: 'OpenapiGetV1ProductClassesIdInput',
    },
    v1ProductFeatures: {
      input: 'OpenapiGetV1ProductFeaturesInput',
    },
    v1Products: {
      input: 'OpenapiGetV1ProductsInput',
    },
    v1ProductSetupStatus: {
      input: 'OpenapiGetV1ProductSetupStatusInput',
    },
    v1ProductsId: {
      input: 'OpenapiGetV1ProductsIdInput',
    },
    v1ProductsProductFeatures: {
      input: 'OpenapiGetV1ProductsProductFeaturesInput',
    },
    v1ProductSuggestions: {
      input: 'OpenapiGetV1ProductSuggestionsInput',
    },
    v1Profiles: {
      input: 'OpenapiGetV1ProfilesInput',
    },
    v1ProfilesAlerts: {
      input: 'OpenapiGetV1ProfilesAlertsInput',
    },
    v1ProfilesFinancialAccountTransfersConfig: {
      input: 'OpenapiGetV1ProfilesFinancialAccountTransfersConfigInput',
    },
    v1ProfilesFinancialAccountTransfersNetworkIdConfig: {
      input: 'OpenapiGetV1ProfilesFinancialAccountTransfersNetworkIdConfigInput',
    },
    v1ProfilesMerchantAccountId: {
      input: 'OpenapiGetV1ProfilesMerchantAccountIdInput',
    },
    v1ProfilesProposal: {
      input: 'OpenapiGetV1ProfilesProposalInput',
    },
    v1ProfilesSearch: {
      input: 'OpenapiGetV1ProfilesSearchInput',
    },
    v1ProfilesUsernameStatusUsername: {
      input: 'OpenapiGetV1ProfilesUsernameStatusUsernameInput',
    },
    v1ProfilesUsernameUsername: {
      input: 'OpenapiGetV1ProfilesUsernameUsernameInput',
    },
    v1Quotes: {
      input: 'OpenapiGetV1QuotesInput',
    },
    v1QuotesQuote: {
      input: 'OpenapiGetV1QuotesQuoteInput',
    },
    v1RadarAgenticInsights: {
      input: 'OpenapiGetV1RadarAgenticInsightsInput',
    },
    v1RadarCustomCountersConfiguration: {
      input: 'OpenapiGetV1RadarCustomCountersConfigurationInput',
    },
    v1RadarExpandGraph: {
      input: 'OpenapiGetV1RadarExpandGraphInput',
    },
    v1RadarMerchantRulesId: {
      input: 'OpenapiGetV1RadarMerchantRulesIdInput',
    },
    v1RadarMerchantRulesMerchantRuleIdFanoutsFanoutId: {
      input: 'OpenapiGetV1RadarMerchantRulesMerchantRuleIdFanoutsFanoutIdInput',
    },
    v1RadarPaymentEvaluations: {
      input: 'OpenapiGetV1RadarPaymentEvaluationsInput',
    },
    v1RadarPaymentEvaluationsId: {
      input: 'OpenapiGetV1RadarPaymentEvaluationsIdInput',
    },
    v1RadarRetrieveAttributeValues: {
      input: 'OpenapiGetV1RadarRetrieveAttributeValuesInput',
    },
    v1RadarRetrieveFraudAlerts: {
      input: 'OpenapiGetV1RadarRetrieveFraudAlertsInput',
    },
    v1RadarSearchPredicateDetailMetrics: {
      input: 'OpenapiGetV1RadarSearchPredicateDetailMetricsInput',
    },
    v1RadarSearchRulesDisputeMetrics: {
      input: 'OpenapiGetV1RadarSearchRulesDisputeMetricsInput',
    },
    v1RadarSearchRulesDisputes: {
      input: 'OpenapiGetV1RadarSearchRulesDisputesInput',
    },
    v1RadarTemplateConfigs: {
      input: 'OpenapiGetV1RadarTemplateConfigsInput',
    },
    v1RadarTieredFeatures: {
      input: 'OpenapiGetV1RadarTieredFeaturesInput',
    },
    v1RadarValueListItems: {
      input: 'OpenapiGetV1RadarValueListItemsInput',
    },
    v1RadarValueListItemsItem: {
      input: 'OpenapiGetV1RadarValueListItemsItemInput',
    },
    v1RadarValueLists: {
      input: 'OpenapiGetV1RadarValueListsInput',
    },
    v1RadarValueListsValueList: {
      input: 'OpenapiGetV1RadarValueListsValueListInput',
    },
    v1RealTimeNotificationSettings: {
      input: 'OpenapiGetV1RealTimeNotificationSettingsInput',
    },
    v1Refunds: {
      input: 'OpenapiGetV1RefundsInput',
    },
    v1RefundsRefund: {
      input: 'OpenapiGetV1RefundsRefundInput',
    },
    v1ReportingCompartmentCachedMetadataKeys: {
      input: 'OpenapiGetV1ReportingCompartmentCachedMetadataKeysInput',
    },
    v1ReportingExecuteMultiEntityReport: {
      input: 'OpenapiGetV1ReportingExecuteMultiEntityReportInput',
    },
    v1ReportingMultiEntityReportRunsMultiEntityReportRun: {
      input: 'OpenapiGetV1ReportingMultiEntityReportRunsMultiEntityReportRunInput',
    },
    v1ReportingMultiEntityReportRunsMultiEntityReportRunResults: {
      input: 'OpenapiGetV1ReportingMultiEntityReportRunsMultiEntityReportRunResultsInput',
    },
    v1ReportingMultiEntityReportTypes: {
      input: 'OpenapiGetV1ReportingMultiEntityReportTypesInput',
    },
    v1ReportingMultiEntityReportTypesReportType: {
      input: 'OpenapiGetV1ReportingMultiEntityReportTypesReportTypeInput',
    },
    v1ReportingReportRuns: {
      input: 'OpenapiGetV1ReportingReportRunsInput',
    },
    v1ReportingReportRunsReportRun: {
      input: 'OpenapiGetV1ReportingReportRunsReportRunInput',
    },
    v1ReportingReportTypes: {
      input: 'OpenapiGetV1ReportingReportTypesInput',
    },
    v1ReportingReportTypesReportType: {
      input: 'OpenapiGetV1ReportingReportTypesReportTypeInput',
    },
    v1RequestLogs: {
      input: 'OpenapiGetV1RequestLogsInput',
    },
    v1RequestLogsId: {
      input: 'OpenapiGetV1RequestLogsIdInput',
    },
    v1ReserveHolds: {
      input: 'OpenapiGetV1ReserveHoldsInput',
    },
    v1ReserveHoldsId: {
      input: 'OpenapiGetV1ReserveHoldsIdInput',
    },
    v1ReservePlans: {
      input: 'OpenapiGetV1ReservePlansInput',
    },
    v1ReservePlansId: {
      input: 'OpenapiGetV1ReservePlansIdInput',
    },
    v1ReserveReleases: {
      input: 'OpenapiGetV1ReserveReleasesInput',
    },
    v1ReserveReleasesId: {
      input: 'OpenapiGetV1ReserveReleasesIdInput',
    },
    v1RetrieveEmbeddedFlags: {
      input: 'OpenapiGetV1RetrieveEmbeddedFlagsInput',
    },
    v1RetryPolicies: {
      input: 'OpenapiGetV1RetryPoliciesInput',
    },
    v1RetryPoliciesRetryPolicy: {
      input: 'OpenapiGetV1RetryPoliciesRetryPolicyInput',
    },
    v1RevenueRecognitionAccountingIntelligenceRevenueForecast: {
      input: 'OpenapiGetV1RevenueRecognitionAccountingIntelligenceRevenueForecastInput',
    },
    v1RevenueRecognitionAccountingIntelligenceStatementsInsights: {
      input: 'OpenapiGetV1RevenueRecognitionAccountingIntelligenceStatementsInsightsInput',
    },
    v1RevenueRecognitionBundleStatus: {
      input: 'OpenapiGetV1RevenueRecognitionBundleStatusInput',
    },
    v1RevenueRecognitionContractsId: {
      input: 'OpenapiGetV1RevenueRecognitionContractsIdInput',
    },
    v1RevenueRecognitionContractsIdLines: {
      input: 'OpenapiGetV1RevenueRecognitionContractsIdLinesInput',
    },
    v1RevenueRecognitionDataImportJournalEntries: {
      input: 'OpenapiGetV1RevenueRecognitionDataImportJournalEntriesInput',
    },
    v1RevenueRecognitionFilterOptions: {
      input: 'OpenapiGetV1RevenueRecognitionFilterOptionsInput',
    },
    v1RevenueRecognitionOverviewRecommendation: {
      input: 'OpenapiGetV1RevenueRecognitionOverviewRecommendationInput',
    },
    v1RevenueStudioCampaigns: {
      input: 'OpenapiGetV1RevenueStudioCampaignsInput',
    },
    v1RevenueStudioCampaignsCampaign: {
      input: 'OpenapiGetV1RevenueStudioCampaignsCampaignInput',
    },
    v1RevenueStudioPaymentOptimizerPaymentMethodRecommendations: {
      input: 'OpenapiGetV1RevenueStudioPaymentOptimizerPaymentMethodRecommendationsInput',
    },
    v1RevenueStudioPaymentOptimizerPlatformPaymentMethodRecommendations: {
      input: 'OpenapiGetV1RevenueStudioPaymentOptimizerPlatformPaymentMethodRecommendationsInput',
    },
    v1Reviews: {
      input: 'OpenapiGetV1ReviewsInput',
    },
    v1ReviewsReview: {
      input: 'OpenapiGetV1ReviewsReviewInput',
    },
    v1RisaComplianceSurvey: {
      input: 'OpenapiGetV1RisaComplianceSurveyInput',
    },
    v1RiskAccountStatus: {
      input: 'OpenapiGetV1RiskAccountStatusInput',
    },
    v1RiskAddressValidate: {
      input: 'OpenapiGetV1RiskAddressValidateInput',
    },
    v1RiskChallengesChallengeId: {
      input: 'OpenapiGetV1RiskChallengesChallengeIdInput',
    },
    v1RiskDashboardFormsAllPayoutAccountsLinked: {
      input: 'OpenapiGetV1RiskDashboardFormsAllPayoutAccountsLinkedInput',
    },
    v1RiskDashboardFormsByNameName: {
      input: 'OpenapiGetV1RiskDashboardFormsByNameNameInput',
    },
    v1RiskDashboardFormsRequirementId: {
      input: 'OpenapiGetV1RiskDashboardFormsRequirementIdInput',
    },
    v1RiskDashboardFormsValidationUrl: {
      input: 'OpenapiGetV1RiskDashboardFormsValidationUrlInput',
    },
    v1RiskStripeVerifiedGetVerifiedStatus: {
      input: 'OpenapiGetV1RiskStripeVerifiedGetVerifiedStatusInput',
    },
    v1RiskStripeVerifiedInterventions: {
      input: 'OpenapiGetV1RiskStripeVerifiedInterventionsInput',
    },
    v1RiskStripeVerifiedIsMerchantTopStartup: {
      input: 'OpenapiGetV1RiskStripeVerifiedIsMerchantTopStartupInput',
    },
    v1RiskUiAccountStatusBanner: {
      input: 'OpenapiGetV1RiskUiAccountStatusBannerInput',
    },
    v1RiskUiAccountStatusSuppressionExemptions: {
      input: 'OpenapiGetV1RiskUiAccountStatusSuppressionExemptionsInput',
    },
    v1RiskUrlRequirementStatus: {
      input: 'OpenapiGetV1RiskUrlRequirementStatusInput',
    },
    v1Ruleset: {
      input: 'OpenapiGetV1RulesetInput',
    },
    v1ScreenshareSessionToken: {
      input: 'OpenapiGetV1ScreenshareSessionTokenInput',
    },
    v1SettingsAllowedSettlementCurrencies: {
      input: 'OpenapiGetV1SettingsAllowedSettlementCurrenciesInput',
    },
    v1SettingsCustomerCashBalanceDefaultReconciliationMode: {
      input: 'OpenapiGetV1SettingsCustomerCashBalanceDefaultReconciliationModeInput',
    },
    v1SettingsDebitsSettlement: {
      input: 'OpenapiGetV1SettingsDebitsSettlementInput',
    },
    v1SettingsFasterSettlement: {
      input: 'OpenapiGetV1SettingsFasterSettlementInput',
    },
    v1SettingsPlansAndFeesInvoiceHistoryDocuments: {
      input: 'OpenapiGetV1SettingsPlansAndFeesInvoiceHistoryDocumentsInput',
    },
    v1SettingsSupportHistorySharingCanOptOutOfSharingSupportHistory: {
      input: 'OpenapiGetV1SettingsSupportHistorySharingCanOptOutOfSharingSupportHistoryInput',
    },
    v1SettingsUserSettlementCurrencies: {
      input: 'OpenapiGetV1SettingsUserSettlementCurrenciesInput',
    },
    v1SetupAttempts: {
      input: 'OpenapiGetV1SetupAttemptsInput',
    },
    v1SetupIntentsIntent: {
      input: 'OpenapiGetV1SetupIntentsIntentInput',
    },
    v1ShippingRates: {
      input: 'OpenapiGetV1ShippingRatesInput',
    },
    v1ShippingRatesShippingRateToken: {
      input: 'OpenapiGetV1ShippingRatesShippingRateTokenInput',
    },
    v1SigmaAssistantSessionIdChatHistory: {
      input: 'OpenapiGetV1SigmaAssistantSessionIdChatHistoryInput',
    },
    v1SigmaIsMerchantSanctioned: {
      input: 'OpenapiGetV1SigmaIsMerchantSanctionedInput',
    },
    v1SigmaOrganizationQueries: {
      input: 'OpenapiGetV1SigmaOrganizationQueriesInput',
    },
    v1SigmaOrganizationQueriesCompartments: {
      input: 'OpenapiGetV1SigmaOrganizationQueriesCompartmentsInput',
    },
    v1SigmaOrganizationQueriesOrganizationQuery: {
      input: 'OpenapiGetV1SigmaOrganizationQueriesOrganizationQueryInput',
    },
    v1SigmaOrganizationQueriesOrganizationQueryDownload: {
      input: 'OpenapiGetV1SigmaOrganizationQueriesOrganizationQueryDownloadInput',
    },
    v1SigmaOrganizationQueryFiles: {
      input: 'OpenapiGetV1SigmaOrganizationQueryFilesInput',
    },
    v1SigmaOrganizationQueryFilesOrganizationQueryFile: {
      input: 'OpenapiGetV1SigmaOrganizationQueryFilesOrganizationQueryFileInput',
    },
    v1SigmaOrganizationScheduledQueryRuns: {
      input: 'OpenapiGetV1SigmaOrganizationScheduledQueryRunsInput',
    },
    v1SigmaOrganizationScheduledQueryRunsOrganizationScheduledQueryRunDownload: {
      input: 'OpenapiGetV1SigmaOrganizationScheduledQueryRunsOrganizationScheduledQueryRunDownloadInput',
    },
    v1SigmaOrganizationSchema: {
      input: 'OpenapiGetV1SigmaOrganizationSchemaInput',
    },
    v1SigmaQueries: {
      input: 'OpenapiGetV1SigmaQueriesInput',
    },
    v1SigmaQueriesReportingQuery: {
      input: 'OpenapiGetV1SigmaQueriesReportingQueryInput',
    },
    v1SigmaQueriesReportingQueryDownload: {
      input: 'OpenapiGetV1SigmaQueriesReportingQueryDownloadInput',
    },
    v1SigmaQueriesReportingQueryResults: {
      input: 'OpenapiGetV1SigmaQueriesReportingQueryResultsInput',
    },
    v1SigmaReportingQueryFolders: {
      input: 'OpenapiGetV1SigmaReportingQueryFoldersInput',
    },
    v1SigmaScheduledQueries: {
      input: 'OpenapiGetV1SigmaScheduledQueriesInput',
    },
    v1SigmaScheduledQueriesScheduledQuery: {
      input: 'OpenapiGetV1SigmaScheduledQueriesScheduledQueryInput',
    },
    v1SigmaScheduledQueryRuns: {
      input: 'OpenapiGetV1SigmaScheduledQueryRunsInput',
    },
    v1SigmaScheduledQueryRunsScheduledQueryRun: {
      input: 'OpenapiGetV1SigmaScheduledQueryRunsScheduledQueryRunInput',
    },
    v1SigmaVisualizations: {
      input: 'OpenapiGetV1SigmaVisualizationsInput',
    },
    v1SingaporeCddSurveyEnabled: {
      input: 'OpenapiGetV1SingaporeCddSurveyEnabledInput',
    },
    v1Skus: {
      input: 'OpenapiGetV1SkusInput',
    },
    v1SourcesSource: {
      input: 'OpenapiGetV1SourcesSourceInput',
    },
    v1StartupPartners: {
      input: 'OpenapiGetV1StartupPartnersInput',
    },
    v1StatementsMetadata: {
      input: 'OpenapiGetV1StatementsMetadataInput',
    },
    v1StripecliDevices: {
      input: 'OpenapiGetV1StripecliDevicesInput',
    },
    v1StripecliWebhookResponses: {
      input: 'OpenapiGetV1StripecliWebhookResponsesInput',
    },
    v1StripeDataPipelineExportPlanRequirements: {
      input: 'OpenapiGetV1StripeDataPipelineExportPlanRequirementsInput',
    },
    v1StripeDataPipelineExportPlans: {
      input: 'OpenapiGetV1StripeDataPipelineExportPlansInput',
    },
    v1StripeDataPipelineInviteEmail: {
      input: 'OpenapiGetV1StripeDataPipelineInviteEmailInput',
    },
    v1StripeDataPipelineListParentExportPlans: {
      input: 'OpenapiGetV1StripeDataPipelineListParentExportPlansInput',
    },
    v1StripeVerifiedStatus: {
      input: 'OpenapiGetV1StripeVerifiedStatusInput',
    },
    v1SubscriptionItems: {
      input: 'OpenapiGetV1SubscriptionItemsInput',
    },
    v1Subscriptions: {
      input: 'OpenapiGetV1SubscriptionsInput',
    },
    v1SubscriptionSchedules: {
      input: 'OpenapiGetV1SubscriptionSchedulesInput',
    },
    v1SubscriptionSchedulesSchedule: {
      input: 'OpenapiGetV1SubscriptionSchedulesScheduleInput',
    },
    v1SubscriptionsSubscriptionExposedId: {
      input: 'OpenapiGetV1SubscriptionsSubscriptionExposedIdInput',
    },
    v1TailorAppBuildVersion: {
      input: 'OpenapiGetV1TailorAppBuildVersionInput',
    },
    v1TailorAppBuildVersionId: {
      input: 'OpenapiGetV1TailorAppBuildVersionIdInput',
    },
    v1TailorAppByPublicId: {
      input: 'OpenapiGetV1TailorAppByPublicIdInput',
    },
    v1TailorAppId: {
      input: 'OpenapiGetV1TailorAppIdInput',
    },
    v1TailorAppIdInstalls: {
      input: 'OpenapiGetV1TailorAppIdInstallsInput',
    },
    v1TailorBackendSecretAppId: {
      input: 'OpenapiGetV1TailorBackendSecretAppIdInput',
    },
    v1TailorBackendSignature: {
      input: 'OpenapiGetV1TailorBackendSignatureInput',
    },
    v1TailorExtensionPrototypeVersion: {
      input: 'OpenapiGetV1TailorExtensionPrototypeVersionInput',
    },
    v1TailorExtensionPrototypeVersions: {
      input: 'OpenapiGetV1TailorExtensionPrototypeVersionsInput',
    },
    v1TailorExtensionsForInterface: {
      input: 'OpenapiGetV1TailorExtensionsForInterfaceInput',
    },
    v1TailorExtensionUsagesForApp: {
      input: 'OpenapiGetV1TailorExtensionUsagesForAppInput',
    },
    v1TailorExtensionUsagesId: {
      input: 'OpenapiGetV1TailorExtensionUsagesIdInput',
    },
    v1TailorInstall: {
      input: 'OpenapiGetV1TailorInstallInput',
    },
    v1TailorInstallId: {
      input: 'OpenapiGetV1TailorInstallIdInput',
    },
    v1TailorTermsAcceptanceByAccountMerchantIdValid: {
      input: 'OpenapiGetV1TailorTermsAcceptanceByAccountMerchantIdValidInput',
    },
    v1TaskRadarRuleMatchedAccounts: {
      input: 'OpenapiGetV1TaskRadarRuleMatchedAccountsInput',
    },
    v1TaxAvailableCountries: {
      input: 'OpenapiGetV1TaxAvailableCountriesInput',
    },
    v1TaxCodes: {
      input: 'OpenapiGetV1TaxCodesInput',
    },
    v1TaxCodesId: {
      input: 'OpenapiGetV1TaxCodesIdInput',
    },
    v1TaxCurrentPricing: {
      input: 'OpenapiGetV1TaxCurrentPricingInput',
    },
    v1TaxDocuments: {
      input: 'OpenapiGetV1TaxDocumentsInput',
    },
    v1TaxFilingEnrollmentApplications: {
      input: 'OpenapiGetV1TaxFilingEnrollmentApplicationsInput',
    },
    v1TaxFilingEnrollmentApplicationsId: {
      input: 'OpenapiGetV1TaxFilingEnrollmentApplicationsIdInput',
    },
    v1TaxFilingEnrollmentAvailabily: {
      input: 'OpenapiGetV1TaxFilingEnrollmentAvailabilyInput',
    },
    v1TaxFilingEnrollmentPartnerAccountsFind: {
      input: 'OpenapiGetV1TaxFilingEnrollmentPartnerAccountsFindInput',
    },
    v1TaxFilingEnrollmentsAndApplications: {
      input: 'OpenapiGetV1TaxFilingEnrollmentsAndApplicationsInput',
    },
    v1TaxHeadOfficeAvailableLocations: {
      input: 'OpenapiGetV1TaxHeadOfficeAvailableLocationsInput',
    },
    v1TaxJurisdictionFeaturesFiling: {
      input: 'OpenapiGetV1TaxJurisdictionFeaturesFilingInput',
    },
    v1TaxLocations: {
      input: 'OpenapiGetV1TaxLocationsInput',
    },
    v1TaxLocationsLocation: {
      input: 'OpenapiGetV1TaxLocationsLocationInput',
    },
    v1TaxMerchantPricing: {
      input: 'OpenapiGetV1TaxMerchantPricingInput',
    },
    v1TaxMonitoringThresholds: {
      input: 'OpenapiGetV1TaxMonitoringThresholdsInput',
    },
    v1TaxOnboardingAvailability: {
      input: 'OpenapiGetV1TaxOnboardingAvailabilityInput',
    },
    v1TaxPaygoMerchantRegistrationsAndFilings: {
      input: 'OpenapiGetV1TaxPaygoMerchantRegistrationsAndFilingsInput',
    },
    v1TaxPlatformSettingsRetrieve: {
      input: 'OpenapiGetV1TaxPlatformSettingsRetrieveInput',
    },
    v1TaxProductSettingsTaxCodeAssistantSearch: {
      input: 'OpenapiGetV1TaxProductSettingsTaxCodeAssistantSearchInput',
    },
    v1TaxProductSettingsTaxCodeAssistantSearchQueryId: {
      input: 'OpenapiGetV1TaxProductSettingsTaxCodeAssistantSearchQueryIdInput',
    },
    v1TaxProductTaxMigrationsCurrentStateV2: {
      input: 'OpenapiGetV1TaxProductTaxMigrationsCurrentStateV2Input',
    },
    v1TaxProductTaxMigrationsMigrations: {
      input: 'OpenapiGetV1TaxProductTaxMigrationsMigrationsInput',
    },
    v1TaxRates: {
      input: 'OpenapiGetV1TaxRatesInput',
    },
    v1TaxRatesTaxRate: {
      input: 'OpenapiGetV1TaxRatesTaxRateInput',
    },
    v1TaxRegistrationApplications: {
      input: 'OpenapiGetV1TaxRegistrationApplicationsInput',
    },
    v1TaxRegistrationApplicationsId: {
      input: 'OpenapiGetV1TaxRegistrationApplicationsIdInput',
    },
    v1TaxRegistrationExternalUrl: {
      input: 'OpenapiGetV1TaxRegistrationExternalUrlInput',
    },
    v1TaxRegistrationMerchantInfoCountry: {
      input: 'OpenapiGetV1TaxRegistrationMerchantInfoCountryInput',
    },
    v1TaxRegistrations: {
      input: 'OpenapiGetV1TaxRegistrationsInput',
    },
    v1TaxRegistrationsAvailability: {
      input: 'OpenapiGetV1TaxRegistrationsAvailabilityInput',
    },
    v1TaxRegistrationsId: {
      input: 'OpenapiGetV1TaxRegistrationsIdInput',
    },
    v1TaxReportingFatcaCrsForm: {
      input: 'OpenapiGetV1TaxReportingFatcaCrsFormInput',
    },
    v1TaxSettings: {
      input: 'OpenapiGetV1TaxSettingsInput',
    },
    v1TaxSignupState: {
      input: 'OpenapiGetV1TaxSignupStateInput',
    },
    v1TerminalConfigurations: {
      input: 'OpenapiGetV1TerminalConfigurationsInput',
    },
    v1TerminalConfigurationsConfiguration: {
      input: 'OpenapiGetV1TerminalConfigurationsConfigurationInput',
    },
    v1TerminalConfigurationsDerivedConfig: {
      input: 'OpenapiGetV1TerminalConfigurationsDerivedConfigInput',
    },
    v1TerminalDeployPlans: {
      input: 'OpenapiGetV1TerminalDeployPlansInput',
    },
    v1TerminalDeviceAssets: {
      input: 'OpenapiGetV1TerminalDeviceAssetsInput',
    },
    v1TerminalDeviceAssetsDeviceAsset: {
      input: 'OpenapiGetV1TerminalDeviceAssetsDeviceAssetInput',
    },
    v1TerminalDeviceAssetVersions: {
      input: 'OpenapiGetV1TerminalDeviceAssetVersionsInput',
    },
    v1TerminalDeviceAssetVersionsDeviceAssetVersion: {
      input: 'OpenapiGetV1TerminalDeviceAssetVersionsDeviceAssetVersionInput',
    },
    v1TerminalDeviceDeployBundles: {
      input: 'OpenapiGetV1TerminalDeviceDeployBundlesInput',
    },
    v1TerminalDeviceDeployBundlesDeviceDeployBundle: {
      input: 'OpenapiGetV1TerminalDeviceDeployBundlesDeviceDeployBundleInput',
    },
    v1TerminalDeviceDeployGroups: {
      input: 'OpenapiGetV1TerminalDeviceDeployGroupsInput',
    },
    v1TerminalDeviceDeployGroupsDeployGroupDeployRules: {
      input: 'OpenapiGetV1TerminalDeviceDeployGroupsDeployGroupDeployRulesInput',
    },
    v1TerminalDeviceDeployGroupsDeviceDeployGroup: {
      input: 'OpenapiGetV1TerminalDeviceDeployGroupsDeviceDeployGroupInput',
    },
    v1TerminalHardwareOrderDevices: {
      input: 'OpenapiGetV1TerminalHardwareOrderDevicesInput',
    },
    v1TerminalHardwareOrderDevicesHardwareOrderInfo: {
      input: 'OpenapiGetV1TerminalHardwareOrderDevicesHardwareOrderInfoInput',
    },
    v1TerminalHardwareOrderDevicesId: {
      input: 'OpenapiGetV1TerminalHardwareOrderDevicesIdInput',
    },
    v1TerminalHardwareOrders: {
      input: 'OpenapiGetV1TerminalHardwareOrdersInput',
    },
    v1TerminalHardwareOrdersAvailableCountries: {
      input: 'OpenapiGetV1TerminalHardwareOrdersAvailableCountriesInput',
    },
    v1TerminalHardwareOrdersAvailableProviders: {
      input: 'OpenapiGetV1TerminalHardwareOrdersAvailableProvidersInput',
    },
    v1TerminalHardwareOrdersCharacterLimits: {
      input: 'OpenapiGetV1TerminalHardwareOrdersCharacterLimitsInput',
    },
    v1TerminalHardwareOrdersConnectConfigurationsDefault: {
      input: 'OpenapiGetV1TerminalHardwareOrdersConnectConfigurationsDefaultInput',
    },
    v1TerminalHardwareOrdersId: {
      input: 'OpenapiGetV1TerminalHardwareOrdersIdInput',
    },
    v1TerminalHardwareOrdersIdPaymentDetails: {
      input: 'OpenapiGetV1TerminalHardwareOrdersIdPaymentDetailsInput',
    },
    v1TerminalHardwareOrdersInvoicesPaginated: {
      input: 'OpenapiGetV1TerminalHardwareOrdersInvoicesPaginatedInput',
    },
    v1TerminalHardwareOrdersPreview: {
      input: 'OpenapiGetV1TerminalHardwareOrdersPreviewInput',
    },
    v1TerminalHardwareOrdersProductTypeGroups: {
      input: 'OpenapiGetV1TerminalHardwareOrdersProductTypeGroupsInput',
    },
    v1TerminalHardwareOrdersProductTypesOrder: {
      input: 'OpenapiGetV1TerminalHardwareOrdersProductTypesOrderInput',
    },
    v1TerminalHardwareOrdersSplitName: {
      input: 'OpenapiGetV1TerminalHardwareOrdersSplitNameInput',
    },
    v1TerminalHardwareOrdersStripeEntityPublishableKey: {
      input: 'OpenapiGetV1TerminalHardwareOrdersStripeEntityPublishableKeyInput',
    },
    v1TerminalHardwareOrdersValidateAddress: {
      input: 'OpenapiGetV1TerminalHardwareOrdersValidateAddressInput',
    },
    v1TerminalHardwareOrdersValidatedCalculatedOrderIntentId: {
      input: 'OpenapiGetV1TerminalHardwareOrdersValidatedCalculatedOrderIntentIdInput',
    },
    v1TerminalHardwareOrdersValidatedCalculatedOrderIntentIdPaymentDetails: {
      input: 'OpenapiGetV1TerminalHardwareOrdersValidatedCalculatedOrderIntentIdPaymentDetailsInput',
    },
    v1TerminalHardwareShippingMethods: {
      input: 'OpenapiGetV1TerminalHardwareShippingMethodsInput',
    },
    v1TerminalHardwareShippingMethodsId: {
      input: 'OpenapiGetV1TerminalHardwareShippingMethodsIdInput',
    },
    v1TerminalHardwareSkus: {
      input: 'OpenapiGetV1TerminalHardwareSkusInput',
    },
    v1TerminalHardwareSkusId: {
      input: 'OpenapiGetV1TerminalHardwareSkusIdInput',
    },
    v1TerminalLocationCapabilities: {
      input: 'OpenapiGetV1TerminalLocationCapabilitiesInput',
    },
    v1TerminalLocationCapabilitiesCapability: {
      input: 'OpenapiGetV1TerminalLocationCapabilitiesCapabilityInput',
    },
    v1TerminalLocationCapabilitiesSearch: {
      input: 'OpenapiGetV1TerminalLocationCapabilitiesSearchInput',
    },
    v1TerminalLocations: {
      input: 'OpenapiGetV1TerminalLocationsInput',
    },
    v1TerminalLocationsLocation: {
      input: 'OpenapiGetV1TerminalLocationsLocationInput',
    },
    v1TerminalLocationsSearch: {
      input: 'OpenapiGetV1TerminalLocationsSearchInput',
    },
    v1TerminalMerchantDeployableCountriesMerchantId: {
      input: 'OpenapiGetV1TerminalMerchantDeployableCountriesMerchantIdInput',
    },
    v1TerminalMerchantP2peValues: {
      input: 'OpenapiGetV1TerminalMerchantP2peValuesInput',
    },
    v1TerminalReaders: {
      input: 'OpenapiGetV1TerminalReadersInput',
    },
    v1TerminalReadersListDistinctDeviceTypes: {
      input: 'OpenapiGetV1TerminalReadersListDistinctDeviceTypesInput',
    },
    v1TerminalReadersReader: {
      input: 'OpenapiGetV1TerminalReadersReaderInput',
    },
    v1TerminalReadersSearch: {
      input: 'OpenapiGetV1TerminalReadersSearchInput',
    },
    v1TerminalTerminalDetailsPayment: {
      input: 'OpenapiGetV1TerminalTerminalDetailsPaymentInput',
    },
    v1TerminalZones: {
      input: 'OpenapiGetV1TerminalZonesInput',
    },
    v1TerminalZonesId: {
      input: 'OpenapiGetV1TerminalZonesIdInput',
    },
    v1TestHelpersTestClocks: {
      input: 'OpenapiGetV1TestHelpersTestClocksInput',
    },
    v1TestHelpersTestClocksTestClock: {
      input: 'OpenapiGetV1TestHelpersTestClocksTestClockInput',
    },
    v1ThreeDSecureAuthentications: {
      input: 'OpenapiGetV1ThreeDSecureAuthenticationsInput',
    },
    v1ThreeDSecureAuthenticationsAuthentication: {
      input: 'OpenapiGetV1ThreeDSecureAuthenticationsAuthenticationInput',
    },
    v1TokenBillingAiModelPrices: {
      input: 'OpenapiGetV1TokenBillingAiModelPricesInput',
    },
    v1TokenBillingSettings: {
      input: 'OpenapiGetV1TokenBillingSettingsInput',
    },
    v1TokensToken: {
      input: 'OpenapiGetV1TokensTokenInput',
    },
    v1TopupEmbeddedEligibility: {
      input: 'OpenapiGetV1TopupEmbeddedEligibilityInput',
    },
    v1TopupIncomingWireTransfer: {
      input: 'OpenapiGetV1TopupIncomingWireTransferInput',
    },
    v1Topups: {
      input: 'OpenapiGetV1TopupsInput',
    },
    v1TransferCurrencyMapping: {
      input: 'OpenapiGetV1TransferCurrencyMappingInput',
    },
    v1Transfers: {
      input: 'OpenapiGetV1TransfersInput',
    },
    v1TreasuryCreditReversalsCreditReversal: {
      input: 'OpenapiGetV1TreasuryCreditReversalsCreditReversalInput',
    },
    v1TreasuryDebitReversalsDebitReversal: {
      input: 'OpenapiGetV1TreasuryDebitReversalsDebitReversalInput',
    },
    v1TreasuryFinancialAccounts: {
      input: 'OpenapiGetV1TreasuryFinancialAccountsInput',
    },
    v1TreasuryFinancialAccountsFinancialAccount: {
      input: 'OpenapiGetV1TreasuryFinancialAccountsFinancialAccountInput',
    },
    v1TreasuryFinancialAccountsFinancialAccountFeatures: {
      input: 'OpenapiGetV1TreasuryFinancialAccountsFinancialAccountFeaturesInput',
    },
    v1TreasuryInboundTransfersId: {
      input: 'OpenapiGetV1TreasuryInboundTransfersIdInput',
    },
    v1TreasuryOutboundPayments: {
      input: 'OpenapiGetV1TreasuryOutboundPaymentsInput',
    },
    v1TreasuryOutboundPaymentsId: {
      input: 'OpenapiGetV1TreasuryOutboundPaymentsIdInput',
    },
    v1TreasuryOutboundTransfersOutboundTransfer: {
      input: 'OpenapiGetV1TreasuryOutboundTransfersOutboundTransferInput',
    },
    v1TreasuryReceivedCreditsId: {
      input: 'OpenapiGetV1TreasuryReceivedCreditsIdInput',
    },
    v1TreasuryReceivedDebitsId: {
      input: 'OpenapiGetV1TreasuryReceivedDebitsIdInput',
    },
    v1TreasuryTransactions: {
      input: 'OpenapiGetV1TreasuryTransactionsInput',
    },
    v1TreasuryTransactionsId: {
      input: 'OpenapiGetV1TreasuryTransactionsIdInput',
    },
    v1UnifiedCustomersList: {
      input: 'OpenapiGetV1UnifiedCustomersListInput',
    },
    v1UnifiedLightningCustomersList: {
      input: 'OpenapiGetV1UnifiedLightningCustomersListInput',
    },
    v1UsageFeeSummary: {
      input: 'OpenapiGetV1UsageFeeSummaryInput',
    },
    v1UsersInvite: {
      input: 'OpenapiGetV1UsersInviteInput',
    },
    v1UsPaperChecksId: {
      input: 'OpenapiGetV1UsPaperChecksIdInput',
    },
    v1ValidUaConfigs: {
      input: 'OpenapiGetV1ValidUaConfigsInput',
    },
    v1VerificationRequirementHintsBankAccount: {
      input: 'OpenapiGetV1VerificationRequirementHintsBankAccountInput',
    },
    v1WaysToPayPaymentMethodsDefault: {
      input: 'OpenapiGetV1WaysToPayPaymentMethodsDefaultInput',
    },
    v1WaysToPayPublishableKey: {
      input: 'OpenapiGetV1WaysToPayPublishableKeyInput',
    },
    v1WebhookEndpoints: {
      input: 'OpenapiGetV1WebhookEndpointsInput',
    },
    v1WebhookEndpointsWebhookEndpoint: {
      input: 'OpenapiGetV1WebhookEndpointsWebhookEndpointInput',
    },
    v1WebhookEndpointsWebhookEndpointSecret: {
      input: 'OpenapiGetV1WebhookEndpointsWebhookEndpointSecretInput',
    },
    v1WorkbenchAccountResourceVersion: {
      input: 'OpenapiGetV1WorkbenchAccountResourceVersionInput',
    },
    v1WorkbenchApiEnums: {
      input: 'OpenapiGetV1WorkbenchApiEnumsInput',
    },
    v1WorkbenchApikeys: {
      input: 'OpenapiGetV1WorkbenchApikeysInput',
    },
    v1WorkbenchApiRequests: {
      input: 'OpenapiGetV1WorkbenchApiRequestsInput',
    },
    v1WorkbenchApiRequestStats: {
      input: 'OpenapiGetV1WorkbenchApiRequestStatsInput',
    },
    v1WorkbenchApiRequestStatsMultiPeriod: {
      input: 'OpenapiGetV1WorkbenchApiRequestStatsMultiPeriodInput',
    },
    v1WorkbenchCliAuthTokenStatus: {
      input: 'OpenapiGetV1WorkbenchCliAuthTokenStatusInput',
    },
    v1WorkbenchCliDeviceName: {
      input: 'OpenapiGetV1WorkbenchCliDeviceNameInput',
    },
    v1WorkbenchCurrentUser: {
      input: 'OpenapiGetV1WorkbenchCurrentUserInput',
    },
    v1WorkbenchErrorGroups: {
      input: 'OpenapiGetV1WorkbenchErrorGroupsInput',
    },
    v1WorkbenchEventDestinationStats: {
      input: 'OpenapiGetV1WorkbenchEventDestinationStatsInput',
    },
    v1WorkbenchIntegrationMigrationsId: {
      input: 'OpenapiGetV1WorkbenchIntegrationMigrationsIdInput',
    },
    v1WorkbenchIntegrationMigrationsSourcesUsage: {
      input: 'OpenapiGetV1WorkbenchIntegrationMigrationsSourcesUsageInput',
    },
    v1WorkbenchIntegrationMigrationsUsage: {
      input: 'OpenapiGetV1WorkbenchIntegrationMigrationsUsageInput',
    },
    v1WorkbenchMissionControlMission: {
      input: 'OpenapiGetV1WorkbenchMissionControlMissionInput',
    },
    v1WorkbenchOwningMerchant: {
      input: 'OpenapiGetV1WorkbenchOwningMerchantInput',
    },
    v1WorkbenchShellPreviewTree: {
      input: 'OpenapiGetV1WorkbenchShellPreviewTreeInput',
    },
    v1WorkbenchStripecliWebhookSecret: {
      input: 'OpenapiGetV1WorkbenchStripecliWebhookSecretInput',
    },
    v1WorkbenchTestingScenarios: {
      input: 'OpenapiGetV1WorkbenchTestingScenariosInput',
    },
    v1WorkbenchVersionDataSeries: {
      input: 'OpenapiGetV1WorkbenchVersionDataSeriesInput',
    },
    v1WorkbenchWebhookConversationBodies: {
      input: 'OpenapiGetV1WorkbenchWebhookConversationBodiesInput',
    },
    v1WorkbenchWebhookConversations: {
      input: 'OpenapiGetV1WorkbenchWebhookConversationsInput',
    },
    v1WorkbenchWebhookEndpointStats: {
      input: 'OpenapiGetV1WorkbenchWebhookEndpointStatsInput',
    },
    v1WorkbenchWebhookEventTypes: {
      input: 'OpenapiGetV1WorkbenchWebhookEventTypesInput',
    }
  },
  mutations: {
    deleteV1AccountsAccountExternalAccountsId: {
      input: 'OpenapiDeleteV1AccountsAccountExternalAccountsIdInput',
    },
    deleteV1AccountsAccountPersonsPerson: {
      input: 'OpenapiDeleteV1AccountsAccountPersonsPersonInput',
    },
    deleteV1ApprovalsApprovalRulesId: {
      input: 'OpenapiDeleteV1ApprovalsApprovalRulesIdInput',
    },
    deleteV1AppsAppConnectionId: {
      input: 'OpenapiDeleteV1AppsAppConnectionIdInput',
    },
    deleteV1ClimateProgram: {
      input: 'OpenapiDeleteV1ClimateProgramInput',
    },
    deleteV1ConnectInvitationInviteId: {
      input: 'OpenapiDeleteV1ConnectInvitationInviteIdInput',
    },
    deleteV1ConnectPricingGroupsTemplatesPricingTemplate: {
      input: 'OpenapiDeleteV1ConnectPricingGroupsTemplatesPricingTemplateInput',
    },
    deleteV1ConsoleConversationsConversationId: {
      input: 'OpenapiDeleteV1ConsoleConversationsConversationIdInput',
    },
    deleteV1ConsoleMerchantContext: {
      input: 'OpenapiDeleteV1ConsoleMerchantContextInput',
    },
    deleteV1ConsoleSkills: {
      input: 'OpenapiDeleteV1ConsoleSkillsInput',
    },
    deleteV1CurrentUserProfileBackupEmail: {
      input: 'OpenapiDeleteV1CurrentUserProfileBackupEmailInput',
    },
    deleteV1CustomDomainsId: {
      input: 'OpenapiDeleteV1CustomDomainsIdInput',
    },
    deleteV1CustomersCustomer: {
      input: 'OpenapiDeleteV1CustomersCustomerInput',
    },
    deleteV1CustomersCustomerTaxIdsId: {
      input: 'OpenapiDeleteV1CustomersCustomerTaxIdsIdInput',
    },
    deleteV1CustomerSegmentationSavedSegmentsSavedSegment: {
      input: 'OpenapiDeleteV1CustomerSegmentationSavedSegmentsSavedSegmentInput',
    },
    deleteV1DataExplorerGroupsGroup: {
      input: 'OpenapiDeleteV1DataExplorerGroupsGroupInput',
    },
    deleteV1DataExplorerMetricsMetric: {
      input: 'OpenapiDeleteV1DataExplorerMetricsMetricInput',
    },
    deleteV1ExportExportId: {
      input: 'OpenapiDeleteV1ExportExportIdInput',
    },
    deleteV1InvoicesInvoice: {
      input: 'OpenapiDeleteV1InvoicesInvoiceInput',
    },
    deleteV1NotesNote: {
      input: 'OpenapiDeleteV1NotesNoteInput',
    },
    deleteV1PricesPrice: {
      input: 'OpenapiDeleteV1PricesPriceInput',
    },
    deleteV1PricingConfigsPricingTypeSchemesId: {
      input: 'OpenapiDeleteV1PricingConfigsPricingTypeSchemesIdInput',
    },
    deleteV1ProductClassesId: {
      input: 'OpenapiDeleteV1ProductClassesIdInput',
    },
    deleteV1ProductsId: {
      input: 'OpenapiDeleteV1ProductsIdInput',
    },
    deleteV1ProductsProductFeaturesId: {
      input: 'OpenapiDeleteV1ProductsProductFeaturesIdInput',
    },
    deleteV1ProfilesFinancialAccountTransfersConfig: {
      input: 'OpenapiDeleteV1ProfilesFinancialAccountTransfersConfigInput',
    },
    deleteV1RadarMerchantRulesId: {
      input: 'OpenapiDeleteV1RadarMerchantRulesIdInput',
    },
    deleteV1RadarTemplateConfigs: {
      input: 'OpenapiDeleteV1RadarTemplateConfigsInput',
    },
    deleteV1RadarValueListItemsItem: {
      input: 'OpenapiDeleteV1RadarValueListItemsItemInput',
    },
    deleteV1RadarValueListsValueList: {
      input: 'OpenapiDeleteV1RadarValueListsValueListInput',
    },
    deleteV1RevenueRecognitionDataImportJournalEntriesId: {
      input: 'OpenapiDeleteV1RevenueRecognitionDataImportJournalEntriesIdInput',
    },
    deleteV1RevenueStudioCampaignsCampaign: {
      input: 'OpenapiDeleteV1RevenueStudioCampaignsCampaignInput',
    },
    deleteV1RulesRule: {
      input: 'OpenapiDeleteV1RulesRuleInput',
    },
    deleteV1SigmaOrganizationQueryFilesOrganizationQueryFile: {
      input: 'OpenapiDeleteV1SigmaOrganizationQueryFilesOrganizationQueryFileInput',
    },
    deleteV1SigmaQueriesReportingQuery: {
      input: 'OpenapiDeleteV1SigmaQueriesReportingQueryInput',
    },
    deleteV1SigmaReportingQueryFoldersFolderId: {
      input: 'OpenapiDeleteV1SigmaReportingQueryFoldersFolderIdInput',
    },
    deleteV1SigmaScheduledQueriesScheduledQuery: {
      input: 'OpenapiDeleteV1SigmaScheduledQueriesScheduledQueryInput',
    },
    deleteV1SubscriptionsSubscriptionExposedId: {
      input: 'OpenapiDeleteV1SubscriptionsSubscriptionExposedIdInput',
    },
    deleteV1TailorInstallId: {
      input: 'OpenapiDeleteV1TailorInstallIdInput',
    },
    deleteV1TaxFilingEnrollmentApplicationsId: {
      input: 'OpenapiDeleteV1TaxFilingEnrollmentApplicationsIdInput',
    },
    deleteV1TaxRegistrationApplicationsId: {
      input: 'OpenapiDeleteV1TaxRegistrationApplicationsIdInput',
    },
    deleteV1TerminalConfigurationsConfiguration: {
      input: 'OpenapiDeleteV1TerminalConfigurationsConfigurationInput',
    },
    deleteV1TerminalDeviceDeployGroupsDeviceDeployGroup: {
      input: 'OpenapiDeleteV1TerminalDeviceDeployGroupsDeviceDeployGroupInput',
    },
    deleteV1TerminalLocationsLocation: {
      input: 'OpenapiDeleteV1TerminalLocationsLocationInput',
    },
    deleteV1TerminalReadersReader: {
      input: 'OpenapiDeleteV1TerminalReadersReaderInput',
    },
    deleteV1TerminalZonesId: {
      input: 'OpenapiDeleteV1TerminalZonesIdInput',
    },
    deleteV1TestHelpersTestClocksTestClock: {
      input: 'OpenapiDeleteV1TestHelpersTestClocksTestClockInput',
    },
    deleteV1WebhookEndpointsWebhookEndpoint: {
      input: 'OpenapiDeleteV1WebhookEndpointsWebhookEndpointInput',
    },
    putV1ExpressAccountAccountId: {
      input: 'OpenapiPutV1ExpressAccountAccountIdInput',
    },
    putV1RadarTemplateConfigs: {
      input: 'OpenapiPutV1RadarTemplateConfigsInput',
    },
    putV1RealTimeNotificationSettings: {
      input: 'OpenapiPutV1RealTimeNotificationSettingsInput',
    },
    v13pTaxProviderEnableEngine: {
      input: 'OpenapiPostV13pTaxProviderEnableEngineInput',
    },
    v1AadhaarPrivateImport: {
      input: 'OpenapiPostV1AadhaarPrivateImportInput',
    },
    v1AadhaarPrivateStart: {
      input: 'OpenapiPostV1AadhaarPrivateStartInput',
    },
    v1Account: {
      input: 'OpenapiPostV1AccountInput',
    },
    v1AccountBatchPersons: {
      input: 'OpenapiPostV1AccountBatchPersonsInput',
    },
    v1AccountEmailSettingsUpdateAccountEmailSetting: {
      input: 'OpenapiPostV1AccountEmailSettingsUpdateAccountEmailSettingInput',
    },
    v1AccountingJournalSummarizerConfig: {
      input: 'OpenapiPostV1AccountingJournalSummarizerConfigInput',
    },
    v1AccountLinks: {
      input: 'OpenapiPostV1AccountLinksInput',
    },
    v1AccountPersonsPersonIdDocComplete: {
      input: 'OpenapiPostV1AccountPersonsPersonIdDocCompleteInput',
    },
    v1AccountPersonsPersonIdDocTestSubmit: {
      input: 'OpenapiPostV1AccountPersonsPersonIdDocTestSubmitInput',
    },
    v1AccountPersonsPersonIdDocVerify: {
      input: 'OpenapiPostV1AccountPersonsPersonIdDocVerifyInput',
    },
    v1Accounts: {
      input: 'OpenapiPostV1AccountsInput',
    },
    v1AccountsAccount: {
      input: 'OpenapiPostV1AccountsAccountInput',
    },
    v1AccountsAccountBatchPersons: {
      input: 'OpenapiPostV1AccountsAccountBatchPersonsInput',
    },
    v1AccountsAccountCapabilitiesCapability: {
      input: 'OpenapiPostV1AccountsAccountCapabilitiesCapabilityInput',
    },
    v1AccountsAccountExternalAccounts: {
      input: 'OpenapiPostV1AccountsAccountExternalAccountsInput',
    },
    v1AccountsAccountExternalAccountsId: {
      input: 'OpenapiPostV1AccountsAccountExternalAccountsIdInput',
    },
    v1AccountsAccountInvoiceTaxInfoSettings: {
      input: 'OpenapiPostV1AccountsAccountInvoiceTaxInfoSettingsInput',
    },
    v1AccountsAccountLoginLinksWithRedirect: {
      input: 'OpenapiPostV1AccountsAccountLoginLinksWithRedirectInput',
    },
    v1AccountsAccountPersons: {
      input: 'OpenapiPostV1AccountsAccountPersonsInput',
    },
    v1AccountsAccountPersonsPerson: {
      input: 'OpenapiPostV1AccountsAccountPersonsPersonInput',
    },
    v1AccountsAccountReject: {
      input: 'OpenapiPostV1AccountsAccountRejectInput',
    },
    v1AccountSessionsClaim: {
      input: 'OpenapiPostV1AccountSessionsClaimInput',
    },
    v1AccountSuggestions: {
      input: 'OpenapiPostV1AccountSuggestionsInput',
    },
    v1AccountVerificationDocument: {
      input: 'OpenapiPostV1AccountVerificationDocumentInput',
    },
    v1AdaptivePricingDirectConfig: {
      input: 'OpenapiPostV1AdaptivePricingDirectConfigInput',
    },
    v1AdaptivePricingSubaccountConfigsPlatform: {
      input: 'OpenapiPostV1AdaptivePricingSubaccountConfigsPlatformInput',
    },
    v1AdaptivePricingTemplateConfig: {
      input: 'OpenapiPostV1AdaptivePricingTemplateConfigInput',
    },
    v1AgenticCommerceSellerConfig: {
      input: 'OpenapiPostV1AgenticCommerceSellerConfigInput',
    },
    v1ApplicationFeesIdRefunds: {
      input: 'OpenapiPostV1ApplicationFeesIdRefundsInput',
    },
    v1Applications: {
      input: 'OpenapiPostV1ApplicationsInput',
    },
    v1ApplicationsApplicationTokenIntent: {
      input: 'OpenapiPostV1ApplicationsApplicationTokenIntentInput',
    },
    v1ApplicationsApplicationTokenSubmit: {
      input: 'OpenapiPostV1ApplicationsApplicationTokenSubmitInput',
    },
    v1ApprovalsApprovalRequestsApproveId: {
      input: 'OpenapiPostV1ApprovalsApprovalRequestsApproveIdInput',
    },
    v1ApprovalsApprovalRequestsDenyId: {
      input: 'OpenapiPostV1ApprovalsApprovalRequestsDenyIdInput',
    },
    v1ApprovalsApprovalRulesId: {
      input: 'OpenapiPostV1ApprovalsApprovalRulesIdInput',
    },
    v1ApprovalsCreateApprovalRule: {
      input: 'OpenapiPostV1ApprovalsCreateApprovalRuleInput',
    },
    v1ApprovalsDetectApprovalRuleConflict: {
      input: 'OpenapiPostV1ApprovalsDetectApprovalRuleConflictInput',
    },
    v1AppsAppConnection: {
      input: 'OpenapiPostV1AppsAppConnectionInput',
    },
    v1AppsAppEmbeddedKey: {
      input: 'OpenapiPostV1AppsAppEmbeddedKeyInput',
    },
    v1AppsAppEmbeddedSession: {
      input: 'OpenapiPostV1AppsAppEmbeddedSessionInput',
    },
    v1AppsAppIdChannels: {
      input: 'OpenapiPostV1AppsAppIdChannelsInput',
    },
    v1AppsAppIdChannelsChannelIdPublish: {
      input: 'OpenapiPostV1AppsAppIdChannelsChannelIdPublishInput',
    },
    v1AppsAppIdChannelsId: {
      input: 'OpenapiPostV1AppsAppIdChannelsIdInput',
    },
    v1AppsAppIdDynamicClientApplicationsClientIdRevoke: {
      input: 'OpenapiPostV1AppsAppIdDynamicClientApplicationsClientIdRevokeInput',
    },
    v1AppsAppIdUpdate: {
      input: 'OpenapiPostV1AppsAppIdUpdateInput',
    },
    v1AppsInquiries: {
      input: 'OpenapiPostV1AppsInquiriesInput',
    },
    v1AppsInquiriesAppInquiryIdUpdate: {
      input: 'OpenapiPostV1AppsInquiriesAppInquiryIdUpdateInput',
    },
    v1AppsInstalls: {
      input: 'OpenapiPostV1AppsInstallsInput',
    },
    v1AppsInstallsIdUninstall: {
      input: 'OpenapiPostV1AppsInstallsIdUninstallInput',
    },
    v1AppsSecrets: {
      input: 'OpenapiPostV1AppsSecretsInput',
    },
    v1AtlasDeleteApplication: {
      input: 'OpenapiPostV1AtlasDeleteApplicationInput',
    },
    v1AtlasFundraisingBoardConsentBoardMembers: {
      input: 'OpenapiPostV1AtlasFundraisingBoardConsentBoardMembersInput',
    },
    v1AtlasFundraisingBoardConsentTargetRaise: {
      input: 'OpenapiPostV1AtlasFundraisingBoardConsentTargetRaiseInput',
    },
    v1AtlasGenerateFundraisingBoardConsent: {
      input: 'OpenapiPostV1AtlasGenerateFundraisingBoardConsentInput',
    },
    v1AtlasSafeAuthorizedSigner: {
      input: 'OpenapiPostV1AtlasSafeAuthorizedSignerInput',
    },
    v1AtlasSafeInvestor: {
      input: 'OpenapiPostV1AtlasSafeInvestorInput',
    },
    v1AtlasSafeSafeIdUpdate: {
      input: 'OpenapiPostV1AtlasSafeSafeIdUpdateInput',
    },
    v1AtlasSafeSend: {
      input: 'OpenapiPostV1AtlasSafeSendInput',
    },
    v1AtlasSafeTerms: {
      input: 'OpenapiPostV1AtlasSafeTermsInput',
    },
    v1AtlasSkipFundraisingBoardConsent: {
      input: 'OpenapiPostV1AtlasSkipFundraisingBoardConsentInput',
    },
    v1AtlasVoidFundraisingBoardConsent: {
      input: 'OpenapiPostV1AtlasVoidFundraisingBoardConsentInput',
    },
    v1AtlasVoidSafe: {
      input: 'OpenapiPostV1AtlasVoidSafeInput',
    },
    v1AuthChallengesInitiate: {
      input: 'OpenapiPostV1AuthChallengesInitiateInput',
    },
    v1AuthChallengesRequire: {
      input: 'OpenapiPostV1AuthChallengesRequireInput',
    },
    v1AuthChallengesValidate: {
      input: 'OpenapiPostV1AuthChallengesValidateInput',
    },
    v1BalanceSettings: {
      input: 'OpenapiPostV1BalanceSettingsInput',
    },
    v1BalanceTransfers: {
      input: 'OpenapiPostV1BalanceTransfersInput',
    },
    v1BalanceTransfersBalanceTransfer: {
      input: 'OpenapiPostV1BalanceTransfersBalanceTransferInput',
    },
    v1BankAccountsSourceGenerateMicrodeposits: {
      input: 'OpenapiPostV1BankAccountsSourceGenerateMicrodepositsInput',
    },
    v1BankingPrivateBankingTransactionsTransaction: {
      input: 'OpenapiPostV1BankingPrivateBankingTransactionsTransactionInput',
    },
    v1BankingPrivateTreasuryPayout: {
      input: 'OpenapiPostV1BankingPrivateTreasuryPayoutInput',
    },
    v1BankingUnrestrictFinancialAccountFeature: {
      input: 'OpenapiPostV1BankingUnrestrictFinancialAccountFeatureInput',
    },
    v1BillingAlerts: {
      input: 'OpenapiPostV1BillingAlertsInput',
    },
    v1BillingAlertsIdActivate: {
      input: 'OpenapiPostV1BillingAlertsIdActivateInput',
    },
    v1BillingAlertsIdArchive: {
      input: 'OpenapiPostV1BillingAlertsIdArchiveInput',
    },
    v1BillingAlertsIdDeactivate: {
      input: 'OpenapiPostV1BillingAlertsIdDeactivateInput',
    },
    v1BillingCreditGrants: {
      input: 'OpenapiPostV1BillingCreditGrantsInput',
    },
    v1BillingCreditGrantsId: {
      input: 'OpenapiPostV1BillingCreditGrantsIdInput',
    },
    v1BillingCreditGrantsIdExpire: {
      input: 'OpenapiPostV1BillingCreditGrantsIdExpireInput',
    },
    v1BillingCreditGrantsIdVoid: {
      input: 'OpenapiPostV1BillingCreditGrantsIdVoidInput',
    },
    v1BillingMerchantTags: {
      input: 'OpenapiPostV1BillingMerchantTagsInput',
    },
    v1BillingMeterEvents: {
      input: 'OpenapiPostV1BillingMeterEventsInput',
    },
    v1BillingMeterMerchantSettings: {
      input: 'OpenapiPostV1BillingMeterMerchantSettingsInput',
    },
    v1BillingMeters: {
      input: 'OpenapiPostV1BillingMetersInput',
    },
    v1BillingMetersId: {
      input: 'OpenapiPostV1BillingMetersIdInput',
    },
    v1BillingMetersIdDeactivate: {
      input: 'OpenapiPostV1BillingMetersIdDeactivateInput',
    },
    v1BillingMetersIdReactivate: {
      input: 'OpenapiPostV1BillingMetersIdReactivateInput',
    },
    v1BillingOverviewMerchantSettingsVersion: {
      input: 'OpenapiPostV1BillingOverviewMerchantSettingsVersionInput',
    },
    v1BillingOverviewUbbMerchantSettings: {
      input: 'OpenapiPostV1BillingOverviewUbbMerchantSettingsInput',
    },
    v1BillingPolicies: {
      input: 'OpenapiPostV1BillingPoliciesInput',
    },
    v1BillingPortalAccessClientConfirmAccess: {
      input: 'OpenapiPostV1BillingPortalAccessClientConfirmAccessInput',
    },
    v1BillingPortalAccessClientSendAccess: {
      input: 'OpenapiPostV1BillingPortalAccessClientSendAccessInput',
    },
    v1BillingPortalConfigurations: {
      input: 'OpenapiPostV1BillingPortalConfigurationsInput',
    },
    v1BillingPortalConfigurationsConfiguration: {
      input: 'OpenapiPostV1BillingPortalConfigurationsConfigurationInput',
    },
    v1BillingPortalRefundPolicies: {
      input: 'OpenapiPostV1BillingPortalRefundPoliciesInput',
    },
    v1BillingPortalRetentionFlows: {
      input: 'OpenapiPostV1BillingPortalRetentionFlowsInput',
    },
    v1BillingPortalSessionsSessionBillingIntents: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionBillingIntentsInput',
    },
    v1BillingPortalSessionsSessionCustomersCustomer: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionCustomersCustomerInput',
    },
    v1BillingPortalSessionsSessionExpSubscriptionSubscriptionCancelTypeType: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionExpSubscriptionSubscriptionCancelTypeTypeInput',
    },
    v1BillingPortalSessionsSessionExpSubscriptionSubscriptionRetentionCoupon: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionExpSubscriptionSubscriptionRetentionCouponInput',
    },
    v1BillingPortalSessionsSessionExpSubscriptionSubscriptionUpdatePaymentMethod: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionExpSubscriptionSubscriptionUpdatePaymentMethodInput',
    },
    v1BillingPortalSessionsSessionExpSubscriptionSubscriptionUpdateSubscription: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionExpSubscriptionSubscriptionUpdateSubscriptionInput',
    },
    v1BillingPortalSessionsSessionInvoicesInvoicePaymentMethodTypes: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionInvoicesInvoicePaymentMethodTypesInput',
    },
    v1BillingPortalSessionsSessionLogout: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionLogoutInput',
    },
    v1BillingPortalSessionsSessionPaymentIntents: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionPaymentIntentsInput',
    },
    v1BillingPortalSessionsSessionPaymentIntentsPaymentIntentConfirm: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionPaymentIntentsPaymentIntentConfirmInput',
    },
    v1BillingPortalSessionsSessionPaymentMethodsPaymentMethod: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionPaymentMethodsPaymentMethodInput',
    },
    v1BillingPortalSessionsSessionPaymentMethodsPaymentMethodAllowRedisplay: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionPaymentMethodsPaymentMethodAllowRedisplayInput',
    },
    v1BillingPortalSessionsSessionPaymentMethodsPaymentMethodDetach: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionPaymentMethodsPaymentMethodDetachInput',
    },
    v1BillingPortalSessionsSessionPaymentMethodsPaymentMethodRecovery: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionPaymentMethodsPaymentMethodRecoveryInput',
    },
    v1BillingPortalSessionsSessionPricingPlanSubscriptionsPricingPlanSubscriptionIdCancel: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionPricingPlanSubscriptionsPricingPlanSubscriptionIdCancelInput',
    },
    v1BillingPortalSessionsSessionSetupIntents: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionSetupIntentsInput',
    },
    v1BillingPortalSessionsSessionSetupIntentsSetupIntentConfirm: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionSetupIntentsSetupIntentConfirmInput',
    },
    v1BillingPortalSessionsSessionSpecialPurposeSubscriptionsResume: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionSpecialPurposeSubscriptionsResumeInput',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscription: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionSubscriptionsSubscriptionInput',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionCancel: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionSubscriptionsSubscriptionCancelInput',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionCancellationReason: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionSubscriptionsSubscriptionCancellationReasonInput',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionPause: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionSubscriptionsSubscriptionPauseInput',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionPaymentMethodsPaymentMethod: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionSubscriptionsSubscriptionPaymentMethodsPaymentMethodInput',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionReactivate: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionSubscriptionsSubscriptionReactivateInput',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionRelease: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionSubscriptionsSubscriptionReleaseInput',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionRemovePaymentOverride: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionSubscriptionsSubscriptionRemovePaymentOverrideInput',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionResume: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionSubscriptionsSubscriptionResumeInput',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionRetainSubscriptionCustomer: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionSubscriptionsSubscriptionRetainSubscriptionCustomerInput',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionRetentionFlowSession: {
      input: 'OpenapiPostV1BillingPortalSessionsSessionSubscriptionsSubscriptionRetentionFlowSessionInput',
    },
    v1BulkActionDisconnectFinancialConnectionsAccount: {
      input: 'OpenapiPostV1BulkActionDisconnectFinancialConnectionsAccountInput',
    },
    v1BulkActionRequestFinancialConnectionsHostedRelink: {
      input: 'OpenapiPostV1BulkActionRequestFinancialConnectionsHostedRelinkInput',
    },
    v1BulkOnboardingUpdateAccount: {
      input: 'OpenapiPostV1BulkOnboardingUpdateAccountInput',
    },
    v1BuyButtons: {
      input: 'OpenapiPostV1BuyButtonsInput',
    },
    v1BuyButtonsBuyButton: {
      input: 'OpenapiPostV1BuyButtonsBuyButtonInput',
    },
    v1CapitalActionRequiredId: {
      input: 'OpenapiPostV1CapitalActionRequiredIdInput',
    },
    v1CapitalAdditionalUnderwritingRequest: {
      input: 'OpenapiPostV1CapitalAdditionalUnderwritingRequestInput',
    },
    v1CapitalAdditionalUnderwritingRequestsCancel: {
      input: 'OpenapiPostV1CapitalAdditionalUnderwritingRequestsCancelInput',
    },
    v1CapitalConnectContractSign: {
      input: 'OpenapiPostV1CapitalConnectContractSignInput',
    },
    v1CapitalConnectEnableDefaultSettings: {
      input: 'OpenapiPostV1CapitalConnectEnableDefaultSettingsInput',
    },
    v1CapitalConnectPartnerProgramsCreateOrUpdateFromBusinessIntents: {
      input: 'OpenapiPostV1CapitalConnectPartnerProgramsCreateOrUpdateFromBusinessIntentsInput',
    },
    v1CapitalEmbeddedAccountLinks: {
      input: 'OpenapiPostV1CapitalEmbeddedAccountLinksInput',
    },
    v1CapitalFinancingOffersFinancingOfferChargeOff: {
      input: 'OpenapiPostV1CapitalFinancingOffersFinancingOfferChargeOffInput',
    },
    v1CapitalFinancingOffersFinancingOfferDeliverOffer: {
      input: 'OpenapiPostV1CapitalFinancingOffersFinancingOfferDeliverOfferInput',
    },
    v1CapitalFinancingOffersFinancingOfferExpire: {
      input: 'OpenapiPostV1CapitalFinancingOffersFinancingOfferExpireInput',
    },
    v1CapitalFinancingOffersFinancingOfferFullyRepay: {
      input: 'OpenapiPostV1CapitalFinancingOffersFinancingOfferFullyRepayInput',
    },
    v1CapitalFinancingOffersFinancingOfferMarkDelivered: {
      input: 'OpenapiPostV1CapitalFinancingOffersFinancingOfferMarkDeliveredInput',
    },
    v1CapitalFinancingOffersFinancingOfferMintDurableLink: {
      input: 'OpenapiPostV1CapitalFinancingOffersFinancingOfferMintDurableLinkInput',
    },
    v1CapitalFinancingOffersFinancingOfferPayout: {
      input: 'OpenapiPostV1CapitalFinancingOffersFinancingOfferPayoutInput',
    },
    v1CapitalFinancingOffersFinancingOfferRequestDisbursal: {
      input: 'OpenapiPostV1CapitalFinancingOffersFinancingOfferRequestDisbursalInput',
    },
    v1CapitalFinancingOffersFinancingOfferRevokeV2: {
      input: 'OpenapiPostV1CapitalFinancingOffersFinancingOfferRevokeV2Input',
    },
    v1CapitalFinancingOffersFinancingOfferUpgrade: {
      input: 'OpenapiPostV1CapitalFinancingOffersFinancingOfferUpgradeInput',
    },
    v1CapitalFinancingOffersOnDemand: {
      input: 'OpenapiPostV1CapitalFinancingOffersOnDemandInput',
    },
    v1CapitalFinancingOffersTestMode: {
      input: 'OpenapiPostV1CapitalFinancingOffersTestModeInput',
    },
    v1CapitalImports: {
      input: 'OpenapiPostV1CapitalImportsInput',
    },
    v1CapitalImportsImportBundleTransition: {
      input: 'OpenapiPostV1CapitalImportsImportBundleTransitionInput',
    },
    v1CapitalLendingNetworkCreatePartnerApplicationWorkflow: {
      input: 'OpenapiPostV1CapitalLendingNetworkCreatePartnerApplicationWorkflowInput',
    },
    v1CapitalMerchantSettings: {
      input: 'OpenapiPostV1CapitalMerchantSettingsInput',
    },
    v1CapitalMultiDrawSubsequentDrawOffers: {
      input: 'OpenapiPostV1CapitalMultiDrawSubsequentDrawOffersInput',
    },
    v1CapitalOfferApplicationsOfferApplication: {
      input: 'OpenapiPostV1CapitalOfferApplicationsOfferApplicationInput',
    },
    v1CapitalOfferApplicationsOfferApplicationSubmit: {
      input: 'OpenapiPostV1CapitalOfferApplicationsOfferApplicationSubmitInput',
    },
    v1CapitalOfferApplicationsOfferInitiate: {
      input: 'OpenapiPostV1CapitalOfferApplicationsOfferInitiateInput',
    },
    v1CapitalOffersOfferOfferDocuments: {
      input: 'OpenapiPostV1CapitalOffersOfferOfferDocumentsInput',
    },
    v1CapitalPlatformsMerchantSettings: {
      input: 'OpenapiPostV1CapitalPlatformsMerchantSettingsInput',
    },
    v1CapitalSbfeConsent: {
      input: 'OpenapiPostV1CapitalSbfeConsentInput',
    },
    v1CapitalYouLendAcceptanceWorkflow: {
      input: 'OpenapiPostV1CapitalYouLendAcceptanceWorkflowInput',
    },
    v1CashAdvancesCashAdvanceAccept: {
      input: 'OpenapiPostV1CashAdvancesCashAdvanceAcceptInput',
    },
    v1CashAdvancesCashAdvancePaydowns: {
      input: 'OpenapiPostV1CashAdvancesCashAdvancePaydownsInput',
    },
    v1ChargesCharge: {
      input: 'OpenapiPostV1ChargesChargeInput',
    },
    v1ChargesChargeCapture: {
      input: 'OpenapiPostV1ChargesChargeCaptureInput',
    },
    v1CheckoutSessions: {
      input: 'OpenapiPostV1CheckoutSessionsInput',
    },
    v1CheckoutSessionsSession: {
      input: 'OpenapiPostV1CheckoutSessionsSessionInput',
    },
    v1ClimateAutogenDraftSettingsPublish: {
      input: 'OpenapiPostV1ClimateAutogenDraftSettingsPublishInput',
    },
    v1ClimateAutogenDraftSettingsUpdate: {
      input: 'OpenapiPostV1ClimateAutogenDraftSettingsUpdateInput',
    },
    v1ClimateAutogenLiveSettingsDisable: {
      input: 'OpenapiPostV1ClimateAutogenLiveSettingsDisableInput',
    },
    v1ClimateAutogenLiveSettingsEnable: {
      input: 'OpenapiPostV1ClimateAutogenLiveSettingsEnableInput',
    },
    v1ClimateBadge: {
      input: 'OpenapiPostV1ClimateBadgeInput',
    },
    v1ClimateBrandSettings: {
      input: 'OpenapiPostV1ClimateBrandSettingsInput',
    },
    v1ClimateConnectPlatformConfig: {
      input: 'OpenapiPostV1ClimateConnectPlatformConfigInput',
    },
    v1ClimateOrders: {
      input: 'OpenapiPostV1ClimateOrdersInput',
    },
    v1ClimateOrdersOrder: {
      input: 'OpenapiPostV1ClimateOrdersOrderInput',
    },
    v1ClimateOrdersOrderCancel: {
      input: 'OpenapiPostV1ClimateOrdersOrderCancelInput',
    },
    v1ClimateProgram: {
      input: 'OpenapiPostV1ClimateProgramInput',
    },
    v1ClimateSignupState: {
      input: 'OpenapiPostV1ClimateSignupStateInput',
    },
    v1ClimateSignupStateActivate: {
      input: 'OpenapiPostV1ClimateSignupStateActivateInput',
    },
    v1ClimateWaitlistEntry: {
      input: 'OpenapiPostV1ClimateWaitlistEntryInput',
    },
    v1CloseOwnAccount: {
      input: 'OpenapiPostV1CloseOwnAccountInput',
    },
    v1CommunicationManagementAddEmailDestination: {
      input: 'OpenapiPostV1CommunicationManagementAddEmailDestinationInput',
    },
    v1CommunicationManagementAddSubscriptionRecipient: {
      input: 'OpenapiPostV1CommunicationManagementAddSubscriptionRecipientInput',
    },
    v1CommunicationManagementBulkAddSubscriptionRecipient: {
      input: 'OpenapiPostV1CommunicationManagementBulkAddSubscriptionRecipientInput',
    },
    v1CommunicationManagementClearEmailDestinationBounce: {
      input: 'OpenapiPostV1CommunicationManagementClearEmailDestinationBounceInput',
    },
    v1CommunicationManagementDeleteEmailDestination: {
      input: 'OpenapiPostV1CommunicationManagementDeleteEmailDestinationInput',
    },
    v1CommunicationManagementDeleteSubscriptionRecipient: {
      input: 'OpenapiPostV1CommunicationManagementDeleteSubscriptionRecipientInput',
    },
    v1CommunicationManagementResendEmailDestinationVerification: {
      input: 'OpenapiPostV1CommunicationManagementResendEmailDestinationVerificationInput',
    },
    v1ConnectAccountGroupsCsv: {
      input: 'OpenapiPostV1ConnectAccountGroupsCsvInput',
    },
    v1ConnectAccountGroupsCsvValidate: {
      input: 'OpenapiPostV1ConnectAccountGroupsCsvValidateInput',
    },
    v1ConnectAccountNotes: {
      input: 'OpenapiPostV1ConnectAccountNotesInput',
    },
    v1ConnectAccountsV2EnableAutoprojections: {
      input: 'OpenapiPostV1ConnectAccountsV2EnableAutoprojectionsInput',
    },
    v1ConnectAccountsV2GateMerchantIntoBeta: {
      input: 'OpenapiPostV1ConnectAccountsV2GateMerchantIntoBetaInput',
    },
    v1ConnectAccountsV2OptOut: {
      input: 'OpenapiPostV1ConnectAccountsV2OptOutInput',
    },
    v1ConnectAccountsV2RequestV2AccountsFasttrack: {
      input: 'OpenapiPostV1ConnectAccountsV2RequestV2AccountsFasttrackInput',
    },
    v1ConnectAgenticCommerceConfigSubaccountConfig: {
      input: 'OpenapiPostV1ConnectAgenticCommerceConfigSubaccountConfigInput',
    },
    v1ConnectAgenticCommerceConfigTemplateConfig: {
      input: 'OpenapiPostV1ConnectAgenticCommerceConfigTemplateConfigInput',
    },
    v1ConnectAuthRequiresExternalAccountVerification: {
      input: 'OpenapiPostV1ConnectAuthRequiresExternalAccountVerificationInput',
    },
    v1ConnectCommsCenterAccountsAccount: {
      input: 'OpenapiPostV1ConnectCommsCenterAccountsAccountInput',
    },
    v1ConnectCommsCenterCsvValidation: {
      input: 'OpenapiPostV1ConnectCommsCenterCsvValidationInput',
    },
    v1ConnectCommsCenterPlatformCommunicationsTemplateOption: {
      input: 'OpenapiPostV1ConnectCommsCenterPlatformCommunicationsTemplateOptionInput',
    },
    v1ConnectCommsCenterSendTestEmail: {
      input: 'OpenapiPostV1ConnectCommsCenterSendTestEmailInput',
    },
    v1ConnectCommsCenterUpdateEmails: {
      input: 'OpenapiPostV1ConnectCommsCenterUpdateEmailsInput',
    },
    v1ConnectCommsCenterUrlsRoute: {
      input: 'OpenapiPostV1ConnectCommsCenterUrlsRouteInput',
    },
    v1ConnectCompleteOnboarding: {
      input: 'OpenapiPostV1ConnectCompleteOnboardingInput',
    },
    v1ConnectCreateDirectifySecret: {
      input: 'OpenapiPostV1ConnectCreateDirectifySecretInput',
    },
    v1ConnectCreateLoginLinks: {
      input: 'OpenapiPostV1ConnectCreateLoginLinksInput',
    },
    v1ConnectExpressInstantPayouts: {
      input: 'OpenapiPostV1ConnectExpressInstantPayoutsInput',
    },
    v1ConnectExternalAccountChallengeChallengeToken: {
      input: 'OpenapiPostV1ConnectExternalAccountChallengeChallengeTokenInput',
    },
    v1ConnectExternalAccountCode: {
      input: 'OpenapiPostV1ConnectExternalAccountCodeInput',
    },
    v1ConnectExternalAccountCodeVerify: {
      input: 'OpenapiPostV1ConnectExternalAccountCodeVerifyInput',
    },
    v1ConnectGrossSettlementConfig: {
      input: 'OpenapiPostV1ConnectGrossSettlementConfigInput',
    },
    v1ConnectIdentityChallenge: {
      input: 'OpenapiPostV1ConnectIdentityChallengeInput',
    },
    v1ConnectIntegrationPlatformAttestationItem: {
      input: 'OpenapiPostV1ConnectIntegrationPlatformAttestationItemInput',
    },
    v1ConnectInviteNewOwnerMerchant: {
      input: 'OpenapiPostV1ConnectInviteNewOwnerMerchantInput',
    },
    v1ConnectionsDisconnectAccounts: {
      input: 'OpenapiPostV1ConnectionsDisconnectAccountsInput',
    },
    v1ConnectionsLinkAccountSessions: {
      input: 'OpenapiPostV1ConnectionsLinkAccountSessionsInput',
    },
    v1ConnectionsOffersOfferAccept: {
      input: 'OpenapiPostV1ConnectionsOffersOfferAcceptInput',
    },
    v1ConnectionsRecipientOnboardingConfiguration: {
      input: 'OpenapiPostV1ConnectionsRecipientOnboardingConfigurationInput',
    },
    v1ConnectionsTokens: {
      input: 'OpenapiPostV1ConnectionsTokensInput',
    },
    v1ConnectNoCodeInstantPayoutsSubaccountConfigConnectedAccountId: {
      input: 'OpenapiPostV1ConnectNoCodeInstantPayoutsSubaccountConfigConnectedAccountIdInput',
    },
    v1ConnectNoCodeInstantPayoutsTemplateConfig: {
      input: 'OpenapiPostV1ConnectNoCodeInstantPayoutsTemplateConfigInput',
    },
    v1ConnectPricingGroupsSubaccountPricingGroup: {
      input: 'OpenapiPostV1ConnectPricingGroupsSubaccountPricingGroupInput',
    },
    v1ConnectPricingGroupsTemplates: {
      input: 'OpenapiPostV1ConnectPricingGroupsTemplatesInput',
    },
    v1ConnectPricingGroupsTemplatesPricingTemplate: {
      input: 'OpenapiPostV1ConnectPricingGroupsTemplatesPricingTemplateInput',
    },
    v1ConnectReonboardingValidateCsv: {
      input: 'OpenapiPostV1ConnectReonboardingValidateCsvInput',
    },
    v1ConnectResendVerificationEmail: {
      input: 'OpenapiPostV1ConnectResendVerificationEmailInput',
    },
    v1ConnectResendVerificationPhone: {
      input: 'OpenapiPostV1ConnectResendVerificationPhoneInput',
    },
    v1ConnectRiskAndComplianceSettings: {
      input: 'OpenapiPostV1ConnectRiskAndComplianceSettingsInput',
    },
    v1ConnectSessionAuthAttempt: {
      input: 'OpenapiPostV1ConnectSessionAuthAttemptInput',
    },
    v1ConnectSessionAuthAttemptVerify: {
      input: 'OpenapiPostV1ConnectSessionAuthAttemptVerifyInput',
    },
    v1ConnectTransferExpressAccountOwnership: {
      input: 'OpenapiPostV1ConnectTransferExpressAccountOwnershipInput',
    },
    v1ConnectUseLegalEntityAllLegalEntity: {
      input: 'OpenapiPostV1ConnectUseLegalEntityAllLegalEntityInput',
    },
    v1ConnectUserUpdateEmail: {
      input: 'OpenapiPostV1ConnectUserUpdateEmailInput',
    },
    v1ConnectUserUpdatePhoneNumber: {
      input: 'OpenapiPostV1ConnectUserUpdatePhoneNumberInput',
    },
    v1ConnectUserUpdatePhoneNumberChallenge: {
      input: 'OpenapiPostV1ConnectUserUpdatePhoneNumberChallengeInput',
    },
    v1ConnectVerifyPhone: {
      input: 'OpenapiPostV1ConnectVerifyPhoneInput',
    },
    v1ConnectW8W9CollectionW8: {
      input: 'OpenapiPostV1ConnectW8W9CollectionW8Input',
    },
    v1ConnectW8W9CollectionW8W9PlatformConfig: {
      input: 'OpenapiPostV1ConnectW8W9CollectionW8W9PlatformConfigInput',
    },
    v1ConnectW8W9CollectionW9: {
      input: 'OpenapiPostV1ConnectW8W9CollectionW9Input',
    },
    v1Console: {
      input: 'OpenapiPostV1ConsoleInput',
    },
    v1ConsoleMerchantContext: {
      input: 'OpenapiPostV1ConsoleMerchantContextInput',
    },
    v1ConsoleMerchantContextBackfill: {
      input: 'OpenapiPostV1ConsoleMerchantContextBackfillInput',
    },
    v1ConsoleSkills: {
      input: 'OpenapiPostV1ConsoleSkillsInput',
    },
    v1ControlledContentEvent: {
      input: 'OpenapiPostV1ControlledContentEventInput',
    },
    v1Coupons: {
      input: 'OpenapiPostV1CouponsInput',
    },
    v1CreateCompliancePdf: {
      input: 'OpenapiPostV1CreateCompliancePdfInput',
    },
    v1CreatePaymentsConfig: {
      input: 'OpenapiPostV1CreatePaymentsConfigInput',
    },
    v1CreditNotes: {
      input: 'OpenapiPostV1CreditNotesInput',
    },
    v1CryptoInternalPayinSessionConfirm: {
      input: 'OpenapiPostV1CryptoInternalPayinSessionConfirmInput',
    },
    v1CryptoInternalPayinSessionCryptoPayinSessionAllocateDepositAddress: {
      input: 'OpenapiPostV1CryptoInternalPayinSessionCryptoPayinSessionAllocateDepositAddressInput',
    },
    v1CryptoInternalPayinSessionPrepare: {
      input: 'OpenapiPostV1CryptoInternalPayinSessionPrepareInput',
    },
    v1CryptoInternalPayinSessionUpdate: {
      input: 'OpenapiPostV1CryptoInternalPayinSessionUpdateInput',
    },
    v1CryptoInternalPersonLookup: {
      input: 'OpenapiPostV1CryptoInternalPersonLookupInput',
    },
    v1CryptoInternalPersonPopulate: {
      input: 'OpenapiPostV1CryptoInternalPersonPopulateInput',
    },
    v1CryptoInternalSetupSessionCryptoSetupSessionConfirm: {
      input: 'OpenapiPostV1CryptoInternalSetupSessionCryptoSetupSessionConfirmInput',
    },
    v1CryptoInternalSetupSessionCryptoSetupSessionPrepare: {
      input: 'OpenapiPostV1CryptoInternalSetupSessionCryptoSetupSessionPrepareInput',
    },
    v1CryptoInternalSetupSessionCryptoSetupSessionUpdate: {
      input: 'OpenapiPostV1CryptoInternalSetupSessionCryptoSetupSessionUpdateInput',
    },
    v1CurrentUserContactPhoneNumber: {
      input: 'OpenapiPostV1CurrentUserContactPhoneNumberInput',
    },
    v1CurrentUserContactPhoneNumberConfirm: {
      input: 'OpenapiPostV1CurrentUserContactPhoneNumberConfirmInput',
    },
    v1CurrentUserProfileBackupEmail: {
      input: 'OpenapiPostV1CurrentUserProfileBackupEmailInput',
    },
    v1CurrentUserProfileDeferredInterrupt: {
      input: 'OpenapiPostV1CurrentUserProfileDeferredInterruptInput',
    },
    v1CustomDomains: {
      input: 'OpenapiPostV1CustomDomainsInput',
    },
    v1CustomDomainsId: {
      input: 'OpenapiPostV1CustomDomainsIdInput',
    },
    v1Customers: {
      input: 'OpenapiPostV1CustomersInput',
    },
    v1CustomersBlockedBillingAddressCountries: {
      input: 'OpenapiPostV1CustomersBlockedBillingAddressCountriesInput',
    },
    v1CustomersCustomer: {
      input: 'OpenapiPostV1CustomersCustomerInput',
    },
    v1CustomersCustomerCashBalance: {
      input: 'OpenapiPostV1CustomersCustomerCashBalanceInput',
    },
    v1CustomersCustomerCashBalanceTransfers: {
      input: 'OpenapiPostV1CustomersCustomerCashBalanceTransfersInput',
    },
    v1CustomersCustomerFundingInstructions: {
      input: 'OpenapiPostV1CustomersCustomerFundingInstructionsInput',
    },
    v1CustomersCustomerTaxIds: {
      input: 'OpenapiPostV1CustomersCustomerTaxIdsInput',
    },
    v1CustomerSegmentationPromptToSql: {
      input: 'OpenapiPostV1CustomerSegmentationPromptToSqlInput',
    },
    v1CustomerSegmentationSavedSegments: {
      input: 'OpenapiPostV1CustomerSegmentationSavedSegmentsInput',
    },
    v1CustomerSegmentationSavedSegmentsSavedSegment: {
      input: 'OpenapiPostV1CustomerSegmentationSavedSegmentsSavedSegmentInput',
    },
    v1DashboardFxQuotes: {
      input: 'OpenapiPostV1DashboardFxQuotesInput',
    },
    v1DashboardMulticurrencySettlementBulkUpdate: {
      input: 'OpenapiPostV1DashboardMulticurrencySettlementBulkUpdateInput',
    },
    v1DashboardOnboardingExistingMerchantSetup: {
      input: 'OpenapiPostV1DashboardOnboardingExistingMerchantSetupInput',
    },
    v1DashboardOnboardingStripeProfileOnboardingTaskSetup: {
      input: 'OpenapiPostV1DashboardOnboardingStripeProfileOnboardingTaskSetupInput',
    },
    v1DashboardSettingsBillingMode: {
      input: 'OpenapiPostV1DashboardSettingsBillingModeInput',
    },
    v1DashboardSettingsBillingNotifications: {
      input: 'OpenapiPostV1DashboardSettingsBillingNotificationsInput',
    },
    v1DashboardVolumeLimitIncreaseRequest: {
      input: 'OpenapiPostV1DashboardVolumeLimitIncreaseRequestInput',
    },
    v1DataExplorerGroups: {
      input: 'OpenapiPostV1DataExplorerGroupsInput',
    },
    v1DataExplorerGroupsGroup: {
      input: 'OpenapiPostV1DataExplorerGroupsGroupInput',
    },
    v1DataExplorerMetrics: {
      input: 'OpenapiPostV1DataExplorerMetricsInput',
    },
    v1DataExplorerMetricsMetric: {
      input: 'OpenapiPostV1DataExplorerMetricsMetricInput',
    },
    v1DataManagementImportSets: {
      input: 'OpenapiPostV1DataManagementImportSetsInput',
    },
    v1DataManagementImportSetsIdArchive: {
      input: 'OpenapiPostV1DataManagementImportSetsIdArchiveInput',
    },
    v1DataStudioStartSdpTrial: {
      input: 'OpenapiPostV1DataStudioStartSdpTrialInput',
    },
    v1DataStudioSubscribeTrial: {
      input: 'OpenapiPostV1DataStudioSubscribeTrialInput',
    },
    v1DisputeEvidenceSubmissionsSettings: {
      input: 'OpenapiPostV1DisputeEvidenceSubmissionsSettingsInput',
    },
    v1DisputesDispute: {
      input: 'OpenapiPostV1DisputesDisputeInput',
    },
    v1DisputesDisputeClose: {
      input: 'OpenapiPostV1DisputesDisputeCloseInput',
    },
    v1DisputesDisputeInternalEscalate: {
      input: 'OpenapiPostV1DisputesDisputeInternalEscalateInput',
    },
    v1DisputesInternalAutoRepresentmentSettingDirectConfig: {
      input: 'OpenapiPostV1DisputesInternalAutoRepresentmentSettingDirectConfigInput',
    },
    v1DisputesInternalAutoRepresentmentSettingSubaccountConfigsPlatform: {
      input: 'OpenapiPostV1DisputesInternalAutoRepresentmentSettingSubaccountConfigsPlatformInput',
    },
    v1DisputesInternalAutoRepresentmentSettingTemplateConfig: {
      input: 'OpenapiPostV1DisputesInternalAutoRepresentmentSettingTemplateConfigInput',
    },
    v1DisputesInternalEvidenceLibraryUpsertRecord: {
      input: 'OpenapiPostV1DisputesInternalEvidenceLibraryUpsertRecordInput',
    },
    v1DisputesInternalPreventionActivateEnrollment: {
      input: 'OpenapiPostV1DisputesInternalPreventionActivateEnrollmentInput',
    },
    v1DisputesInternalPreventionUpdateMerchantSettings: {
      input: 'OpenapiPostV1DisputesInternalPreventionUpdateMerchantSettingsInput',
    },
    v1DomainVerifier: {
      input: 'OpenapiPostV1DomainVerifierInput',
    },
    v1EmbeddedAuthenticationLinks: {
      input: 'OpenapiPostV1EmbeddedAuthenticationLinksInput',
    },
    v1EmbeddedCreateInstantPayout: {
      input: 'OpenapiPostV1EmbeddedCreateInstantPayoutInput',
    },
    v1EmbeddedCreatePrefundingBalancePayout: {
      input: 'OpenapiPostV1EmbeddedCreatePrefundingBalancePayoutInput',
    },
    v1EmbeddedCreateStandardPayout: {
      input: 'OpenapiPostV1EmbeddedCreateStandardPayoutInput',
    },
    v1EmbeddedPaymentEphemeralKey: {
      input: 'OpenapiPostV1EmbeddedPaymentEphemeralKeyInput',
    },
    v1EmbeddedSurfaces: {
      input: 'OpenapiPostV1EmbeddedSurfacesInput',
    },
    v1EntitlementsFeatures: {
      input: 'OpenapiPostV1EntitlementsFeaturesInput',
    },
    v1EntitlementsFeaturesId: {
      input: 'OpenapiPostV1EntitlementsFeaturesIdInput',
    },
    v1EventsIdRetry: {
      input: 'OpenapiPostV1EventsIdRetryInput',
    },
    v1Export: {
      input: 'OpenapiPostV1ExportInput',
    },
    v1FacilitatedCommercePermissionedKey: {
      input: 'OpenapiPostV1FacilitatedCommercePermissionedKeyInput',
    },
    v1FacilitatedCommercePermissionGrants: {
      input: 'OpenapiPostV1FacilitatedCommercePermissionGrantsInput',
    },
    v1FacilitatedCommercePermissionGrantsRevoke: {
      input: 'OpenapiPostV1FacilitatedCommercePermissionGrantsRevokeInput',
    },
    v1FacilitatedCommerceProducts: {
      input: 'OpenapiPostV1FacilitatedCommerceProductsInput',
    },
    v1FeeCreditsActivate: {
      input: 'OpenapiPostV1FeeCreditsActivateInput',
    },
    v1FileLinks: {
      input: 'OpenapiPostV1FileLinksInput',
    },
    v1FinancialConnectionsAccountsAccountDisconnect: {
      input: 'OpenapiPostV1FinancialConnectionsAccountsAccountDisconnectInput',
    },
    v1FinancialConnectionsAccountsAccountHostedRelink: {
      input: 'OpenapiPostV1FinancialConnectionsAccountsAccountHostedRelinkInput',
    },
    v1FlexLoansFlexLoanPaydowns: {
      input: 'OpenapiPostV1FlexLoansFlexLoanPaydownsInput',
    },
    v1FortunaUpdateInvoicingEligibility: {
      input: 'OpenapiPostV1FortunaUpdateInvoicingEligibilityInput',
    },
    v1FrMealVouchersSiretInfo: {
      input: 'OpenapiPostV1FrMealVouchersSiretInfoInput',
    },
    v1FrMealVouchersSiretInfoId: {
      input: 'OpenapiPostV1FrMealVouchersSiretInfoIdInput',
    },
    v1GiftCardsCards: {
      input: 'OpenapiPostV1GiftCardsCardsInput',
    },
    v1GiftCardsCardsId: {
      input: 'OpenapiPostV1GiftCardsCardsIdInput',
    },
    v1GiftCardsCardsValidate: {
      input: 'OpenapiPostV1GiftCardsCardsValidateInput',
    },
    v1GiftCardsTransactions: {
      input: 'OpenapiPostV1GiftCardsTransactionsInput',
    },
    v1GlobalTaxReportingPlatformSettings: {
      input: 'OpenapiPostV1GlobalTaxReportingPlatformSettingsInput',
    },
    v1GlobalTaxReportingReportReportId: {
      input: 'OpenapiPostV1GlobalTaxReportingReportReportIdInput',
    },
    v1GuestCustomersGuestCustomerRedact: {
      input: 'OpenapiPostV1GuestCustomersGuestCustomerRedactInput',
    },
    v1GuidedFlowGetOrCreateFlowId: {
      input: 'OpenapiPostV1GuidedFlowGetOrCreateFlowIdInput',
    },
    v1GuidedFlowNextStepId: {
      input: 'OpenapiPostV1GuidedFlowNextStepIdInput',
    },
    v1IamRoleAssignmentsPrincipal: {
      input: 'OpenapiPostV1IamRoleAssignmentsPrincipalInput',
    },
    v1IdentityVerificationEntityTypeCheck: {
      input: 'OpenapiPostV1IdentityVerificationEntityTypeCheckInput',
    },
    v1IdentityVerificationSessions: {
      input: 'OpenapiPostV1IdentityVerificationSessionsInput',
    },
    v1IdentityVerificationSessionsSession: {
      input: 'OpenapiPostV1IdentityVerificationSessionsSessionInput',
    },
    v1IdentityVerificationSessionsSessionCancel: {
      input: 'OpenapiPostV1IdentityVerificationSessionsSessionCancelInput',
    },
    v1IdentityVerificationSessionsSessionRedact: {
      input: 'OpenapiPostV1IdentityVerificationSessionsSessionRedactInput',
    },
    v1IdentityVerificationTemplates: {
      input: 'OpenapiPostV1IdentityVerificationTemplatesInput',
    },
    v1IdentityVerificationTemplatesTemplate: {
      input: 'OpenapiPostV1IdentityVerificationTemplatesTemplateInput',
    },
    v1IdentityVerificationTemplatesTemplateActivate: {
      input: 'OpenapiPostV1IdentityVerificationTemplatesTemplateActivateInput',
    },
    v1IdentityVerificationTemplatesTemplateDeactivate: {
      input: 'OpenapiPostV1IdentityVerificationTemplatesTemplateDeactivateInput',
    },
    v1InternalRubyWriteFirst: {
      input: 'OpenapiPostV1InternalRubyWriteFirstInput',
    },
    v1Inventories: {
      input: 'OpenapiPostV1InventoriesInput',
    },
    v1InventoriesId: {
      input: 'OpenapiPostV1InventoriesIdInput',
    },
    v1InventoriesIdAdjust: {
      input: 'OpenapiPostV1InventoriesIdAdjustInput',
    },
    v1InventoriesIdRestock: {
      input: 'OpenapiPostV1InventoriesIdRestockInput',
    },
    v1InviteATeammate: {
      input: 'OpenapiPostV1InviteATeammateInput',
    },
    v1Invoiceitems: {
      input: 'OpenapiPostV1InvoiceitemsInput',
    },
    v1InvoiceRenderingTemplates: {
      input: 'OpenapiPostV1InvoiceRenderingTemplatesInput',
    },
    v1InvoiceRenderingTemplatesTemplate: {
      input: 'OpenapiPostV1InvoiceRenderingTemplatesTemplateInput',
    },
    v1InvoiceRenderingTemplatesTemplateApply: {
      input: 'OpenapiPostV1InvoiceRenderingTemplatesTemplateApplyInput',
    },
    v1InvoiceRenderingTemplatesTemplateArchive: {
      input: 'OpenapiPostV1InvoiceRenderingTemplatesTemplateArchiveInput',
    },
    v1InvoiceRenderingTemplatesTemplateUnarchive: {
      input: 'OpenapiPostV1InvoiceRenderingTemplatesTemplateUnarchiveInput',
    },
    v1Invoices: {
      input: 'OpenapiPostV1InvoicesInput',
    },
    v1InvoicesInvoice: {
      input: 'OpenapiPostV1InvoicesInvoiceInput',
    },
    v1InvoicesInvoiceAttachPayment: {
      input: 'OpenapiPostV1InvoicesInvoiceAttachPaymentInput',
    },
    v1InvoicesInvoiceAttachPaymentIntent: {
      input: 'OpenapiPostV1InvoicesInvoiceAttachPaymentIntentInput',
    },
    v1InvoicesInvoiceDetachPayment: {
      input: 'OpenapiPostV1InvoicesInvoiceDetachPaymentInput',
    },
    v1InvoicesInvoiceFinalize: {
      input: 'OpenapiPostV1InvoicesInvoiceFinalizeInput',
    },
    v1InvoicesInvoiceMarkUncollectible: {
      input: 'OpenapiPostV1InvoicesInvoiceMarkUncollectibleInput',
    },
    v1InvoicesInvoicePay: {
      input: 'OpenapiPostV1InvoicesInvoicePayInput',
    },
    v1InvoicesInvoiceSend: {
      input: 'OpenapiPostV1InvoicesInvoiceSendInput',
    },
    v1InvoicesInvoiceVoid: {
      input: 'OpenapiPostV1InvoicesInvoiceVoidInput',
    },
    v1IssuingAftenrollmentEnroll: {
      input: 'OpenapiPostV1IssuingAftenrollmentEnrollInput',
    },
    v1IssuingAftenrollmentUnenroll: {
      input: 'OpenapiPostV1IssuingAftenrollmentUnenrollInput',
    },
    v1IssuingAuthorizationsAuthorization: {
      input: 'OpenapiPostV1IssuingAuthorizationsAuthorizationInput',
    },
    v1IssuingCardholders: {
      input: 'OpenapiPostV1IssuingCardholdersInput',
    },
    v1IssuingCardholdersCardholder: {
      input: 'OpenapiPostV1IssuingCardholdersCardholderInput',
    },
    v1IssuingCardholdersCardholderRedact: {
      input: 'OpenapiPostV1IssuingCardholdersCardholderRedactInput',
    },
    v1IssuingCards: {
      input: 'OpenapiPostV1IssuingCardsInput',
    },
    v1IssuingCardsCard: {
      input: 'OpenapiPostV1IssuingCardsCardInput',
    },
    v1IssuingCardsCardInitiateApplePayWebProvisioning: {
      input: 'OpenapiPostV1IssuingCardsCardInitiateApplePayWebProvisioningInput',
    },
    v1IssuingCardsCardInitiateGooglePayWebProvisioning: {
      input: 'OpenapiPostV1IssuingCardsCardInitiateGooglePayWebProvisioningInput',
    },
    v1IssuingCardsCardRedact: {
      input: 'OpenapiPostV1IssuingCardsCardRedactInput',
    },
    v1IssuingDisputes: {
      input: 'OpenapiPostV1IssuingDisputesInput',
    },
    v1IssuingDisputesDispute: {
      input: 'OpenapiPostV1IssuingDisputesDisputeInput',
    },
    v1IssuingDisputesDisputeSubmit: {
      input: 'OpenapiPostV1IssuingDisputesDisputeSubmitInput',
    },
    v1IssuingDualOnboardOntoFinancialAccountIssuingMastercard: {
      input: 'OpenapiPostV1IssuingDualOnboardOntoFinancialAccountIssuingMastercardInput',
    },
    v1IssuingOnboardingApplicationSubmit: {
      input: 'OpenapiPostV1IssuingOnboardingApplicationSubmitInput',
    },
    v1IssuingOnboardOntoDirectFinancialAccountIssuing: {
      input: 'OpenapiPostV1IssuingOnboardOntoDirectFinancialAccountIssuingInput',
    },
    v1IssuingPersonalizationDesigns: {
      input: 'OpenapiPostV1IssuingPersonalizationDesignsInput',
    },
    v1IssuingPersonalizationDesignsPersonalizationDesign: {
      input: 'OpenapiPostV1IssuingPersonalizationDesignsPersonalizationDesignInput',
    },
    v1IssuingProgramsProgram: {
      input: 'OpenapiPostV1IssuingProgramsProgramInput',
    },
    v1IssuingReceipts: {
      input: 'OpenapiPostV1IssuingReceiptsInput',
    },
    v1IssuingTransactionsTransaction: {
      input: 'OpenapiPostV1IssuingTransactionsTransactionInput',
    },
    v1LpmDashboardSettingsFinancingPackageDetailsUpdateAffirmPackage: {
      input: 'OpenapiPostV1LpmDashboardSettingsFinancingPackageDetailsUpdateAffirmPackageInput',
    },
    v1ManagedPaymentsMerchantSettings: {
      input: 'OpenapiPostV1ManagedPaymentsMerchantSettingsInput',
    },
    v1ManagedPaymentsTermsOfService: {
      input: 'OpenapiPostV1ManagedPaymentsTermsOfServiceInput',
    },
    v1MyinfoPrivateImport: {
      input: 'OpenapiPostV1MyinfoPrivateImportInput',
    },
    v1MyinfoPrivateStart: {
      input: 'OpenapiPostV1MyinfoPrivateStartInput',
    },
    v1Notes: {
      input: 'OpenapiPostV1NotesInput',
    },
    v1NotesNote: {
      input: 'OpenapiPostV1NotesNoteInput',
    },
    v1OrdersIdFulfill: {
      input: 'OpenapiPostV1OrdersIdFulfillInput',
    },
    v1PaperChecksIdReconcile: {
      input: 'OpenapiPostV1PaperChecksIdReconcileInput',
    },
    v1PaymentIntents: {
      input: 'OpenapiPostV1PaymentIntentsInput',
    },
    v1PaymentIntentsIntent: {
      input: 'OpenapiPostV1PaymentIntentsIntentInput',
    },
    v1PaymentIntentsIntentApplyCustomerBalance: {
      input: 'OpenapiPostV1PaymentIntentsIntentApplyCustomerBalanceInput',
    },
    v1PaymentIntentsIntentCancel: {
      input: 'OpenapiPostV1PaymentIntentsIntentCancelInput',
    },
    v1PaymentIntentsIntentCapture: {
      input: 'OpenapiPostV1PaymentIntentsIntentCaptureInput',
    },
    v1PaymentIntentsIntentConfirm: {
      input: 'OpenapiPostV1PaymentIntentsIntentConfirmInput',
    },
    v1PaymentLinks: {
      input: 'OpenapiPostV1PaymentLinksInput',
    },
    v1PaymentLinksPaymentLink: {
      input: 'OpenapiPostV1PaymentLinksPaymentLinkInput',
    },
    v1PaymentLinksPaymentLinkCopy: {
      input: 'OpenapiPostV1PaymentLinksPaymentLinkCopyInput',
    },
    v1PaymentLinksPaymentLinkLineItemsCopy: {
      input: 'OpenapiPostV1PaymentLinksPaymentLinkLineItemsCopyInput',
    },
    v1PaymentMethodConfigurationsConfiguration: {
      input: 'OpenapiPostV1PaymentMethodConfigurationsConfigurationInput',
    },
    v1PaymentMethodDomains: {
      input: 'OpenapiPostV1PaymentMethodDomainsInput',
    },
    v1PaymentMethodDomainsPaymentMethodDomain: {
      input: 'OpenapiPostV1PaymentMethodDomainsPaymentMethodDomainInput',
    },
    v1PaymentMethodDomainsPaymentMethodDomainValidate: {
      input: 'OpenapiPostV1PaymentMethodDomainsPaymentMethodDomainValidateInput',
    },
    v1PaymentMethods: {
      input: 'OpenapiPostV1PaymentMethodsInput',
    },
    v1PaymentMethodsPaymentMethod: {
      input: 'OpenapiPostV1PaymentMethodsPaymentMethodInput',
    },
    v1PaymentMethodsPaymentMethodDetach: {
      input: 'OpenapiPostV1PaymentMethodsPaymentMethodDetachInput',
    },
    v1PaymentOptimizerSettings: {
      input: 'OpenapiPostV1PaymentOptimizerSettingsInput',
    },
    v1PaymentOrchestrationRoutingRoutingExtensionIdActivate: {
      input: 'OpenapiPostV1PaymentOrchestrationRoutingRoutingExtensionIdActivateInput',
    },
    v1PaymentOrchestrationRoutingRoutingExtensionIdDeactivate: {
      input: 'OpenapiPostV1PaymentOrchestrationRoutingRoutingExtensionIdDeactivateInput',
    },
    v1PaymentRecordsReportPayment: {
      input: 'OpenapiPostV1PaymentRecordsReportPaymentInput',
    },
    v1PaymentsConfig: {
      input: 'OpenapiPostV1PaymentsConfigInput',
    },
    v1Payouts: {
      input: 'OpenapiPostV1PayoutsInput',
    },
    v1PayoutsPayout: {
      input: 'OpenapiPostV1PayoutsPayoutInput',
    },
    v1PayoutsSettingsBankToPayoutReconciliation: {
      input: 'OpenapiPostV1PayoutsSettingsBankToPayoutReconciliationInput',
    },
    v1PersonVerificationRequest: {
      input: 'OpenapiPostV1PersonVerificationRequestInput',
    },
    v1PlatformExtension: {
      input: 'OpenapiPostV1PlatformExtensionInput',
    },
    v1PlatformOnboardingVerificationSession: {
      input: 'OpenapiPostV1PlatformOnboardingVerificationSessionInput',
    },
    v1PmonboardingPmonboardingFormConfig: {
      input: 'OpenapiPostV1PmonboardingPmonboardingFormConfigInput',
    },
    v1PocDocumentValidationValidate: {
      input: 'OpenapiPostV1PocDocumentValidationValidateInput',
    },
    v1Prices: {
      input: 'OpenapiPostV1PricesInput',
    },
    v1PricesPrice: {
      input: 'OpenapiPostV1PricesPriceInput',
    },
    v1PricingConfigsPricingTypeSchemes: {
      input: 'OpenapiPostV1PricingConfigsPricingTypeSchemesInput',
    },
    v1PricingTables: {
      input: 'OpenapiPostV1PricingTablesInput',
    },
    v1PricingTablesPricingTable: {
      input: 'OpenapiPostV1PricingTablesPricingTableInput',
    },
    v1ProductCatalogTrialOffers: {
      input: 'OpenapiPostV1ProductCatalogTrialOffersInput',
    },
    v1ProductClasses: {
      input: 'OpenapiPostV1ProductClassesInput',
    },
    v1ProductClassesId: {
      input: 'OpenapiPostV1ProductClassesIdInput',
    },
    v1Products: {
      input: 'OpenapiPostV1ProductsInput',
    },
    v1ProductsId: {
      input: 'OpenapiPostV1ProductsIdInput',
    },
    v1ProductsIdCopy: {
      input: 'OpenapiPostV1ProductsIdCopyInput',
    },
    v1ProductsProductFeatures: {
      input: 'OpenapiPostV1ProductsProductFeaturesInput',
    },
    v1ProductSuggestions: {
      input: 'OpenapiPostV1ProductSuggestionsInput',
    },
    v1Profiles: {
      input: 'OpenapiPostV1ProfilesInput',
    },
    v1ProfilesFinancialAccountTransfersConfig: {
      input: 'OpenapiPostV1ProfilesFinancialAccountTransfersConfigInput',
    },
    v1ProfilesFinancialAccountTransfersRecipient: {
      input: 'OpenapiPostV1ProfilesFinancialAccountTransfersRecipientInput',
    },
    v1ProfilesFlag: {
      input: 'OpenapiPostV1ProfilesFlagInput',
    },
    v1ProfilesNetworkId: {
      input: 'OpenapiPostV1ProfilesNetworkIdInput',
    },
    v1ProvisioningMerchantPrepare: {
      input: 'OpenapiPostV1ProvisioningMerchantPrepareInput',
    },
    v1Quotes: {
      input: 'OpenapiPostV1QuotesInput',
    },
    v1QuotesQuote: {
      input: 'OpenapiPostV1QuotesQuoteInput',
    },
    v1QuotesQuoteAccept: {
      input: 'OpenapiPostV1QuotesQuoteAcceptInput',
    },
    v1QuotesQuoteCancel: {
      input: 'OpenapiPostV1QuotesQuoteCancelInput',
    },
    v1QuotesQuoteFinalize: {
      input: 'OpenapiPostV1QuotesQuoteFinalizeInput',
    },
    v1RadarApplyRiskPreference: {
      input: 'OpenapiPostV1RadarApplyRiskPreferenceInput',
    },
    v1RadarCustomCountersConfiguration: {
      input: 'OpenapiPostV1RadarCustomCountersConfigurationInput',
    },
    v1RadarMerchantRulesActivateRuleId: {
      input: 'OpenapiPostV1RadarMerchantRulesActivateRuleIdInput',
    },
    v1RadarMerchantRulesId: {
      input: 'OpenapiPostV1RadarMerchantRulesIdInput',
    },
    v1RadarMerchantRulesMerchantRuleIdFanouts: {
      input: 'OpenapiPostV1RadarMerchantRulesMerchantRuleIdFanoutsInput',
    },
    v1RadarMerchantRulesRadarGptSendMessage: {
      input: 'OpenapiPostV1RadarMerchantRulesRadarGptSendMessageInput',
    },
    v1RadarPaymentEvaluations: {
      input: 'OpenapiPostV1RadarPaymentEvaluationsInput',
    },
    v1RadarRiskControlUpdateSettings: {
      input: 'OpenapiPostV1RadarRiskControlUpdateSettingsInput',
    },
    v1RadarSendUnderAttackMessage: {
      input: 'OpenapiPostV1RadarSendUnderAttackMessageInput',
    },
    v1RadarSmartThreedsUpdateSettings: {
      input: 'OpenapiPostV1RadarSmartThreedsUpdateSettingsInput',
    },
    v1RadarTemplateConfigs: {
      input: 'OpenapiPostV1RadarTemplateConfigsInput',
    },
    v1RadarValueListItems: {
      input: 'OpenapiPostV1RadarValueListItemsInput',
    },
    v1RadarValueListItemsItemRedact: {
      input: 'OpenapiPostV1RadarValueListItemsItemRedactInput',
    },
    v1RadarValueLists: {
      input: 'OpenapiPostV1RadarValueListsInput',
    },
    v1RadarValueListsValueList: {
      input: 'OpenapiPostV1RadarValueListsValueListInput',
    },
    v1Refunds: {
      input: 'OpenapiPostV1RefundsInput',
    },
    v1RefundsRefund: {
      input: 'OpenapiPostV1RefundsRefundInput',
    },
    v1RefundsRefundCancel: {
      input: 'OpenapiPostV1RefundsRefundCancelInput',
    },
    v1ReportingMultiEntityReportRuns: {
      input: 'OpenapiPostV1ReportingMultiEntityReportRunsInput',
    },
    v1ReportingReportRuns: {
      input: 'OpenapiPostV1ReportingReportRunsInput',
    },
    v1ReserveHolds: {
      input: 'OpenapiPostV1ReserveHoldsInput',
    },
    v1ReserveHoldsId: {
      input: 'OpenapiPostV1ReserveHoldsIdInput',
    },
    v1ReservePlans: {
      input: 'OpenapiPostV1ReservePlansInput',
    },
    v1ReservePlansId: {
      input: 'OpenapiPostV1ReservePlansIdInput',
    },
    v1ReservePlansIdDisable: {
      input: 'OpenapiPostV1ReservePlansIdDisableInput',
    },
    v1ReserveReleases: {
      input: 'OpenapiPostV1ReserveReleasesInput',
    },
    v1RetrieveMerchantCustomerMarketingPreferencesCapabilitySlug: {
      input: 'OpenapiPostV1RetrieveMerchantCustomerMarketingPreferencesCapabilitySlugInput',
    },
    v1RetryPolicies: {
      input: 'OpenapiPostV1RetryPoliciesInput',
    },
    v1RetryPoliciesRetryPolicy: {
      input: 'OpenapiPostV1RetryPoliciesRetryPolicyInput',
    },
    v1RevenueStudioCampaigns: {
      input: 'OpenapiPostV1RevenueStudioCampaignsInput',
    },
    v1RevenueStudioCampaignsCampaign: {
      input: 'OpenapiPostV1RevenueStudioCampaignsCampaignInput',
    },
    v1ReviewsReviewApprove: {
      input: 'OpenapiPostV1ReviewsReviewApproveInput',
    },
    v1ReviewsReviewAssign: {
      input: 'OpenapiPostV1ReviewsReviewAssignInput',
    },
    v1ReviewsReviewClose: {
      input: 'OpenapiPostV1ReviewsReviewCloseInput',
    },
    v1ReviewsReviewForwardToWebhook: {
      input: 'OpenapiPostV1ReviewsReviewForwardToWebhookInput',
    },
    v1RisaComplianceSurvey: {
      input: 'OpenapiPostV1RisaComplianceSurveyInput',
    },
    v1RiskChallengesCreateFinancialConnectionResponse: {
      input: 'OpenapiPostV1RiskChallengesCreateFinancialConnectionResponseInput',
    },
    v1RiskChallengesSaveProductDescriptionIfSufficient: {
      input: 'OpenapiPostV1RiskChallengesSaveProductDescriptionIfSufficientInput',
    },
    v1RiskChallengesStripeVerifiedAccept: {
      input: 'OpenapiPostV1RiskChallengesStripeVerifiedAcceptInput',
    },
    v1RiskDashboardForms: {
      input: 'OpenapiPostV1RiskDashboardFormsInput',
    },
    v1RiskDashboardFormsByName: {
      input: 'OpenapiPostV1RiskDashboardFormsByNameInput',
    },
    v1RiskDefinedInterventionsGetOrCreate: {
      input: 'OpenapiPostV1RiskDefinedInterventionsGetOrCreateInput',
    },
    v1RiskRequirements: {
      input: 'OpenapiPostV1RiskRequirementsInput',
    },
    v1RiskStripeVerifiedCreateAndLinkSupportCase: {
      input: 'OpenapiPostV1RiskStripeVerifiedCreateAndLinkSupportCaseInput',
    },
    v1RiskUrlRequirementReevaluate: {
      input: 'OpenapiPostV1RiskUrlRequirementReevaluateInput',
    },
    v1Rules: {
      input: 'OpenapiPostV1RulesInput',
    },
    v1RulesRule: {
      input: 'OpenapiPostV1RulesRuleInput',
    },
    v1ScaleSetupIntents: {
      input: 'OpenapiPostV1ScaleSetupIntentsInput',
    },
    v1SettingsCustomerCashBalanceDefaultReconciliationMode: {
      input: 'OpenapiPostV1SettingsCustomerCashBalanceDefaultReconciliationModeInput',
    },
    v1SettingsDebitsSettlement: {
      input: 'OpenapiPostV1SettingsDebitsSettlementInput',
    },
    v1SettingsFasterSettlement: {
      input: 'OpenapiPostV1SettingsFasterSettlementInput',
    },
    v1SettingsTaxInfo: {
      input: 'OpenapiPostV1SettingsTaxInfoInput',
    },
    v1SetupIntents: {
      input: 'OpenapiPostV1SetupIntentsInput',
    },
    v1SetupIntentsIntent: {
      input: 'OpenapiPostV1SetupIntentsIntentInput',
    },
    v1ShardedOnboardingDeleteRequest: {
      input: 'OpenapiPostV1ShardedOnboardingDeleteRequestInput',
    },
    v1ShardedOnboardingSubmitEmail: {
      input: 'OpenapiPostV1ShardedOnboardingSubmitEmailInput',
    },
    v1ShareableMetrics: {
      input: 'OpenapiPostV1ShareableMetricsInput',
    },
    v1ShippingRates: {
      input: 'OpenapiPostV1ShippingRatesInput',
    },
    v1SigmaAssistantMessage: {
      input: 'OpenapiPostV1SigmaAssistantMessageInput',
    },
    v1SigmaOrganizationQueries: {
      input: 'OpenapiPostV1SigmaOrganizationQueriesInput',
    },
    v1SigmaOrganizationQueriesOrganizationQueryCancel: {
      input: 'OpenapiPostV1SigmaOrganizationQueriesOrganizationQueryCancelInput',
    },
    v1SigmaOrganizationQueryFiles: {
      input: 'OpenapiPostV1SigmaOrganizationQueryFilesInput',
    },
    v1SigmaOrganizationQueryFilesOrganizationQueryFile: {
      input: 'OpenapiPostV1SigmaOrganizationQueryFilesOrganizationQueryFileInput',
    },
    v1SigmaOrganizationQueryFilesOrganizationQueryFileSubscribe: {
      input: 'OpenapiPostV1SigmaOrganizationQueryFilesOrganizationQueryFileSubscribeInput',
    },
    v1SigmaOrganizationQueryFilesOrganizationQueryFileUnsubscribe: {
      input: 'OpenapiPostV1SigmaOrganizationQueryFilesOrganizationQueryFileUnsubscribeInput',
    },
    v1SigmaQueries: {
      input: 'OpenapiPostV1SigmaQueriesInput',
    },
    v1SigmaQueriesReportingQueryExportToSdp: {
      input: 'OpenapiPostV1SigmaQueriesReportingQueryExportToSdpInput',
    },
    v1SigmaReportingQueryFolders: {
      input: 'OpenapiPostV1SigmaReportingQueryFoldersInput',
    },
    v1SigmaReportingQueryFoldersFolderId: {
      input: 'OpenapiPostV1SigmaReportingQueryFoldersFolderIdInput',
    },
    v1SigmaScheduledQueries: {
      input: 'OpenapiPostV1SigmaScheduledQueriesInput',
    },
    v1SigmaScheduledQueriesScheduledQuery: {
      input: 'OpenapiPostV1SigmaScheduledQueriesScheduledQueryInput',
    },
    v1SigmaVisualizations: {
      input: 'OpenapiPostV1SigmaVisualizationsInput',
    },
    v1SigmaVisualizationsVisualizationId: {
      input: 'OpenapiPostV1SigmaVisualizationsVisualizationIdInput',
    },
    v1StripeDataPipelineActivateExportPlan: {
      input: 'OpenapiPostV1StripeDataPipelineActivateExportPlanInput',
    },
    v1StripeDataPipelineCreateExportPlan: {
      input: 'OpenapiPostV1StripeDataPipelineCreateExportPlanInput',
    },
    v1StripeDataPipelineDeactivateExportPlan: {
      input: 'OpenapiPostV1StripeDataPipelineDeactivateExportPlanInput',
    },
    v1StripeDataPipelineUpdateContactEmail: {
      input: 'OpenapiPostV1StripeDataPipelineUpdateContactEmailInput',
    },
    v1StripeVerifiedRequest: {
      input: 'OpenapiPostV1StripeVerifiedRequestInput',
    },
    v1Subscriptions: {
      input: 'OpenapiPostV1SubscriptionsInput',
    },
    v1SubscriptionSchedules: {
      input: 'OpenapiPostV1SubscriptionSchedulesInput',
    },
    v1SubscriptionSchedulesSchedule: {
      input: 'OpenapiPostV1SubscriptionSchedulesScheduleInput',
    },
    v1SubscriptionSchedulesScheduleCancel: {
      input: 'OpenapiPostV1SubscriptionSchedulesScheduleCancelInput',
    },
    v1SubscriptionSchedulesScheduleRelease: {
      input: 'OpenapiPostV1SubscriptionSchedulesScheduleReleaseInput',
    },
    v1SubscriptionsSubscriptionAttachCadence: {
      input: 'OpenapiPostV1SubscriptionsSubscriptionAttachCadenceInput',
    },
    v1SubscriptionsSubscriptionExposedId: {
      input: 'OpenapiPostV1SubscriptionsSubscriptionExposedIdInput',
    },
    v1SubscriptionsSubscriptionMigrate: {
      input: 'OpenapiPostV1SubscriptionsSubscriptionMigrateInput',
    },
    v1SubscriptionsSubscriptionResume: {
      input: 'OpenapiPostV1SubscriptionsSubscriptionResumeInput',
    },
    v1SupportEmail: {
      input: 'OpenapiPostV1SupportEmailInput',
    },
    v1TailorAppBuildVersionAppBuildVersionIdUpdate: {
      input: 'OpenapiPostV1TailorAppBuildVersionAppBuildVersionIdUpdateInput',
    },
    v1TailorInstall: {
      input: 'OpenapiPostV1TailorInstallInput',
    },
    v1TailorRotateBackendSecretPublicId: {
      input: 'OpenapiPostV1TailorRotateBackendSecretPublicIdInput',
    },
    v1TailorTermsAcceptance: {
      input: 'OpenapiPostV1TailorTermsAcceptanceInput',
    },
    v1TaxConnectorsShopifyOauthAuthorize: {
      input: 'OpenapiPostV1TaxConnectorsShopifyOauthAuthorizeInput',
    },
    v1TaxConnectorsShopifyOauthVerify: {
      input: 'OpenapiPostV1TaxConnectorsShopifyOauthVerifyInput',
    },
    v1TaxDocumentsChallenge1099Tin: {
      input: 'OpenapiPostV1TaxDocumentsChallenge1099TinInput',
    },
    v1TaxDocumentsDownloadTypeToken: {
      input: 'OpenapiPostV1TaxDocumentsDownloadTypeTokenInput',
    },
    v1TaxFilingEnrollmentApplications: {
      input: 'OpenapiPostV1TaxFilingEnrollmentApplicationsInput',
    },
    v1TaxFilingEnrollmentApplicationsId: {
      input: 'OpenapiPostV1TaxFilingEnrollmentApplicationsIdInput',
    },
    v1TaxFilingEnrollmentApplicationsIdSubmit: {
      input: 'OpenapiPostV1TaxFilingEnrollmentApplicationsIdSubmitInput',
    },
    v1TaxFilingEnrollmentApplicationsIdUpdateSubmitted: {
      input: 'OpenapiPostV1TaxFilingEnrollmentApplicationsIdUpdateSubmittedInput',
    },
    v1TaxFilingEnrollmentPartnerAccountsCreate: {
      input: 'OpenapiPostV1TaxFilingEnrollmentPartnerAccountsCreateInput',
    },
    v1TaxLocations: {
      input: 'OpenapiPostV1TaxLocationsInput',
    },
    v1TaxOnboardingSettingsRetrieveOrCreate: {
      input: 'OpenapiPostV1TaxOnboardingSettingsRetrieveOrCreateInput',
    },
    v1TaxOnboardingSettingsUpdate: {
      input: 'OpenapiPostV1TaxOnboardingSettingsUpdateInput',
    },
    v1TaxPlatformSettingsUpdate: {
      input: 'OpenapiPostV1TaxPlatformSettingsUpdateInput',
    },
    v1TaxProductSettingsTaxCodeAssistantAfterSave: {
      input: 'OpenapiPostV1TaxProductSettingsTaxCodeAssistantAfterSaveInput',
    },
    v1TaxProductSettingsTaxCodeAssistantFeedback: {
      input: 'OpenapiPostV1TaxProductSettingsTaxCodeAssistantFeedbackInput',
    },
    v1TaxProductSettingsTaxCodeAssistantSearch: {
      input: 'OpenapiPostV1TaxProductSettingsTaxCodeAssistantSearchInput',
    },
    v1TaxProductThresholdNotificationOptIn: {
      input: 'OpenapiPostV1TaxProductThresholdNotificationOptInInput',
    },
    v1TaxProductThresholdNotificationPreferences: {
      input: 'OpenapiPostV1TaxProductThresholdNotificationPreferencesInput',
    },
    v1TaxRegistrationApplications: {
      input: 'OpenapiPostV1TaxRegistrationApplicationsInput',
    },
    v1TaxRegistrationApplicationsId: {
      input: 'OpenapiPostV1TaxRegistrationApplicationsIdInput',
    },
    v1TaxRegistrationApplicationsIdSubmit: {
      input: 'OpenapiPostV1TaxRegistrationApplicationsIdSubmitInput',
    },
    v1TaxRegistrations: {
      input: 'OpenapiPostV1TaxRegistrationsInput',
    },
    v1TaxRegistrationsId: {
      input: 'OpenapiPostV1TaxRegistrationsIdInput',
    },
    v1TaxReportingFatcaCrsForm: {
      input: 'OpenapiPostV1TaxReportingFatcaCrsFormInput',
    },
    v1TaxSettings: {
      input: 'OpenapiPostV1TaxSettingsInput',
    },
    v1TaxSignupStateActivate: {
      input: 'OpenapiPostV1TaxSignupStateActivateInput',
    },
    v1TaxSignupStateRetrieveOrCreate: {
      input: 'OpenapiPostV1TaxSignupStateRetrieveOrCreateInput',
    },
    v1TaxSignupStateUpdate: {
      input: 'OpenapiPostV1TaxSignupStateUpdateInput',
    },
    v1TerminalConfigurations: {
      input: 'OpenapiPostV1TerminalConfigurationsInput',
    },
    v1TerminalConfigurationsConfiguration: {
      input: 'OpenapiPostV1TerminalConfigurationsConfigurationInput',
    },
    v1TerminalConfigurationsConfigurationReportAdminMenuPasscodeViewed: {
      input: 'OpenapiPostV1TerminalConfigurationsConfigurationReportAdminMenuPasscodeViewedInput',
    },
    v1TerminalDeployPlans: {
      input: 'OpenapiPostV1TerminalDeployPlansInput',
    },
    v1TerminalDeployPlansDeployPlanActivate: {
      input: 'OpenapiPostV1TerminalDeployPlansDeployPlanActivateInput',
    },
    v1TerminalDeployPlansDeployPlanAdvance: {
      input: 'OpenapiPostV1TerminalDeployPlansDeployPlanAdvanceInput',
    },
    v1TerminalDeployPlansDeployPlanPause: {
      input: 'OpenapiPostV1TerminalDeployPlansDeployPlanPauseInput',
    },
    v1TerminalDeviceAssets: {
      input: 'OpenapiPostV1TerminalDeviceAssetsInput',
    },
    v1TerminalDeviceAssetVersions: {
      input: 'OpenapiPostV1TerminalDeviceAssetVersionsInput',
    },
    v1TerminalDeviceDeployGroups: {
      input: 'OpenapiPostV1TerminalDeviceDeployGroupsInput',
    },
    v1TerminalDeviceDeployGroupsDeviceDeployGroup: {
      input: 'OpenapiPostV1TerminalDeviceDeployGroupsDeviceDeployGroupInput',
    },
    v1TerminalHardwareOrdersConnectConfigurationsDefault: {
      input: 'OpenapiPostV1TerminalHardwareOrdersConnectConfigurationsDefaultInput',
    },
    v1TerminalHardwareOrdersConnectConfigurationsIdSkuCatalog: {
      input: 'OpenapiPostV1TerminalHardwareOrdersConnectConfigurationsIdSkuCatalogInput',
    },
    v1TerminalHardwareOrdersCreateValidatedCalculatedOrderAndPaymentIntent: {
      input: 'OpenapiPostV1TerminalHardwareOrdersCreateValidatedCalculatedOrderAndPaymentIntentInput',
    },
    v1TerminalHardwareOrdersHardwareOrderCancel: {
      input: 'OpenapiPostV1TerminalHardwareOrdersHardwareOrderCancelInput',
    },
    v1TerminalHardwareOrdersSkuNotificationSignup: {
      input: 'OpenapiPostV1TerminalHardwareOrdersSkuNotificationSignupInput',
    },
    v1TerminalHardwareWarrantyClaimsTerminalHardwareWarrantyClaimHardwareWarrantyClaimItems: {
      input: 'OpenapiPostV1TerminalHardwareWarrantyClaimsTerminalHardwareWarrantyClaimHardwareWarrantyClaimItemsInput',
    },
    v1TerminalLocationCapabilitiesCapability: {
      input: 'OpenapiPostV1TerminalLocationCapabilitiesCapabilityInput',
    },
    v1TerminalLocations: {
      input: 'OpenapiPostV1TerminalLocationsInput',
    },
    v1TerminalLocationsLocation: {
      input: 'OpenapiPostV1TerminalLocationsLocationInput',
    },
    v1TerminalReaders: {
      input: 'OpenapiPostV1TerminalReadersInput',
    },
    v1TerminalReadersReader: {
      input: 'OpenapiPostV1TerminalReadersReaderInput',
    },
    v1TerminalReadersReaderAdminOperations: {
      input: 'OpenapiPostV1TerminalReadersReaderAdminOperationsInput',
    },
    v1TerminalReportsExternalCsvReportEmails: {
      input: 'OpenapiPostV1TerminalReportsExternalCsvReportEmailsInput',
    },
    v1TerminalZones: {
      input: 'OpenapiPostV1TerminalZonesInput',
    },
    v1TerminalZonesId: {
      input: 'OpenapiPostV1TerminalZonesIdInput',
    },
    v1TestHelpersCapitalFinancingOffersFinancingOfferTransactionIntents: {
      input: 'OpenapiPostV1TestHelpersCapitalFinancingOffersFinancingOfferTransactionIntentsInput',
    },
    v1TestHelpersCapitalFinancingOffersFinancingOfferTransactions: {
      input: 'OpenapiPostV1TestHelpersCapitalFinancingOffersFinancingOfferTransactionsInput',
    },
    v1TestHelpersCapitalLineOfCreditCreateOrRefresh: {
      input: 'OpenapiPostV1TestHelpersCapitalLineOfCreditCreateOrRefreshInput',
    },
    v1TestHelpersCapitalTransactionIntentsTransactionIntentFail: {
      input: 'OpenapiPostV1TestHelpersCapitalTransactionIntentsTransactionIntentFailInput',
    },
    v1TestHelpersCapitalTransactionIntentsTransactionIntentSettle: {
      input: 'OpenapiPostV1TestHelpersCapitalTransactionIntentsTransactionIntentSettleInput',
    },
    v1TestHelpersCapitalTransactionsTransactionReverse: {
      input: 'OpenapiPostV1TestHelpersCapitalTransactionsTransactionReverseInput',
    },
    v1TestHelpersClimateOrdersOrderDelay: {
      input: 'OpenapiPostV1TestHelpersClimateOrdersOrderDelayInput',
    },
    v1TestHelpersClimateOrdersOrderDeliver: {
      input: 'OpenapiPostV1TestHelpersClimateOrdersOrderDeliverInput',
    },
    v1TestHelpersDelegatedCheckoutRequestedSessions: {
      input: 'OpenapiPostV1TestHelpersDelegatedCheckoutRequestedSessionsInput',
    },
    v1TestHelpersDelegatedCheckoutRequestedSessionsRequestedSession: {
      input: 'OpenapiPostV1TestHelpersDelegatedCheckoutRequestedSessionsRequestedSessionInput',
    },
    v1TestHelpersDelegatedCheckoutRequestedSessionsRequestedSessionConfirm: {
      input: 'OpenapiPostV1TestHelpersDelegatedCheckoutRequestedSessionsRequestedSessionConfirmInput',
    },
    v1TestHelpersDemoMerchantIssue: {
      input: 'OpenapiPostV1TestHelpersDemoMerchantIssueInput',
    },
    v1TestHelpersIssuingAuthorizations: {
      input: 'OpenapiPostV1TestHelpersIssuingAuthorizationsInput',
    },
    v1TestHelpersIssuingAuthorizationsAuthorizationCapture: {
      input: 'OpenapiPostV1TestHelpersIssuingAuthorizationsAuthorizationCaptureInput',
    },
    v1TestHelpersIssuingAuthorizationsAuthorizationExpire: {
      input: 'OpenapiPostV1TestHelpersIssuingAuthorizationsAuthorizationExpireInput',
    },
    v1TestHelpersIssuingAuthorizationsAuthorizationIncrement: {
      input: 'OpenapiPostV1TestHelpersIssuingAuthorizationsAuthorizationIncrementInput',
    },
    v1TestHelpersIssuingAuthorizationsAuthorizationReverse: {
      input: 'OpenapiPostV1TestHelpersIssuingAuthorizationsAuthorizationReverseInput',
    },
    v1TestHelpersIssuingAuthorizationsExpireId: {
      input: 'OpenapiPostV1TestHelpersIssuingAuthorizationsExpireIdInput',
    },
    v1TestHelpersIssuingCaptures: {
      input: 'OpenapiPostV1TestHelpersIssuingCapturesInput',
    },
    v1TestHelpersIssuingCardsCardShippingDeliver: {
      input: 'OpenapiPostV1TestHelpersIssuingCardsCardShippingDeliverInput',
    },
    v1TestHelpersIssuingCardsCardShippingFail: {
      input: 'OpenapiPostV1TestHelpersIssuingCardsCardShippingFailInput',
    },
    v1TestHelpersIssuingCardsCardShippingReturn: {
      input: 'OpenapiPostV1TestHelpersIssuingCardsCardShippingReturnInput',
    },
    v1TestHelpersIssuingCardsCardShippingShip: {
      input: 'OpenapiPostV1TestHelpersIssuingCardsCardShippingShipInput',
    },
    v1TestHelpersIssuingPersonalizationDesignsPersonalizationDesignActivate: {
      input: 'OpenapiPostV1TestHelpersIssuingPersonalizationDesignsPersonalizationDesignActivateInput',
    },
    v1TestHelpersIssuingPersonalizationDesignsPersonalizationDesignDeactivate: {
      input: 'OpenapiPostV1TestHelpersIssuingPersonalizationDesignsPersonalizationDesignDeactivateInput',
    },
    v1TestHelpersIssuingPersonalizationDesignsPersonalizationDesignReject: {
      input: 'OpenapiPostV1TestHelpersIssuingPersonalizationDesignsPersonalizationDesignRejectInput',
    },
    v1TestHelpersIssuingTransactionsCreateForceCapture: {
      input: 'OpenapiPostV1TestHelpersIssuingTransactionsCreateForceCaptureInput',
    },
    v1TestHelpersTerminalHardwareOrderDevicesCreateDevicesForOrder: {
      input: 'OpenapiPostV1TestHelpersTerminalHardwareOrderDevicesCreateDevicesForOrderInput',
    },
    v1TestHelpersTerminalHardwareOrdersHardwareOrderDeliver: {
      input: 'OpenapiPostV1TestHelpersTerminalHardwareOrdersHardwareOrderDeliverInput',
    },
    v1TestHelpersTerminalHardwareOrdersHardwareOrderMarkReadyToShip: {
      input: 'OpenapiPostV1TestHelpersTerminalHardwareOrdersHardwareOrderMarkReadyToShipInput',
    },
    v1TestHelpersTerminalHardwareOrdersHardwareOrderMarkUndeliverable: {
      input: 'OpenapiPostV1TestHelpersTerminalHardwareOrdersHardwareOrderMarkUndeliverableInput',
    },
    v1TestHelpersTerminalHardwareOrdersHardwareOrderShip: {
      input: 'OpenapiPostV1TestHelpersTerminalHardwareOrdersHardwareOrderShipInput',
    },
    v1TestHelpersTestClocks: {
      input: 'OpenapiPostV1TestHelpersTestClocksInput',
    },
    v1TestHelpersTestClocksTestClock: {
      input: 'OpenapiPostV1TestHelpersTestClocksTestClockInput',
    },
    v1TestHelpersTestClocksTestClockAdvance: {
      input: 'OpenapiPostV1TestHelpersTestClocksTestClockAdvanceInput',
    },
    v1TokenBillingSettings: {
      input: 'OpenapiPostV1TokenBillingSettingsInput',
    },
    v1Tokens: {
      input: 'OpenapiPostV1TokensInput',
    },
    v1TopupAddFundsTicket: {
      input: 'OpenapiPostV1TopupAddFundsTicketInput',
    },
    v1Topups: {
      input: 'OpenapiPostV1TopupsInput',
    },
    v1TopupSource: {
      input: 'OpenapiPostV1TopupSourceInput',
    },
    v1Transfers: {
      input: 'OpenapiPostV1TransfersInput',
    },
    v1TreasuryDebitReversals: {
      input: 'OpenapiPostV1TreasuryDebitReversalsInput',
    },
    v1TreasuryFinancialAccountsFinancialAccount: {
      input: 'OpenapiPostV1TreasuryFinancialAccountsFinancialAccountInput',
    },
    v1TreasuryFinancialAccountsFinancialAccountClose: {
      input: 'OpenapiPostV1TreasuryFinancialAccountsFinancialAccountCloseInput',
    },
    v1TreasuryInboundTransfers: {
      input: 'OpenapiPostV1TreasuryInboundTransfersInput',
    },
    v1TreasuryOutboundPayments: {
      input: 'OpenapiPostV1TreasuryOutboundPaymentsInput',
    },
    v1TreasuryOutboundTransfers: {
      input: 'OpenapiPostV1TreasuryOutboundTransfersInput',
    },
    v1TreasuryRecipients: {
      input: 'OpenapiPostV1TreasuryRecipientsInput',
    },
    v1UpdateConnectInsightsDashboardConfigurationForUser: {
      input: 'OpenapiPostV1UpdateConnectInsightsDashboardConfigurationForUserInput',
    },
    v1UpdateMerchantCustomerMarketingPreferencesCapabilitySlug: {
      input: 'OpenapiPostV1UpdateMerchantCustomerMarketingPreferencesCapabilitySlugInput',
    },
    v1UserGetUserPhoneData: {
      input: 'OpenapiPostV1UserGetUserPhoneDataInput',
    },
    v1UserReversePhoneCode: {
      input: 'OpenapiPostV1UserReversePhoneCodeInput',
    },
    v1UserReversePhoneCodeConfirm: {
      input: 'OpenapiPostV1UserReversePhoneCodeConfirmInput',
    },
    v1UsPaperChecks: {
      input: 'OpenapiPostV1UsPaperChecksInput',
    },
    v1UsPaperChecksId: {
      input: 'OpenapiPostV1UsPaperChecksIdInput',
    },
    v1WaysToPayPaymentMethodSetupSessions: {
      input: 'OpenapiPostV1WaysToPayPaymentMethodSetupSessionsInput',
    },
    v1WebhookEndpoints: {
      input: 'OpenapiPostV1WebhookEndpointsInput',
    },
    v1WebhookEndpointsWebhookEndpoint: {
      input: 'OpenapiPostV1WebhookEndpointsWebhookEndpointInput',
    },
    v1WorkbenchIntegationInsightsFeedback: {
      input: 'OpenapiPostV1WorkbenchIntegationInsightsFeedbackInput',
    },
    v1WorkbenchIntegrationMigrations: {
      input: 'OpenapiPostV1WorkbenchIntegrationMigrationsInput',
    },
    v1WorkbenchIntegrationMigrationsIdExecuteStep: {
      input: 'OpenapiPostV1WorkbenchIntegrationMigrationsIdExecuteStepInput',
    },
    v1WorkbenchIntegrationMigrationsIdProgressStep: {
      input: 'OpenapiPostV1WorkbenchIntegrationMigrationsIdProgressStepInput',
    },
    v1WorkbenchMissionControlExecuteTrigger: {
      input: 'OpenapiPostV1WorkbenchMissionControlExecuteTriggerInput',
    },
    v1WorkbenchSendFeedback: {
      input: 'OpenapiPostV1WorkbenchSendFeedbackInput',
    },
    v1WorkbenchStartTestDataDeletion: {
      input: 'OpenapiPostV1WorkbenchStartTestDataDeletionInput',
    },
    v1Ytd2025Metrics: {
      input: 'OpenapiPostV1Ytd2025MetricsInput',
    }
  }
} as const;

export default topLevelFieldsInputTypes;
